/* eslint-disable max-len */
export const consignments = [
  {
    __typename: "Consignment",
    id: 14159,
    artistUserId: 1108,
    channel: {
      __typename: "ConsignmentChannel",
      id: 2,
      description: "Artfair",
      updatedAt: "2013-09-23T14:47:24.000Z",
    },
    channelId: 2,
    company: {
      __typename: "Company",
      id: 11,
      code: "JJ",
      crossInvoiceId: null,
      name: "White Cube Limited",
      vatno: "GB 12345",
    },
    companyId: 11,
    colAddress: "123 Oxford Road",
    colAddress2: "Flat B",
    colAddress3: "Floor 2",
    colCompany: "Julie Curtiss Studio",
    colContactId: 102943,
    colCounty: "Greater London",
    colCountryId: 1,
    colName: "Julie Curtiss",
    colPostcode: "SE11 1SE",
    colTown: "London",
    consigneeCompany: "White Cube Limited [Bermondsey]",
    consigneeEmail: "",
    consigneeFax: "",
    consigneeName: "Julie Curtiss",
    consigner: {
      __typename: "Contact",
      id: 102943,
      address: "Bahe Sokak 211",
      address2: " Apt. 482",
      address3: "address_3",
      affiliations: "None",
      biography:
        "aliquam adipiscing lacus. Ut nec urna et arcu imperdiet ullamcorper.",
      collection:
        "ligula. Aenean euismod mauris eu elit. Nulla facilisi. Sed neque.",
      collectionActive: null,
      company: "COMPANY_102943_SCRUBBED",
      contactCompany: {
        id: 11,
        code: "JJ",
        crossInvoiceId: null,
        consignmentCredit: null,
        consignmentSignOff: "For and on behalf of White Cube Limited",
        images: {
          header: "https://placehold.jp/700x200.png",
          footer: "https://placehold.jp/700x200.png",
        },
        loanSignOff: "White Cube Limited acting as agent for the Artist",
        name: "COMPANY_102943_SCRUBBED",
        vatno: "GB982 566 574",
        __typename: "Company",
      },
      confidential: 0,
      contactSecondary: false,
      countryId: 225,
      county: " Manisa",
      createdAt: "2017-04-28T14:37:54.000Z",
      details: "a, enim. Suspendisse aliquet, sem ut cursus luctus, ipsum leo",
      dob: "2020-01-01",
      email: "whitecube-191105@crvnprojects.com",
      eori: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: null,
      firstcontacttype: null,
      firstUserId: null,
      forename: "Wing_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 1,
      level: null,
      mailingname: "May Durham",
      middlename: null,
      name: "Wing_SCRUBBED Herman",
      notes:
        "egestas. Sed pharetra, felis eget varius ultrices, mauris ipsum porta",
      postcode: " 79732",
      prefered:
        "ante. Nunc mauris sapien, cursus in, hendrerit consectetuer, cursus et,",
      rating: 8,
      sagecode: "CURTISSJ",
      salesUserId: null,
      salesUser2Id: null,
      salutation: "Carissa_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Herman",
      title: null,
      town: " Manisa",
      typeId: 3,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T06:48:54.000Z",
      vat: null,
    },
    consignerId: 102943,
    consigneeTel: "020 7930 5373",
    contact: {
      __typename: "Contact",
      id: 4449,
      address: "49780 Kaitlyn Locks",
      address2: " Suite 367",
      address3: "address_3",
      affiliations: "None",
      biography:
        "magna. Cras convallis convallis dolor. Quisque tincidunt pede ac urna.",
      collection:
        "purus. Maecenas libero est, congue a, aliquet vel, vulputate eu,",
      collectionActive: null,
      company: "COMPANY_4449_SCRUBBED",
      confidential: 0,
      contactCompany: {
        id: 12,
        code: "JJ",
        crossInvoiceId: null,
        consignmentSignOff: "For and on behalf of White Cube Limited",
        loanSignOff: "White Cube Limited acting as agent for the Artist",
        name: "COMPANY_4449_SCRUBBED",
        vatno: "GB 12345",
        __typename: "Company",
      },
      contactSecondary: false,
      countryId: 223,
      county: " Alvertaside",
      country: {
        id: 223,
        continent: "United Kingdom",
        digraph: "UK",
        name: "United Kingdom",
        sagecode: 0,
        updatedAt: "2024-03-20T15:30:43.000Z",
        __typename: "Country",
      },
      createdAt: "2015-09-15T11:10:50.000Z",
      details:
        "elit sed consequat auctor, nunc nulla vulputate dui, nec tempus",
      dob: "2020-01-01",
      email: null,
      eori: "GB982566574000",
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: null,
      firstcontacttype: null,
      firstUserId: null,
      forename: "Abbot_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 724,
      level: null,
      mailingname: "Daquan Golden",
      middlename: null,
      name: "Abbot_SCRUBBED Nixon",
      notes:
        "sagittis augue, eu tempor erat neque non quam. Pellentesque habitant",
      postcode: " ED0 9GM",
      prefered: "Ut tincidunt vehicula risus. Nulla eget metus eu erat semper",
      rating: 1,
      sagecode: "WHITECUB",
      salesUserId: null,
      salesUser2Id: null,
      salutation: "Kyra_SCRUBBED",
      siteId: 6,
      storageCharge: 0,
      surname: "Nixon",
      title: null,
      town: " Alvertaside",
      typeId: 10,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-06-21T10:35:41.000Z",
      vat: "GB 982566574",
    },
    contactId: 4449,
    consignmentWorks: [
      {
        id: 100538,
        artistNames: "Nathaniel Mary Quinn\n",
        conPrice: null,
        consignment: {
          id: 13885,
          artistUserId: null,
          channel: null,
          channelId: null,
          company: {
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          colAddress: "144 - 152 Bermondsey Street",
          colAddress2: null,
          colAddress3: "",
          colCompany: "White Cube Limited [Bermondsey]",
          colContactId: 4449,
          colCounty: "",
          colCountryId: 223,
          colName: "null null",
          colPostcode: "SE1 3TQ",
          colTown: "London",
          consigneeCompany: "KANAL - Centre Pompidou",
          consigneeEmail: "",
          consigneeFax: "",
          consigneeName: null,
          consigner: {
            id: 4449,
            address: "144 - 152 Bermondsey Street",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: "White Cube Limited [Bermondsey]",
            confidential: 0,
            contactCompany: {
              id: 11,
              code: "JJ",
              crossInvoiceId: null,
              name: "White Cube Limited",
              vatno: "GB982 566 574",
              __typename: "Company",
            },
            contactNumbers: [
              {
                id: 25993,
                donotcall: 0,
                identifier: null,
                number: "020 7930 5373",
                prefere: 0,
                typeId: 4,
                __typename: "ContactNumber",
              },
              {
                id: 25994,
                donotcall: 0,
                identifier: null,
                number: "020 7749 7460 / 7621",
                prefere: 0,
                typeId: 5,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
              __typename: "Country",
            },
            county: "",
            createdAt: "2015-09-15T11:10:50.000Z",
            details:
              "EORI - GB982566574000\r\n\r\nEU EORI - FRGB1214861310001\r\n\r\nCDS GBTEA98256657400020220929113111 - TA/0909/698/25\r\n\r\nCDS GBTEA98256657400020191024130941",
            dob: null,
            email: null,
            eori: "GB982566574000",
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 670,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: "EORI - GB982566574000\r\n\r\n4.9 x 9.3 x 17.5m (h x w x d)",
            postcode: "SE1 3TQ",
            prefered: null,
            rating: 1,
            sagecode: "WHITECUB",
            salesUserId: null,
            salesUser2Id: null,
            salutation: "n/a",
            siteId: 6,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "London",
            typeId: 10,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2022-11-10T15:41:26.000Z",
            vat: "GB 982566574",
            __typename: "Contact",
          },
          consignerId: 4449,
          consigneeTel: "",
          contact: {
            id: 132048,
            address: "Sq. Sainctelette 21",
            address2: null,
            address3: null,
            affiliations: null,
            biography:
              "KANAL–Centre Pompidou is a new, interdisciplinary museum of modern and contemporary art in Brussels established by the Brussels Capital Region, and developed and managed by the KANAL Foundation in partnership with Centre Pompidou. Slated to open in 2025, it is situated in a converted Citroën factory at the Yser square. In the run up to the inauguration, since 2018, KANAL has been building an ambitious off-site programme and a collection of contemporary art. With its 40 000 m2 space KANAL promises to be one of the largest museums of modern and contemporary art in Europe.",
            collection: null,
            collectionActive: -1,
            company: "KANAL - Centre Pompidou",
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                id: 232395,
                donotcall: 0,
                identifier: null,
                number: "https://kanal.brussels/en",
                prefere: 0,
                typeId: 9,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: true,
            countryId: 20,
            country: {
              id: 20,
              continent: "Europe",
              digraph: "BE",
              name: "Belgium",
              sagecode: 1,
              updatedAt: "2024-03-20T15:25:02.000Z",
              __typename: "Country",
            },
            county: null,
            createdAt: "2023-03-29T11:58:06.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 0,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: null,
            postcode: "1000",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: null,
            siteId: null,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "Brussels",
            typeId: 20,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2023-03-29T11:58:35.000Z",
            vat: null,
            __typename: "Contact",
          },
          contactId: 132048,
          credit: null,
          currency: {
            id: 3,
            code: "EUR",
            description: "Euro",
            name: null,
            __typename: "Currency",
          },
          currencyId: 3,
          date: "2024-10-17",
          due: "2024-11-07",
          exchange: null,
          exhibition: {
            id: 4705,
            artFair: 0,
            contactId: 4449,
            curator: null,
            endDay: 20,
            endMonth: 8,
            endYear: 2023,
            fullDate: "7/6/2023 - 20/8/2023",
            notes:
              "PV: Tue 6 June 2023\r\nExhibition opens: 7 June 2023\r\nEnd date: 20 August 2023",
            sageCode: "EXH23-BERM-KIEFER",
            startDay: 7,
            startMonth: 6,
            startYear: 2023,
            title:
              "Anselm Kiefer - Finnegans Wake | White Cube Bermondsey, 7 June - 20 August 2023",
            type: "Solo",
            updatedAt: "2023-05-12T17:30:38.000Z",
            __typename: "Exhibition",
          },
          exhibitionId: 4705,
          guarantee: 0,
          notes: "new loan",
          noOfConsignmentWorks: 4,
          photoMaterial: null,
          registrarId: null,
          retAddress: "144 - 152 Bermondsey Street",
          retAddress2: null,
          retAddress3: "",
          retCompany: "White Cube Limited [Bermondsey]",
          retContactId: 4449,
          retCountryId: 223,
          retCounty: "",
          retName: "null null",
          retPostcode: "SE1 3TQ",
          retTown: "London",
          salesUserId: null,
          salesUser: null,
          shipmentNotes: null,
          status: {
            id: 1,
            description: "Pending",
            updatedAt: "2013-11-20T14:53:18.000Z",
            __typename: "ConsignmentStatus",
          },
          statusId: 1,
          terms:
            "1 \tDefinitions\n“Agent” means White Cube Limited\n“Agreement” means this Loan Agreement including the Loan Schedule\n“Artist” means the creator of the Work(s) as identified above\n“Borrower” means institution, gallery or individual identified in the Schedule\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\n“Exhibition” means the exhibition specified in the Schedule\n“Exhibition Dates” means the exhibition dates specified in the Schedule\n“Exhibition Venue” means the exhibition venue specified in the Schedule\n“Lender” means the person identified as such in the Schedule\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \n“Work(s)” means the work(s) of art identified above\n\n2 \tLoan\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\n3 \tRights and Restrictions\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\n3.3.1 \tmake any alteration to the Work(s);\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\n4 \tCredits\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\n5 \tCosts\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\n6 \tTransport\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\n7 \tCondition Report \nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\n8 \tHandling and Display\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\n9 \tInsurance \n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\n10 \tGeneral\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \n10.1.3 \tall press received in connection with the Exhibition. \n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales\n\nUpdate added",
          type: {
            id: 2,
            description: "Loan",
            updatedAt: null,
            __typename: "ConsignmentType",
          },
          typeId: 2,
          updatedAt: "2024-10-01T17:58:30.000Z",
          __typename: "Consignment",
        },
        consignmentId: 13885,
        discount: 0,
        discountRate: 0,
        fabCost: 0,
        fabRate: 0,
        grossProfit: 10000,
        instanceId: 84859,
        instance: {
          id: 84859,
          artistRef: "NQUIN 2023.0016",
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          createdAt: "2023-08-17T13:04:06.000Z",
          edition: {
            id: 51660,
            ap: 0,
            artwork: {
              id: 88271,
              artFair: null,
              authenticity: null,
              categoryId: 4,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2023-08-17T13:03:10.000Z",
              description: null,
              dimensions: "50 x 38 in. | (127 x 96.5 cm) ",
              goodsCode: "970110",
              installation: null,
              installationLink: null,
              images: [
                {
                  artworkId: 89626,
                  archiveId: 216667,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  order: null,
                  photoMaterialId: 54613,
                  updatedAt: "2024-02-23T12:01:18.000Z",
                  uploadedAt: "2024-02-23T10:28:07.000Z",
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium:
                "Black charcoal, gouache and soft pastel on Coventry Vellum Paper",
              packing: null,
              photographed: -1,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "test",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2023-08-17T13:04:03.000Z",
              title: "Fighting Kings",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2023",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ76454",
          notes: null,
          parentOnline: 0,
          ref: 76454,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 2,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-10-01T17:54:37.000Z",
          __typename: "Instance",
        },
        price: 10000,
        ref: "76454",
        share: 0,
        updatedAt: "2024-10-01T17:55:03.000Z",
        __typename: "ConsignmentWork",
      },
      {
        id: 100539,
        artistNames: "Robert Adams\n",
        conPrice: null,
        consignment: {
          id: 13885,
          artistUserId: null,
          channel: null,
          channelId: null,
          company: {
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          colAddress: "144 - 152 Bermondsey Street",
          colAddress2: null,
          colAddress3: "",
          colCompany: "White Cube Limited [Bermondsey]",
          colContactId: 4449,
          colCounty: "",
          colCountryId: 223,
          colName: "null null",
          colPostcode: "SE1 3TQ",
          colTown: "London",
          consigneeCompany: "KANAL - Centre Pompidou",
          consigneeEmail: "",
          consigneeFax: "",
          consigneeName: null,
          consigner: {
            id: 4449,
            address: "144 - 152 Bermondsey Street",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: "White Cube Limited [Bermondsey]",
            confidential: 0,
            contactCompany: {
              id: 11,
              code: "JJ",
              crossInvoiceId: null,
              name: "White Cube Limited",
              vatno: "GB982 566 574",
              __typename: "Company",
            },
            contactNumbers: [
              {
                id: 25993,
                donotcall: 0,
                identifier: null,
                number: "020 7930 5373",
                prefere: 0,
                typeId: 4,
                __typename: "ContactNumber",
              },
              {
                id: 25994,
                donotcall: 0,
                identifier: null,
                number: "020 7749 7460 / 7621",
                prefere: 0,
                typeId: 5,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
              __typename: "Country",
            },
            county: "",
            createdAt: "2015-09-15T11:10:50.000Z",
            details:
              "EORI - GB982566574000\r\n\r\nEU EORI - FRGB1214861310001\r\n\r\nCDS GBTEA98256657400020220929113111 - TA/0909/698/25\r\n\r\nCDS GBTEA98256657400020191024130941",
            dob: null,
            email: null,
            eori: "GB982566574000",
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 670,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: "EORI - GB982566574000\r\n\r\n4.9 x 9.3 x 17.5m (h x w x d)",
            postcode: "SE1 3TQ",
            prefered: null,
            rating: 1,
            sagecode: "WHITECUB",
            salesUserId: null,
            salesUser2Id: null,
            salutation: "n/a",
            siteId: 6,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "London",
            typeId: 10,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2022-11-10T15:41:26.000Z",
            vat: "GB 982566574",
            __typename: "Contact",
          },
          consignerId: 4449,
          consigneeTel: "",
          contact: {
            id: 132048,
            address: "Sq. Sainctelette 21",
            address2: null,
            address3: null,
            affiliations: null,
            biography:
              "KANAL–Centre Pompidou is a new, interdisciplinary museum of modern and contemporary art in Brussels established by the Brussels Capital Region, and developed and managed by the KANAL Foundation in partnership with Centre Pompidou. Slated to open in 2025, it is situated in a converted Citroën factory at the Yser square. In the run up to the inauguration, since 2018, KANAL has been building an ambitious off-site programme and a collection of contemporary art. With its 40 000 m2 space KANAL promises to be one of the largest museums of modern and contemporary art in Europe.",
            collection: null,
            collectionActive: -1,
            company: "KANAL - Centre Pompidou",
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                id: 232395,
                donotcall: 0,
                identifier: null,
                number: "https://kanal.brussels/en",
                prefere: 0,
                typeId: 9,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: true,
            countryId: 20,
            country: {
              id: 20,
              continent: "Europe",
              digraph: "BE",
              name: "Belgium",
              sagecode: 1,
              updatedAt: "2024-03-20T15:25:02.000Z",
              __typename: "Country",
            },
            county: null,
            createdAt: "2023-03-29T11:58:06.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 0,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: null,
            postcode: "1000",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: null,
            siteId: null,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "Brussels",
            typeId: 20,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2023-03-29T11:58:35.000Z",
            vat: null,
            __typename: "Contact",
          },
          contactId: 132048,
          credit: null,
          currency: {
            id: 3,
            code: "EUR",
            description: "Euro",
            name: null,
            __typename: "Currency",
          },
          currencyId: 3,
          date: "2024-10-17",
          due: "2024-11-07",
          exchange: null,
          exhibition: {
            id: 4705,
            artFair: 0,
            contactId: 4449,
            curator: null,
            endDay: 20,
            endMonth: 8,
            endYear: 2023,
            fullDate: "7/6/2023 - 20/8/2023",
            notes:
              "PV: Tue 6 June 2023\r\nExhibition opens: 7 June 2023\r\nEnd date: 20 August 2023",
            sageCode: "EXH23-BERM-KIEFER",
            startDay: 7,
            startMonth: 6,
            startYear: 2023,
            title:
              "Anselm Kiefer - Finnegans Wake | White Cube Bermondsey, 7 June - 20 August 2023",
            type: "Solo",
            updatedAt: "2023-05-12T17:30:38.000Z",
            __typename: "Exhibition",
          },
          exhibitionId: 4705,
          guarantee: 0,
          notes: "new loan",
          noOfConsignmentWorks: 4,
          photoMaterial: null,
          registrarId: null,
          retAddress: "144 - 152 Bermondsey Street",
          retAddress2: null,
          retAddress3: "",
          retCompany: "White Cube Limited [Bermondsey]",
          retContactId: 4449,
          retCountryId: 223,
          retCounty: "",
          retName: "null null",
          retPostcode: "SE1 3TQ",
          retTown: "London",
          salesUserId: null,
          salesUser: null,
          shipmentNotes: null,
          status: {
            id: 1,
            description: "Pending",
            updatedAt: "2013-11-20T14:53:18.000Z",
            __typename: "ConsignmentStatus",
          },
          statusId: 1,
          terms:
            "1 \tDefinitions\n“Agent” means White Cube Limited\n“Agreement” means this Loan Agreement including the Loan Schedule\n“Artist” means the creator of the Work(s) as identified above\n“Borrower” means institution, gallery or individual identified in the Schedule\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\n“Exhibition” means the exhibition specified in the Schedule\n“Exhibition Dates” means the exhibition dates specified in the Schedule\n“Exhibition Venue” means the exhibition venue specified in the Schedule\n“Lender” means the person identified as such in the Schedule\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \n“Work(s)” means the work(s) of art identified above\n\n2 \tLoan\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\n3 \tRights and Restrictions\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\n3.3.1 \tmake any alteration to the Work(s);\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\n4 \tCredits\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\n5 \tCosts\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\n6 \tTransport\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\n7 \tCondition Report \nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\n8 \tHandling and Display\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\n9 \tInsurance \n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\n10 \tGeneral\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \n10.1.3 \tall press received in connection with the Exhibition. \n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales\n\nUpdate added",
          type: {
            id: 2,
            description: "Loan",
            updatedAt: null,
            __typename: "ConsignmentType",
          },
          typeId: 2,
          updatedAt: "2024-10-01T17:58:30.000Z",
          __typename: "Consignment",
        },
        consignmentId: 13885,
        discount: 0,
        discountRate: 0,
        fabCost: 0,
        fabRate: 0,
        grossProfit: 2000,
        instanceId: 85069,
        instance: {
          id: 85069,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          createdAt: "2023-12-11T14:52:57.000Z",
          edition: {
            id: 51780,
            ap: 0,
            artwork: {
              id: 88452,
              artFair: null,
              authenticity: null,
              categoryId: 4,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2023-12-06T17:48:32.000Z",
              description: null,
              dimensions: "1 x 3 x 5 in. | (2.54 x 7.62 x 12.70 cm)",
              goodsCode: null,
              installation: null,
              installationLink: null,
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },

              maintenance: null,
              medium: "Wooden glass",
              packing: null,
              photographed: null,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "test",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2024-06-18T14:24:07.000Z",
              title: "[Title to be confirmed]",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2003",
            number: 5,
            __typename: "Edition",
          },
          editionNumber: 5,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: -1,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ76522",
          notes: null,
          parentOnline: 0,
          ref: 76522,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 2,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-10-01T17:54:37.000Z",
          __typename: "Instance",
        },
        price: 2000,
        ref: "76522",
        share: 0,
        updatedAt: "2024-10-01T18:31:18.000Z",
        __typename: "ConsignmentWork",
      },
      {
        id: 100540,
        artistNames: "Berger & Simon McBurney\n",
        conPrice: null,
        consignment: {
          id: 13885,
          artistUserId: null,
          channel: null,
          channelId: null,
          company: {
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          colAddress: "144 - 152 Bermondsey Street",
          colAddress2: null,
          colAddress3: "",
          colCompany: "White Cube Limited [Bermondsey]",
          colContactId: 4449,
          colCounty: "",
          colCountryId: 223,
          colName: "null null",
          colPostcode: "SE1 3TQ",
          colTown: "London",
          consigneeCompany: "KANAL - Centre Pompidou",
          consigneeEmail: "",
          consigneeFax: "",
          consigneeName: null,
          consigner: {
            id: 4449,
            address: "144 - 152 Bermondsey Street",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: "White Cube Limited [Bermondsey]",
            confidential: 0,
            contactCompany: {
              id: 11,
              code: "JJ",
              crossInvoiceId: null,
              name: "White Cube Limited",
              vatno: "GB982 566 574",
              __typename: "Company",
            },
            contactNumbers: [
              {
                id: 25993,
                donotcall: 0,
                identifier: null,
                number: "020 7930 5373",
                prefere: 0,
                typeId: 4,
                __typename: "ContactNumber",
              },
              {
                id: 25994,
                donotcall: 0,
                identifier: null,
                number: "020 7749 7460 / 7621",
                prefere: 0,
                typeId: 5,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
              __typename: "Country",
            },
            county: "",
            createdAt: "2015-09-15T11:10:50.000Z",
            details:
              "EORI - GB982566574000\r\n\r\nEU EORI - FRGB1214861310001\r\n\r\nCDS GBTEA98256657400020220929113111 - TA/0909/698/25\r\n\r\nCDS GBTEA98256657400020191024130941",
            dob: null,
            email: null,
            eori: "GB982566574000",
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 670,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: "EORI - GB982566574000\r\n\r\n4.9 x 9.3 x 17.5m (h x w x d)",
            postcode: "SE1 3TQ",
            prefered: null,
            rating: 1,
            sagecode: "WHITECUB",
            salesUserId: null,
            salesUser2Id: null,
            salutation: "n/a",
            siteId: 6,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "London",
            typeId: 10,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2022-11-10T15:41:26.000Z",
            vat: "GB 982566574",
            __typename: "Contact",
          },
          consignerId: 4449,
          consigneeTel: "",
          contact: {
            id: 132048,
            address: "Sq. Sainctelette 21",
            address2: null,
            address3: null,
            affiliations: null,
            biography:
              "KANAL–Centre Pompidou is a new, interdisciplinary museum of modern and contemporary art in Brussels established by the Brussels Capital Region, and developed and managed by the KANAL Foundation in partnership with Centre Pompidou. Slated to open in 2025, it is situated in a converted Citroën factory at the Yser square. In the run up to the inauguration, since 2018, KANAL has been building an ambitious off-site programme and a collection of contemporary art. With its 40 000 m2 space KANAL promises to be one of the largest museums of modern and contemporary art in Europe.",
            collection: null,
            collectionActive: -1,
            company: "KANAL - Centre Pompidou",
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                id: 232395,
                donotcall: 0,
                identifier: null,
                number: "https://kanal.brussels/en",
                prefere: 0,
                typeId: 9,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: true,
            countryId: 20,
            country: {
              id: 20,
              continent: "Europe",
              digraph: "BE",
              name: "Belgium",
              sagecode: 1,
              updatedAt: "2024-03-20T15:25:02.000Z",
              __typename: "Country",
            },
            county: null,
            createdAt: "2023-03-29T11:58:06.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 0,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: null,
            postcode: "1000",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: null,
            siteId: null,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "Brussels",
            typeId: 20,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2023-03-29T11:58:35.000Z",
            vat: null,
            __typename: "Contact",
          },
          contactId: 132048,
          credit: null,
          currency: {
            id: 3,
            code: "EUR",
            description: "Euro",
            name: null,
            __typename: "Currency",
          },
          currencyId: 3,
          date: "2024-10-17",
          due: "2024-11-07",
          exchange: null,
          exhibition: {
            id: 4705,
            artFair: 0,
            contactId: 4449,
            curator: null,
            endDay: 20,
            endMonth: 8,
            endYear: 2023,
            fullDate: "7/6/2023 - 20/8/2023",
            notes:
              "PV: Tue 6 June 2023\r\nExhibition opens: 7 June 2023\r\nEnd date: 20 August 2023",
            sageCode: "EXH23-BERM-KIEFER",
            startDay: 7,
            startMonth: 6,
            startYear: 2023,
            title:
              "Anselm Kiefer - Finnegans Wake | White Cube Bermondsey, 7 June - 20 August 2023",
            type: "Solo",
            updatedAt: "2023-05-12T17:30:38.000Z",
            __typename: "Exhibition",
          },
          exhibitionId: 4705,
          guarantee: 0,
          notes: "new loan",
          noOfConsignmentWorks: 4,
          photoMaterial: null,
          registrarId: null,
          retAddress: "144 - 152 Bermondsey Street",
          retAddress2: null,
          retAddress3: "",
          retCompany: "White Cube Limited [Bermondsey]",
          retContactId: 4449,
          retCountryId: 223,
          retCounty: "",
          retName: "null null",
          retPostcode: "SE1 3TQ",
          retTown: "London",
          salesUserId: null,
          salesUser: null,
          shipmentNotes: null,
          status: {
            id: 1,
            description: "Pending",
            updatedAt: "2013-11-20T14:53:18.000Z",
            __typename: "ConsignmentStatus",
          },
          statusId: 1,
          terms:
            "1 \tDefinitions\n“Agent” means White Cube Limited\n“Agreement” means this Loan Agreement including the Loan Schedule\n“Artist” means the creator of the Work(s) as identified above\n“Borrower” means institution, gallery or individual identified in the Schedule\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\n“Exhibition” means the exhibition specified in the Schedule\n“Exhibition Dates” means the exhibition dates specified in the Schedule\n“Exhibition Venue” means the exhibition venue specified in the Schedule\n“Lender” means the person identified as such in the Schedule\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \n“Work(s)” means the work(s) of art identified above\n\n2 \tLoan\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\n3 \tRights and Restrictions\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\n3.3.1 \tmake any alteration to the Work(s);\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\n4 \tCredits\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\n5 \tCosts\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\n6 \tTransport\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\n7 \tCondition Report \nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\n8 \tHandling and Display\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\n9 \tInsurance \n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\n10 \tGeneral\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \n10.1.3 \tall press received in connection with the Exhibition. \n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales\n\nUpdate added",
          type: {
            id: 2,
            description: "Loan",
            updatedAt: null,
            __typename: "ConsignmentType",
          },
          typeId: 2,
          updatedAt: "2024-10-01T17:58:30.000Z",
          __typename: "Consignment",
        },
        consignmentId: 13885,
        discount: 0,
        discountRate: 0,
        fabCost: 0,
        fabRate: 0,
        grossProfit: 3000,
        instanceId: 85104,
        instance: {
          id: 85104,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          createdAt: "2024-09-26T12:53:23.000Z",
          edition: {
            id: 51811,
            ap: 0,
            artwork: {
              id: 188478,
              artFair: null,
              authenticity: "test",
              categoryId: 5,
              classId: 1,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-09-23T10:22:50.000Z",
              description:
                "13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              dimensions:
                "17.72 x 4.72 x 17.72 in. | (45 x 12 x 45 cm)\n13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              goodsCode: "9702",
              installation: null,
              installationLink: null,
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "Glass",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis:
                "For her new series of ceramic wall-based reliefs, Humeau took inspiration from Polish artist Adam Kossowski’s large mosaic panel for the Peckham Civic Center, called ‘The History of the Old Kent Road’ (1965). As the former civic centre and its Grade-II listed mural are scheduled for demolition, Humeau sought to explore the implications of a human community dismantled.\n",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2024-09-27T13:53:21.000Z",
              title: "Title changed",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2021",
            number: 3,
            __typename: "Edition",
          },
          editionNumber: 2,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ76564",
          notes: null,
          parentOnline: 0,
          ref: 76564,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 2,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-10-01T18:31:04.000Z",
          __typename: "Instance",
        },
        price: 3000,
        ref: "76564",
        share: 0,
        updatedAt: "2024-10-01T18:31:22.000Z",
        __typename: "ConsignmentWork",
      },
      {
        id: 100545,
        artistNames: "Anselm Kiefer\n",
        conPrice: null,
        consignment: {
          id: 13885,
          artistUserId: null,
          channel: null,
          channelId: null,
          company: {
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          colAddress: "144 - 152 Bermondsey Street",
          colAddress2: null,
          colAddress3: "",
          colCompany: "White Cube Limited [Bermondsey]",
          colContactId: 4449,
          colCounty: "",
          colCountryId: 223,
          colName: "null null",
          colPostcode: "SE1 3TQ",
          colTown: "London",
          consigneeCompany: "KANAL - Centre Pompidou",
          consigneeEmail: "",
          consigneeFax: "",
          consigneeName: null,
          consigner: {
            id: 4449,
            address: "144 - 152 Bermondsey Street",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: "White Cube Limited [Bermondsey]",
            confidential: 0,
            contactCompany: {
              id: 11,
              code: "JJ",
              crossInvoiceId: null,
              name: "White Cube Limited",
              vatno: "GB982 566 574",
              __typename: "Company",
            },
            contactNumbers: [
              {
                id: 25993,
                donotcall: 0,
                identifier: null,
                number: "020 7930 5373",
                prefere: 0,
                typeId: 4,
                __typename: "ContactNumber",
              },
              {
                id: 25994,
                donotcall: 0,
                identifier: null,
                number: "020 7749 7460 / 7621",
                prefere: 0,
                typeId: 5,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
              __typename: "Country",
            },
            county: "",
            createdAt: "2015-09-15T11:10:50.000Z",
            details:
              "EORI - GB982566574000\r\n\r\nEU EORI - FRGB1214861310001\r\n\r\nCDS GBTEA98256657400020220929113111 - TA/0909/698/25\r\n\r\nCDS GBTEA98256657400020191024130941",
            dob: null,
            email: null,
            eori: "GB982566574000",
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 670,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: "EORI - GB982566574000\r\n\r\n4.9 x 9.3 x 17.5m (h x w x d)",
            postcode: "SE1 3TQ",
            prefered: null,
            rating: 1,
            sagecode: "WHITECUB",
            salesUserId: null,
            salesUser2Id: null,
            salutation: "n/a",
            siteId: 6,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "London",
            typeId: 10,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2022-11-10T15:41:26.000Z",
            vat: "GB 982566574",
            __typename: "Contact",
          },
          consignerId: 4449,
          consigneeTel: "",
          contact: {
            id: 132048,
            address: "Sq. Sainctelette 21",
            address2: null,
            address3: null,
            affiliations: null,
            biography:
              "KANAL–Centre Pompidou is a new, interdisciplinary museum of modern and contemporary art in Brussels established by the Brussels Capital Region, and developed and managed by the KANAL Foundation in partnership with Centre Pompidou. Slated to open in 2025, it is situated in a converted Citroën factory at the Yser square. In the run up to the inauguration, since 2018, KANAL has been building an ambitious off-site programme and a collection of contemporary art. With its 40 000 m2 space KANAL promises to be one of the largest museums of modern and contemporary art in Europe.",
            collection: null,
            collectionActive: -1,
            company: "KANAL - Centre Pompidou",
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                id: 232395,
                donotcall: 0,
                identifier: null,
                number: "https://kanal.brussels/en",
                prefere: 0,
                typeId: 9,
                __typename: "ContactNumber",
              },
            ],
            contactSecondary: true,
            countryId: 20,
            country: {
              id: 20,
              continent: "Europe",
              digraph: "BE",
              name: "Belgium",
              sagecode: 1,
              updatedAt: "2024-03-20T15:25:02.000Z",
              __typename: "Country",
            },
            county: null,
            createdAt: "2023-03-29T11:58:06.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: null,
            greeting: null,
            img: null,
            invoicesLength: 0,
            level: null,
            mailingname: "",
            middlename: null,
            name: "",
            notes: null,
            postcode: "1000",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: null,
            siteId: null,
            storageCharge: 0,
            surname: null,
            title: null,
            town: "Brussels",
            typeId: 20,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2023-03-29T11:58:35.000Z",
            vat: null,
            __typename: "Contact",
          },
          contactId: 132048,
          credit: null,
          currency: {
            id: 3,
            code: "EUR",
            description: "Euro",
            name: null,
            __typename: "Currency",
          },
          currencyId: 3,
          date: "2024-10-17",
          due: "2024-11-07",
          exchange: null,
          exhibition: {
            id: 4705,
            artFair: 0,
            contactId: 4449,
            curator: null,
            endDay: 20,
            endMonth: 8,
            endYear: 2023,
            fullDate: "7/6/2023 - 20/8/2023",
            notes:
              "PV: Tue 6 June 2023\r\nExhibition opens: 7 June 2023\r\nEnd date: 20 August 2023",
            sageCode: "EXH23-BERM-KIEFER",
            startDay: 7,
            startMonth: 6,
            startYear: 2023,
            title:
              "Anselm Kiefer - Finnegans Wake | White Cube Bermondsey, 7 June - 20 August 2023",
            type: "Solo",
            updatedAt: "2023-05-12T17:30:38.000Z",
            __typename: "Exhibition",
          },
          exhibitionId: 4705,
          guarantee: 0,
          notes: "new loan",
          noOfConsignmentWorks: 4,
          photoMaterial: null,
          registrarId: null,
          retAddress: "144 - 152 Bermondsey Street",
          retAddress2: null,
          retAddress3: "",
          retCompany: "White Cube Limited [Bermondsey]",
          retContactId: 4449,
          retCountryId: 223,
          retCounty: "",
          retName: "null null",
          retPostcode: "SE1 3TQ",
          retTown: "London",
          salesUserId: null,
          salesUser: null,
          shipmentNotes: null,
          status: {
            id: 1,
            description: "Pending",
            updatedAt: "2013-11-20T14:53:18.000Z",
            __typename: "ConsignmentStatus",
          },
          statusId: 1,
          terms:
            "1 \tDefinitions\n“Agent” means White Cube Limited\n“Agreement” means this Loan Agreement including the Loan Schedule\n“Artist” means the creator of the Work(s) as identified above\n“Borrower” means institution, gallery or individual identified in the Schedule\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\n“Exhibition” means the exhibition specified in the Schedule\n“Exhibition Dates” means the exhibition dates specified in the Schedule\n“Exhibition Venue” means the exhibition venue specified in the Schedule\n“Lender” means the person identified as such in the Schedule\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \n“Work(s)” means the work(s) of art identified above\n\n2 \tLoan\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\n3 \tRights and Restrictions\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\n3.3.1 \tmake any alteration to the Work(s);\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\n4 \tCredits\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\n5 \tCosts\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\n6 \tTransport\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\n7 \tCondition Report \nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\n8 \tHandling and Display\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\n9 \tInsurance \n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\n10 \tGeneral\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \n10.1.3 \tall press received in connection with the Exhibition. \n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales\n\nUpdate added",
          type: {
            id: 2,
            description: "Loan",
            updatedAt: null,
            __typename: "ConsignmentType",
          },
          typeId: 2,
          updatedAt: "2024-10-01T17:58:30.000Z",
          __typename: "Consignment",
        },
        consignmentId: 13885,
        discount: 0,
        discountRate: 0,
        fabCost: 0,
        fabRate: 0,
        grossProfit: 1500000,
        instanceId: 72506,
        instance: {
          id: 72506,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          createdAt: "2018-09-12T09:54:43.000Z",
          edition: {
            id: 42016,
            ap: 0,
            artwork: {
              id: 78968,
              artFair: null,
              authenticity: null,
              categoryId: 6,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2018-09-12T09:54:23.000Z",
              description:
                "Work is presented on a plinth, 50 x 50 x 50 cm. Artwork dimensions including plinth: 210 x 50 x 50 cm\r\n06/06/2019 JM",
              dimensions: "63 x 19 11/16 x 19 11/16 in. | (160 x 50 x 50 cm) ",
              goodsCode: "9703",
              installation: null,
              installationLink:
                "https://whitecube0.sharepoint.com/sites/Artworks/Anselm Kiefer/Flower power JJ64928",

              maintenance: null,
              medium: "Glass, metal, dried roses and electrolysis",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis:
                "The rhetoric of war is part of Kiefer’s long standing interest in prodding the collective German amnesia to assume the responsibility of a legacy that must not be silenced. In “Flower Power”, Kiefer presents us with a classic symbol of the anti-war movement, a flower in the barrel of a gun. This rusted and defunct rifle (presumably from WWII) is displayed as if in a grave or tomb. Surrounded by a sprinkling of dried flowers and leaning against the glass wall, the gun in this vitrine is presented as a relic from a bygone industrial age; a potent symbol of Kiefer’s own memory of growing up in Germany in the aftermath of WWII. \r\n\r\nJW 03.10.2018",
              reference: null,
              series: "test",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2021-05-14T15:40:19.000Z",
              title: "Flower power",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2016",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: 0,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ64928",
          notes: null,
          parentOnline: 0,
          ref: 64928,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 2,
          salesStrategy:
            "AK price: EUR 180,000 (JW 27.09.2018)\r\n\r\nSold on a 50/50 consignment as consigned for the 9x9x9 exhibition. JW 24.10.2018",
          statusHistory: null,
          updatedAt: "2024-10-02T16:53:36.000Z",
          __typename: "Instance",
        },
        price: 1500000,
        ref: "64928",
        share: 0,
        updatedAt: "2024-10-02T16:53:50.000Z",
        __typename: "ConsignmentWork",
      },
    ],
    credit: null,
    currency: {
      __typename: "Currency",
      id: 2,
      code: "USD",
      description: "US Dollars",
      name: null,
    },
    currencyId: 2,
    date: "2024-02-23",
    due: "2025-02-23",
    exchange: 1.27,
    exhibition: null,
    exhibitionId: null,
    guarantee: 0,
    notes: null,
    noOfConsignmentWorks: 2,
    photoMaterial: null,
    registrarId: null,
    registrar: null,
    retAddress: "",
    retAddress2: "",
    retAddress3: "",
    retCompany: "Julie Curtiss Studio",
    retContactId: 102943,
    retCountryId: 3,
    retCounty: "",
    retName: "Julie Curtiss",
    retPostcode: "",
    retTown: "",
    salesUserId: 1111,
    salesUser: null,
    shipmentNotes: null,
    status: {
      __typename: "ConsignmentStatus",
      id: 1,
      description: "Pending",
      updatedAt: "2013-11-20T14:53:18.000Z",
    },
    statusId: 1,
    terms:
      "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”). \r\n\r\n1.    Definitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1    “Agreement” shall mean this consignment agreement, including the Schedule;\r\n\r\n1.2    “Artist” shall mean Julie Curtiss;\r\n\r\n1.3    “Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4    “Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5    “White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities;\r\n\r\n1.6    “White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.    Consignment\r\n\r\n2.1    The Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.  \r\n\r\n2.2    The Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3    Should White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.    Transportation and Insurance\r\n\r\n3.1    White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period.\r\n\r\n3.2    White Cube shall:\r\n\r\n3.2.1    ensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2    use reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable);\r\n\r\n3.2.3    ensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4    insure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies).\r\n\r\n4.    Handling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1    exercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2    take, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3    ensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4    inform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.    Sale of Works\r\n\r\n5.1    Each Retail Prices is in US Dollars and does not include VAT or any other applicable taxes which may be added to the sale price of a Work.\r\n\r\n5.2    For each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers and a discount of up to 20% if the buyer is an institution or private foundation.  White Cube and the Artist shall share such discounts equally. Any higher discount must be agreed with the Artist, otherwise any discount in excess of those specified in this clause shall be absorbed by White Cube.\r\n\r\n\r\n5.3    In the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4    White Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5    At the end of the Consignment Period, White Cube shall return any unsold Works to the Artist.\r\n\r\n6.    Sale Proceeds and Commission\r\n\r\n6.1   Subject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes).\r\n\r\n6.2   Should the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3      In the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n8.    Warranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule.\r\n\r\n9.    Copyright\r\n\r\n9.1    The copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n9.2    The Artist hereby irrevocably authorises White Cube:\r\n\r\n9.2.1    to create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive;\r\n\r\n9.2.2    to authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons;\r\n\r\n9.2.3    in respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n9.2.4    in the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes.\r\n\r\n10.    Photographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n11.    Credits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of the artist and White Cube”.\r\n\r\n12.    Certificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n13.    General\r\n\r\n13.1    No variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n13.2    If any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected.\r\n\r\n13.3    This Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n13.4    This Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.\r\n\r\nPlease countersign and date this Agreement below to confirm acceptance of these terms and conditions.",
    type: {
      __typename: "ConsignmentType",
      id: 1,
      description: "Consignment",
      updatedAt: null,
    },
    typeId: 1,
    updatedAt: "2024-06-27T10:00:03.000Z",
  },
];

export const instances = [
  {
    __typename: "Instance",
    id: 86482,
    artistNames: "Nathaniel Mary Quinn\n",
    artistRef: null,
    artsy: 0,
    channelEcommerce: 0,
    channelPresentation: 0,
    certificate: null,
    certificateSent: null,
    condition: {
      id: 4470,
      actionRequired: null,
      actionTaken: null,
      annotationUrl: null,
      artistIntent: null,
      artistIntentInclude: 0,
      date: null,
      description:
        "Simon 04/01/2007: Generally good condition.\r\n\r\nAll panels are dirty on the back.\r\nPanels 1,2 and 3 have paint along the top edge from the stairwell at Mansfield St.\r\nPanel 4 has three long but minor horizontal scratches. Another similar scratch archs down from centre right towards the bottom left corner.\r\nPanel 5 has a minor scuff to the face of the frame - top edge 5cm from the right.\r\nPanel9 has 'wet looking' splash marks to face of frame down the left hand side. These marks are also visible at the edge of the plexi - 13 to 27cm down from the top.\r\nPanels 14 and 15 have paint along the bottom edge from the stairwell at Mansfield St.",
      details: null,
      detailsExternal: null,
      detailsExternalInclude: 0,
      detailsInternal: null,
      detailsInternalInclude: 0,
      dimsArtwork: null,
      dimsFramed: null,
      exhibition: null,
      exhibitionInclude: 0,
      fixings: -1,
      frame: null,
      image: -1,
      instanceId: 87,
      jobId: null,
      link: null,
      location: null,
      mount: null,
      mountStatusId: null,
      neon: null,
      packing: null,
      packSpec: null,
      staff: null,
      status: {
        id: 4,
        description: "Good",
        updatedAt: "2003-11-19T17:08:12.000Z",
        __typename: "ConditionStatus",
      },
      statusId: 4,
      technician: null,
      time: "2024-11-18T12:42:18.000Z",
      user: "simon",
      userCreate: null,
      work: null,
      __typename: "Condition",
    },
    company: {
      __typename: "Company",
      id: 11,
      code: "JJ",
      crossInvoiceId: null,
      name: "White Cube Limited",
      vatno: "GB 12345",
      contact: {
        __typename: "Contact",
        id: 4449,
        forename: "Abbot_SCRUBBED",
        surname: "Nixon",
      },
    },
    consignmentPurchase: {
      __typename: "Consignment",
      id: 14159,
      artistUserId: 1108,
      channel: {
        __typename: "ConsignmentChannel",
        id: 2,
        description: "Artfair",
        updatedAt: "2013-09-23T14:47:24.000Z",
      },
      channelId: 2,
      company: {
        __typename: "Company",
        id: 11,
        code: "JJ",
        crossInvoiceId: null,
        name: "White Cube Limited",
        vatno: "GB 12345",
      },
      companyId: 11,
      colAddress: "123 Oxford Road",
      colAddress2: "Flat B",
      colAddress3: "Floor 2",
      colCompany: "Julie Curtiss Studio",
      colContactId: 102943,
      colCounty: "Greater London",
      colCountryId: 1,
      colName: "Julie Curtiss",
      colPostcode: "SE11 1SE",
      colTown: "London",
      consigneeCompany: "White Cube Limited [Bermondsey]",
      consigneeEmail: "",
      consigneeFax: "",
      consigneeName: "Julie Curtiss",
      consigner: {
        __typename: "Contact",
        id: 102943,
        address: "Bahe Sokak 211",
        address2: " Apt. 482",
        address3: "address_3",
        affiliations: "None",
        biography:
          "aliquam adipiscing lacus. Ut nec urna et arcu imperdiet ullamcorper.",
        collection:
          "ligula. Aenean euismod mauris eu elit. Nulla facilisi. Sed neque.",
        collectionActive: null,
        company: "COMPANY_102943_SCRUBBED",
        contactCompany: {
          id: 11,
          code: "JJ",
          crossInvoiceId: null,
          consignmentCredit: null,
          consignmentSignOff: "For and on behalf of White Cube Limited",
          images: {
            header: "https://placehold.jp/700x200.png",
            footer: "https://placehold.jp/700x200.png",
          },
          loanSignOff: "White Cube Limited acting as agent for the Artist",
          name: "COMPANY_102943_SCRUBBED",
          vatno: "GB982 566 574",
          __typename: "Company",
        },
        confidential: 0,
        contactSecondary: false,
        countryId: 225,
        county: " Manisa",
        createdAt: "2017-04-28T14:37:54.000Z",
        details:
          "a, enim. Suspendisse aliquet, sem ut cursus luctus, ipsum leo",
        dob: "2020-01-01",
        email: "whitecube-191105@crvnprojects.com",
        eori: null,
        exhUserId: null,
        firstcontactdate: null,
        firstcontactlocation: null,
        firstcontacttype: null,
        firstUserId: null,
        forename: "Wing_SCRUBBED",
        greeting: null,
        img: null,
        invoicesLength: 1,
        level: null,
        mailingname: "May Durham",
        middlename: null,
        name: "Wing_SCRUBBED Herman",
        notes:
          "egestas. Sed pharetra, felis eget varius ultrices, mauris ipsum porta",
        postcode: " 79732",
        prefered:
          "ante. Nunc mauris sapien, cursus in, hendrerit consectetuer, cursus et,",
        rating: 8,
        sagecode: "CURTISSJ",
        salesUserId: null,
        salesUser2Id: null,
        salutation: "Carissa_SCRUBBED",
        siteId: null,
        storageCharge: 0,
        surname: "Herman",
        title: null,
        town: " Manisa",
        typeId: 3,
        type2Id: null,
        unsubscribed: false,
        updatedAt: "2024-05-22T06:48:54.000Z",
        vat: null,
      },
      consignerId: 102943,
      consigneeTel: "020 7930 5373",
      contact: {
        __typename: "Contact",
        id: 4449,
        address: "49780 Kaitlyn Locks",
        address2: " Suite 367",
        address3: "address_3",
        affiliations: "None",
        biography:
          "magna. Cras convallis convallis dolor. Quisque tincidunt pede ac urna.",
        collection:
          "purus. Maecenas libero est, congue a, aliquet vel, vulputate eu,",
        collectionActive: null,
        company: "COMPANY_4449_SCRUBBED",
        confidential: 0,
        contactCompany: {
          id: 12,
          code: "JJ",
          crossInvoiceId: null,
          consignmentSignOff: "For and on behalf of White Cube Limited",
          loanSignOff: "White Cube Limited acting as agent for the Artist",
          name: "COMPANY_4449_SCRUBBED",
          vatno: "GB 12345",
          __typename: "Company",
        },
        contactSecondary: false,
        countryId: 223,
        county: " Alvertaside",
        country: {
          id: 223,
          continent: "United Kingdom",
          digraph: "UK",
          name: "United Kingdom",
          sagecode: 0,
          updatedAt: "2024-03-20T15:30:43.000Z",
          __typename: "Country",
        },
        createdAt: "2015-09-15T11:10:50.000Z",
        details:
          "elit sed consequat auctor, nunc nulla vulputate dui, nec tempus",
        dob: "2020-01-01",
        email: null,
        eori: "GB982566574000",
        exhUserId: null,
        firstcontactdate: null,
        firstcontactlocation: null,
        firstcontacttype: null,
        firstUserId: null,
        forename: "Abbot_SCRUBBED",
        greeting: null,
        img: null,
        invoicesLength: 724,
        level: null,
        mailingname: "Daquan Golden",
        middlename: null,
        name: "Abbot_SCRUBBED Nixon",
        notes:
          "sagittis augue, eu tempor erat neque non quam. Pellentesque habitant",
        postcode: " ED0 9GM",
        prefered:
          "Ut tincidunt vehicula risus. Nulla eget metus eu erat semper",
        rating: 1,
        sagecode: "WHITECUB",
        salesUserId: null,
        salesUser2Id: null,
        salutation: "Kyra_SCRUBBED",
        siteId: 6,
        storageCharge: 0,
        surname: "Nixon",
        title: null,
        town: " Alvertaside",
        typeId: 10,
        type2Id: null,
        unsubscribed: false,
        updatedAt: "2024-06-21T10:35:41.000Z",
        vat: "GB 982566574",
      },
      contactId: 4449,
      consignmentWorks: [
        {
          id: 100539,
          artistNames: "Robert Adams\n",
          conPrice: null,
          consignment: {
            id: 13885,
            artistUserId: null,
            channel: null,
            channelId: null,
            company: {
              id: 11,
              code: "JJ",
              crossInvoiceId: null,
              name: "White Cube Limited",
              vatno: "GB982 566 574",
              __typename: "Company",
            },
            companyId: 11,
            colAddress: "144 - 152 Bermondsey Street",
            colAddress2: null,
            colAddress3: "",
            colCompany: "White Cube Limited [Bermondsey]",
            colContactId: 4449,
            colCounty: "",
            colCountryId: 223,
            colName: "null null",
            colPostcode: "SE1 3TQ",
            colTown: "London",
            consigneeCompany: "KANAL - Centre Pompidou",
            consigneeEmail: "",
            consigneeFax: "",
            consigneeName: null,
            consigner: {
              id: 4449,
              address: "144 - 152 Bermondsey Street",
              address2: null,
              address3: null,
              affiliations: null,
              biography: null,
              collection: null,
              collectionActive: null,
              company: "White Cube Limited [Bermondsey]",
              confidential: 0,
              contactCompany: {
                id: 11,
                code: "JJ",
                crossInvoiceId: null,
                name: "White Cube Limited",
                vatno: "GB982 566 574",
                __typename: "Company",
              },
              contactNumbers: [
                {
                  id: 25993,
                  donotcall: 0,
                  identifier: null,
                  number: "020 7930 5373",
                  prefere: 0,
                  typeId: 4,
                  __typename: "ContactNumber",
                },
              ],
              contactSecondary: false,
              countryId: 223,
              country: {
                id: 223,
                continent: "United Kingdom",
                digraph: "UK",
                name: "United Kingdom",
                sagecode: 0,
                updatedAt: "2024-03-20T15:30:43.000Z",
                __typename: "Country",
              },
              county: "",
              createdAt: "2015-09-15T11:10:50.000Z",
              details:
                "EORI - GB982566574000\r\n\r\nEU EORI - FRGB1214861310001\r\n\r\nCDS GBTEA98256657400020220929113111 - TA/0909/698/25\r\n\r\nCDS GBTEA98256657400020191024130941",
              dob: null,
              email: null,
              eori: "GB982566574000",
              exhUserId: null,
              firstcontactdate: null,
              firstcontactlocation: null,
              firstcontacttype: null,
              firstUserId: null,
              forename: null,
              greeting: null,
              img: null,
              invoicesLength: 670,
              level: null,
              mailingname: "",
              middlename: null,
              name: "",
              notes:
                "EORI - GB982566574000\r\n\r\n4.9 x 9.3 x 17.5m (h x w x d)",
              postcode: "SE1 3TQ",
              prefered: null,
              rating: 1,
              sagecode: "WHITECUB",
              salesUserId: null,
              salesUser2Id: null,
              salutation: "n/a",
              siteId: 6,
              storageCharge: 0,
              surname: null,
              title: null,
              town: "London",
              typeId: 10,
              type2Id: null,
              unsubscribed: false,
              updatedAt: "2022-11-10T15:41:26.000Z",
              vat: "GB 982566574",
              __typename: "Contact",
            },
            consignerId: 4449,
            consigneeTel: "",
            contact: {
              id: 132048,
              address: "Sq. Sainctelette 21",
              address2: null,
              address3: null,
              affiliations: null,
              biography:
                "KANAL–Centre Pompidou is a new, interdisciplinary museum of modern and contemporary art in Brussels established by the Brussels Capital Region, and developed and managed by the KANAL Foundation in partnership with Centre Pompidou. Slated to open in 2025, it is situated in a converted Citroën factory at the Yser square. In the run up to the inauguration, since 2018, KANAL has been building an ambitious off-site programme and a collection of contemporary art. With its 40 000 m2 space KANAL promises to be one of the largest museums of modern and contemporary art in Europe.",
              collection: null,
              collectionActive: -1,
              company: "KANAL - Centre Pompidou",
              confidential: 0,
              contactCompany: null,
              contactNumbers: [
                {
                  id: 232395,
                  donotcall: 0,
                  identifier: null,
                  number: "https://kanal.brussels/en",
                  prefere: 0,
                  typeId: 9,
                  __typename: "ContactNumber",
                },
              ],
              contactSecondary: true,
              countryId: 20,
              country: {
                id: 20,
                continent: "Europe",
                digraph: "BE",
                name: "Belgium",
                sagecode: 1,
                updatedAt: "2024-03-20T15:25:02.000Z",
                __typename: "Country",
              },
              county: null,
              createdAt: "2023-03-29T11:58:06.000Z",
              details: null,
              dob: null,
              email: null,
              eori: null,
              exhUserId: null,
              firstcontactdate: null,
              firstcontactlocation: null,
              firstcontacttype: null,
              firstUserId: null,
              forename: null,
              greeting: null,
              img: null,
              invoicesLength: 0,
              level: null,
              mailingname: "",
              middlename: null,
              name: "",
              notes: null,
              postcode: "1000",
              prefered: null,
              rating: null,
              sagecode: null,
              salesUserId: null,
              salesUser2Id: null,
              salutation: null,
              siteId: null,
              storageCharge: 0,
              surname: null,
              title: null,
              town: "Brussels",
              typeId: 20,
              type2Id: null,
              unsubscribed: false,
              updatedAt: "2023-03-29T11:58:35.000Z",
              vat: null,
              __typename: "Contact",
            },
            contactId: 132048,
            credit: null,
            currency: {
              id: 3,
              code: "EUR",
              description: "Euro",
              name: null,
              __typename: "Currency",
            },
            currencyId: 3,
            date: "2024-10-17",
            due: "2024-11-07",
            exchange: null,
            guarantee: 0,
            notes: "new loan",
            noOfConsignmentWorks: 4,
            photoMaterial: null,
            registrarId: null,
            retAddress: "144 - 152 Bermondsey Street",
            retAddress2: null,
            retAddress3: "",
            retCompany: "White Cube Limited [Bermondsey]",
            retContactId: 4449,
            retCountryId: 223,
            retCounty: "",
            retName: "null null",
            retPostcode: "SE1 3TQ",
            retTown: "London",
            salesUserId: null,
            salesUser: null,
            shipmentNotes: null,
            status: {
              id: 1,
              description: "Pending",
              updatedAt: "2013-11-20T14:53:18.000Z",
              __typename: "ConsignmentStatus",
            },
            statusId: 1,
            type: {
              id: 2,
              description: "Loan",
              updatedAt: null,
              __typename: "ConsignmentType",
            },
            typeId: 2,
            updatedAt: "2024-10-01T17:58:30.000Z",
            __typename: "Consignment",
          },
          consignmentId: 13885,
          discount: 0,
          discountRate: 0,
          fabCost: 0,
          fabRate: 0,
          grossProfit: 2000,
          instanceId: 85069,
          price: 2000,
          ref: "76522",
          share: 0,
          updatedAt: "2024-10-01T18:31:18.000Z",
          __typename: "ConsignmentWork",
        },
      ],
      credit: null,
      currency: {
        __typename: "Currency",
        id: 2,
        code: "USD",
        description: "US Dollars",
        name: null,
      },
      currencyId: 2,
      date: "2024-02-23",
      due: "2025-02-23",
      exchange: 1.27,
      exhibition: null,
      exhibitionId: null,
      guarantee: 0,
      notes: null,
      noOfConsignmentWorks: 2,
      photoMaterial: null,
      registrarId: null,
      registrar: null,
      retAddress: "",
      retAddress2: "",
      retAddress3: "",
      retCompany: "Julie Curtiss Studio",
      retContactId: 102943,
      retCountryId: 3,
      retCounty: "",
      retName: "Julie Curtiss",
      retPostcode: "",
      retTown: "",
      salesUserId: 1111,
      salesUser: null,
      shipmentNotes: null,
      status: {
        __typename: "ConsignmentStatus",
        id: 1,
        description: "Pending",
        updatedAt: "2013-11-20T14:53:18.000Z",
      },
      statusId: 1,
      type: {
        __typename: "ConsignmentType",
        id: 3,
        description: "Consignment",
        updatedAt: null,
      },
      typeId: 3,
      updatedAt: "2024-06-27T10:00:03.000Z",
    },
    currentWarehouseMove: {
      bondref: null,
      date: "2018-02-09",
      goodsCode: null,
      id: 942817,
      confirmed: null,
      itemId: 1000002,
      location: {
        id: 2597,
        description: "HH Module 1",
        capacity: null,
        siteId: 11,
        __typename: "WarehouseLocation",
      },
      locationId: 2597,
      locref: "Removed from 1089559",
      shipmentId: null,
      siteId: 1,
      site: {
        __typename: "WarehouseSite",
        description: "Bermondsey Lower basement",
      },
      ti: null,
      taDays: null,
      user: "michaelgrime",
      value: null,
      __typename: "WarehouseMove",
    },
    createdAt: "2024-02-22T14:55:05.000Z",
    description:
      "Franz Ackermann, Bryan Adams\n'Soulscapes', Dulwich Picture Gallery, London\n14 February - 2 June 2024\nJJ77934\n",
    droitdesuite: -1,
    edition: {
      id: 53049,
      ap: 0,
      artwork: {
        id: 89626,
        artFair: null,
        artists: [
          {
            id: 1,
            contactId: 2221,
            droitdesuite: -1,
            name: "Franz Ackermann",
            terms: "terms",
            __typename: "Artist",
          },
          {
            id: 3,
            contactId: 3,
            droitdesuite: null,
            name: "Bryan Adams",
            terms: "terms",
            __typename: "Artist",
          },
        ],
        authenticity: null,
        categoryId: 12,
        classId: null,
        confidential: 0,
        countryOfOriginId: null,
        createdAt: "2024-02-22T14:53:44.000Z",
        description: null,
        dimensions: "",
        goodsCode: "",
        installation: null,
        installationLink: null,
        images: [
          {
            artworkId: 89626,
            archiveId: 216667,
            channelDisplayOnline: 1,
            description: null,
            downloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
            imgT: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: 54613,
            updatedAt: "2024-02-23T12:01:18.000Z",
            uploadedAt: "2024-02-23T10:28:07.000Z",
            xDownloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
            __typename: "Image",
          },
          {
            artworkId: 89626,
            archiveId: 216668,
            channelDisplayOnline: 1,
            description: null,
            downloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/t/t216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=0ac405e6ac34759a54654dc4966e7e748d4b098f2ed0a9e19e0bfd35dec82dc4&X-Amz-SignedHeaders=host",
            imgT: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: null,
            updatedAt: "2024-02-22T14:53:46.000Z",
            uploadedAt: null,
            xDownloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/x/x216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=56e90a7d0bf94c1459f211fd4e4a249a45764d258c4ee0d22bcb2ead3531afa0&X-Amz-SignedHeaders=host",
            __typename: "Image",
          },
        ],
        imagesSummary: {
          artworkId: 89627,
          archiveId: 216675,
          channelDisplayOnline: 1,
          description: null,
          downloadPath: "https://placehold.jp/600x600.png",
          imgT: "https://placehold.jp/600x600.png",
          imgX: "https://placehold.jp/600x600.png",
          order: null,
          photoMaterialId: null,
          photoMaterial: null,
          updatedAt: "2024-02-23T11:13:17.000Z",
          uploadedAt: null,
          xDownloadPath: "https://placehold.jp/600x600.png",
          __typename: "Image",
        },
        maintenance: null,
        medium: "Print on paper",
        packing: null,
        photographed: 0,
        photoLink: null,
        photoNote: null,
        precis: null,
        reference: null,
        series: "Group exhibition",
        standardId: null,
        technicalDimensions: null,
        timestamp: "2024-02-23T10:27:31.000Z",
        title: "'Soulscapes', Dulwich Picture Gallery, London",
        travelPack: -1,
        videoLink: null,
        website: 0,
        __typename: "Artwork",
      },
      year: "14 February - 2 June 2024",
      number: 1,
      __typename: "Edition",
    },
    editionNumber: 1,
    editionNumberFormatted: "1/3",
    fabricated: null,
    fabricatedDate: null,
    forSale: 0,
    framed: null,
    ipad: 0,
    insuranceValue: {
      __typename: "Value",
      currency: {
        id: 3,
        code: "EUR",
        description: "Euro",
        name: null,
        __typename: "Currency",
      },
      currencyId: 1,
      value: 200.5,
    },
    value: {
      id: 85669,
      authorisedId: null,
      currency: {
        id: 1,
        code: "GBP",
        description: "Pounds Sterling",
        name: null,
        __typename: "Currency",
      },
      currencyId: 1,
      date: "2025-01-29",
      maxDiscount: null,
      notes: null,
      typeId: 2,
      userId: 1,
      value: 100,
      grossProfit: 100,
      __typename: "Value",
    },
    location: "25-26 Masons Yard",
    locationHistory: "New York",
    name: "JJ77934",
    notes: null,
    parentOnline: 0,
    ref: 36973,
    reference: null,
    returns: 0,
    returnsDirector: 0,
    status: {
      id: 1,
      description: "Pending",
      name: "Sold",
      updatedAt: "2013-11-20T14:53:18.000Z",
      __typename: "Status",
    },
    statusId: 1,
    salesStrategy: null,
    salePrice: 1000.2,
    statusHistory: null,
    updatedAt: "2024-06-07T10:53:44.000Z",
    weight: null,
    warehouseItem: [
      {
        __typename: "WarehouseItem",
        id: 1129746,
        container: 1113890,
        category: {
          __typename: "WarehouseCategory",
          id: 1,
          description: "Fine Art",
          weightPacked: 0,
        },
        description:
          "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
        destroyed: 0,
        dimh: 3,
        dimw: 2,
        dimd: 11,
        itemDescription: "test",
        itemSite: {
          __typename: "WarehouseMove",
          bondref: null,
          date: "2024-07-04",
          goodsCode: null,
          id: 1221328,
          confirmed: null,
          item: {
            __typename: "WarehouseItem",
            id: 1129737,
            artistId: null,
            categoryId: 1,
            container: null,
            description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
            destroyed: 0,
            dimh: null,
            dimw: null,
            dimd: null,
            externalRef: null,
            image: null,
            instanceId: 85096,
            itemDescription: null,
            link: null,
            mgroup: null,
            notes: null,
            packing: null,
            packingId: null,
            responsibleGroupId: null,
            weight: null,
            weightTypeId: 1,
          },
          itemId: 1129737,
          location: {
            id: 2,
            description: "Basement Gallery",
            siteId: 1,
            __typename: "WarehouseLocation",
          },
          locationId: 2,
          locref: null,
          siteId: 1,
          site: {
            __typename: "WarehouseSite",
            description: "Bermondsey Lower basement",
          },
        },
        mgroup: 1,
        packing: {
          __typename: "WarehousePacking",
          id: 58,
          description: "Barrel",
          updatedAt: "2011-01-04T12:09:35.000Z",
        },
        warehouseMoves: [
          {
            __typename: "WarehouseMove",
            bondref: null,
            date: "2024-07-04",
            goodsCode: null,
            id: 1221328,
            confirmed: null,
            item: {
              __typename: "WarehouseItem",
              id: 1129737,
              artistId: null,
              categoryId: 1,
              container: null,
              description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
              destroyed: 0,
              dimh: null,
              dimw: null,
              dimd: null,
              externalRef: null,
              image: null,
              instanceId: 85096,
              itemDescription: null,
              link: null,
              mgroup: null,
              notes: null,
              packing: null,
              packingId: null,
              responsibleGroupId: null,
              weight: null,
              weightTypeId: 1,
            },
            itemId: 1129737,
            location: {
              id: 2,
              description: "Basement Gallery",
              siteId: 1,
              capacity: 100.5,
              __typename: "WarehouseLocation",
            },
            locationId: 2,
            locref: null,
            shipment: {
              __typename: "Shipment",
              id: 91948,
              agent: null,
              bondRef: "GB1234",
              bondReleaseRef: null,
              cancel: 0,
              categoryId: null,
              cds: null,
              condition: null,
              consigneeId: 4449,
              consignorId: 134953,
              currencyId: null,
              customsDate: null,
              customsCode: null,
              customsCodeMatch: null,
              customsCheck: 0,
              customsCheckDate: null,
              customsCheckUser: null,
              customsDeclaration: null,
              customsRef: null,
              customsRequest: 0,
              customsRequestDate: null,
              customsRequestUser: null,
              customsReceived: 0,
              customsReceivedDate: null,
              customsReceivedUser: null,
              date: "2024-11-18",
              declarant: null,
              delAddress: "144 - 152 Bermondsey Street",
              delAddress2: null,
              delAddress3: null,
              delCompany: "White Cube Limited [Bermondsey]",
              delContactId: 4449,
              delCountryId: 223,
              delCounty: "",
              delivered: null,
              delName: "null null",
              delPostcode: "SE1 3TQ",
              delTown: "London",
              destination: null,
              eori: null,
              examined: null,
              guaranteeAccountId: null,
              incoTerm: null,
              insurance: null,
              instructions: null,
              jobId: null,
              oriAddress: null,
              oriAddress2: null,
              oriAddress3: null,
              oriCompany: "ABC",
              oriContactId: 134953,
              oriCountryId: null,
              oriCounty: null,
              oriName: "charlessmith Second",
              oriPostcode: null,
              oriTown: null,
              shipperId: null,
              shipping: null,
              shippingRef: null,
              time: null,
              itemCount: 2,
              totalValue: null,
              unconfirmedItemCount: 2,
              updatedAt: "2024-11-18T16:56:48.000Z",
            },
            shipmentId: 91948,
            siteId: 11,
            site: {
              __typename: "WarehouseSite",
              description: "Bermondsey Lower basement",
            },
          },
        ],
      },
    ],
    volume: 0,
    offer: [
      {
        __typename: "Offer",
        id: 615308,
        amount: 300,
        contact: {
          id: 135841,
          address: "Luvre Fosselyngen 6",
          address2: " Leil. 424",
          address3: "address_3",
          affiliations: "None",
          biography:
            "ultrices posuere cubilia Curae Phasellus ornare. Fusce mollis. Duis sit",
          collection:
            "mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet,",
          collectionActive: -1,
          company: "",
          confidential: 0,
          contactSecondary: true,
          countryId: 225,
          county: " Vestsjeen",
          createdAt: "2023-10-30T23:17:02.000Z",
          details:
            "facilisis facilisis, magna tellus faucibus leo, in lobortis tellus justo",
          dob: "2020-01-01",
          email: "whitecube-237469@crvnprojects.com",
          eori: null,
          exhUserId: null,
          firstcontactdate: "2023-10-30",
          firstcontactlocation: "Intro via Mark Scala",
          firstcontacttype: 5,
          firstUserId: 487,
          forename: "Paula_SCRUBBED",
          greeting: null,
          img: null,
          invoicesLength: 0,
          level: 5,
          mailingname: "Vera Fernandez",
          middlename: null,
          name: "Paula_SCRUBBED Ortega",
          notes:
            "et, magna. Praesent interdum ligula eu enim. Etiam imperdiet dictum",
          postcode: " 6824",
          prefered:
            "Nunc ac sem ut dolor dapibus gravida. Aliquam tincidunt, nunc",
          rating: null,
          sagecode: null,
          salesUserId: 487,
          salesUser2Id: null,
          salutation: "Ori_SCRUBBED",
          siteId: null,
          storageCharge: 0,
          surname: "Ortega",
          title: "McKinnon Curator of Modern and Contemporary Art",
          town: " Vestsjeen",
          typeId: 27,
          type2Id: null,
          unsubscribed: false,
          updatedAt: "2024-05-22T07:31:46.000Z",
          vat: null,
          __typename: "Contact",
        },
        contactId: 135841,
        currency: {
          id: 3,
          code: "EUR",
          description: "Euro",
          name: null,
          __typename: "Currency",
        },
        currencyId: 3,
        date: null,
        dateClosed: null,
        exchange: null,
        hold: {
          __typename: "Instance",
          id: 86482,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          company: {
            __typename: "Company",
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB 12345",
            contact: {
              __typename: "Contact",
              id: 4449,
              forename: "Abbot_SCRUBBED",
              surname: "Nixon",
            },
          },
          createdAt: "2024-02-22T14:55:05.000Z",
          description:
            "Franz Ackermann, Bryan Adams\n'Soulscapes', Dulwich Picture Gallery, London\n14 February - 2 June 2024\nJJ77934\n",
          edition: {
            id: 53049,
            ap: 0,
            artwork: {
              id: 89626,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: null,
              categoryId: 12,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-02-22T14:53:44.000Z",
              description: null,
              dimensions: "",
              goodsCode: "",
              installation: null,
              installationLink: null,
              images: [
                {
                  artworkId: 89626,
                  archiveId: 216667,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: 54613,
                  updatedAt: "2024-02-23T12:01:18.000Z",
                  uploadedAt: "2024-02-23T10:28:07.000Z",
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
                {
                  artworkId: 89626,
                  archiveId: 216668,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/t/t216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=0ac405e6ac34759a54654dc4966e7e748d4b098f2ed0a9e19e0bfd35dec82dc4&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: null,
                  updatedAt: "2024-02-22T14:53:46.000Z",
                  uploadedAt: null,
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/x/x216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=56e90a7d0bf94c1459f211fd4e4a249a45764d258c4ee0d22bcb2ead3531afa0&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
              ],
              imagesSummary: {
                artworkId: 89627,
                archiveId: 216675,
                channelDisplayOnline: 1,
                description: null,
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                order: null,
                photoMaterialId: null,
                photoMaterial: null,
                updatedAt: "2024-02-23T11:13:17.000Z",
                uploadedAt: null,
                xDownloadPath: "https://placehold.jp/600x600.png",
                __typename: "Image",
              },
              maintenance: null,
              medium: "Print on paper",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "Group exhibition",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2024-02-23T10:27:31.000Z",
              title: "'Soulscapes', Dulwich Picture Gallery, London",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "14 February - 2 June 2024",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          location: "London",
          locationHistory: null,
          name: "JJ77934",
          notes: null,
          parentOnline: 0,
          ref: 36973,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 1,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-06-07T10:53:44.000Z",
          weight: null,
          volume: 0,
        },
        holdId: 123,
        holdDate: "2007-07-23T12:30:55.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        status: {
          id: 5,
          name: "To Be Invoiced",
          updatedAt: "2007-07-23T12:30:55.000Z",
          __typename: "OfferStatus",
        },
        statusId: 5,
        tbiAmount: 222.11,
        tbiDate: null,
        transparency: null,
        user: null,
        updatedAt: "2023-10-31T09:54:18.000Z",
      },
    ],
    item: [
      {
        __typename: "Item",
        id: 267679,
        amount: 5000,
        discount: 0,
        discountRate: 0,
        exchange: 1.27,
        date: "2024-08-01",
        description:
          "Nathaniel Mary Quinn\nSomething Blue\n2020\nBlack charcoal, gouache, soft pastel and oil pastel\nJJ86482\n",
        instanceId: 86482,
        invoiceId: 42722,
        price: 5000,
        instance: {
          __typename: "Instance",
          id: 86482,
          name: "Something Blue",
        },
        invoice: {
          __typename: "Invoice",
          id: 42722,
          exchange: 1.27,
          contact: {
            __typename: "Contact",
            id: 137342,
            forename: "Cathleen_SCRUBBED",
            surname: "Moore",
            name: "Cathleen_SCRUBBED Moore",
            company: "COMPANY_137342_SCRUBBED",
            address: "Eichenkamp 47c",
            address2: " Zimmer 283",
            address3: "address_3",
            town: " Neu Dustinland",
            county: " Neu Dustinland",
            postcode: " 85909",
            countryId: 54,
            email: null,
          },
          country: {
            __typename: "Country",
            id: 54,
            continent: "Europe",
            digraph: "DE",
            name: "Germany",
            sagecode: 1,
            updatedAt: "2024-03-20T15:25:03.000Z",
          },
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          invoiceTotals: {
            balance: 5875,
            balance30Days: 5875,
            balance60Days: 0,
            current: 0,
            grossProfit: 2500,
            net: 5000,
            tax: 875,
            total: 5875,
            netExchange: "3937.01",
          },
        },
      },
      {
        __typename: "Item",
        id: 267680,
        amount: 12000,
        discount: 1200,
        discountRate: 10,
        exchange: 1,
        date: "2024-08-15",
        description:
          "Nathaniel Mary Quinn\nUntitled Study\n2019\nCharcoal on paper\nJJ86482\n",
        instanceId: 86482,
        invoiceId: 42723,
        price: 12000,
        instance: {
          __typename: "Instance",
          id: 86482,
          name: "Something Blue",
        },
        invoice: {
          __typename: "Invoice",
          id: 42723,
          exchange: 1,
          contact: {
            __typename: "Contact",
            id: 4449,
            forename: "Abbot_SCRUBBED",
            surname: "Nixon",
            name: "Abbot_SCRUBBED Nixon",
            company: "White Cube Limited [Bermondsey]",
            address: "49780 Kaitlyn Locks",
            address2: " Suite 367",
            address3: "address_3",
            town: " Alvertaside",
            county: " Alvertaside",
            postcode: " ED0 9GM",
            countryId: 223,
            email: null,
          },
          country: {
            __typename: "Country",
            id: 223,
            continent: "United Kingdom",
            digraph: "UK",
            name: "United Kingdom",
            sagecode: 0,
            updatedAt: "2024-03-20T15:30:43.000Z",
          },
          currency: {
            __typename: "Currency",
            id: 2,
            code: "USD",
            description: "US Dollars",
            name: null,
          },
          invoiceTotals: {
            balance: 12690,
            balance30Days: 0,
            balance60Days: 0,
            current: 12690,
            grossProfit: 5400,
            net: 10800,
            tax: 1890,
            total: 12690,
            netExchange: "10800.00",
          },
        },
      },
    ],
  },
  {
    __typename: "Instance",
    id: 86485,
    artistNames: "Damien Hirst\n",
    artistRef: null,
    artsy: 0,
    channelEcommerce: 0,
    channelPresentation: 0,
    certificate: null,
    certificateSent: null,
    condition: {
      id: 4470,
      actionRequired: null,
      actionTaken: null,
      annotationUrl: null,
      artistIntent: null,
      artistIntentInclude: 0,
      date: null,
      description:
        "Simon 04/01/2007: Generally good condition.\r\n\r\nAll panels are dirty on the back.\r\nPanels 1,2 and 3 have paint along the top edge from the stairwell at Mansfield St.\r\nPanel 4 has three long but minor horizontal scratches. Another similar scratch archs down from centre right towards the bottom left corner.\r\nPanel 5 has a minor scuff to the face of the frame - top edge 5cm from the right.\r\nPanel9 has 'wet looking' splash marks to face of frame down the left hand side. These marks are also visible at the edge of the plexi - 13 to 27cm down from the top.\r\nPanels 14 and 15 have paint along the bottom edge from the stairwell at Mansfield St.",
      details: null,
      detailsExternal: null,
      detailsExternalInclude: 0,
      detailsInternal: null,
      detailsInternalInclude: 0,
      dimsArtwork: null,
      dimsFramed: null,
      exhibition: null,
      exhibitionInclude: 0,
      fixings: -1,
      frame: null,
      image: -1,
      instanceId: 87,
      jobId: null,
      link: null,
      location: null,
      mount: null,
      mountStatusId: null,
      neon: null,
      packing: null,
      packSpec: null,
      staff: null,
      status: {
        id: 4,
        description: "Good",
        updatedAt: "2003-11-19T17:08:12.000Z",
        __typename: "ConditionStatus",
      },
      statusId: 4,
      technician: null,
      time: "2024-11-18T12:42:18.000Z",
      user: "simon",
      userCreate: null,
      work: null,
      __typename: "Condition",
    },
    company: {
      __typename: "Company",
      id: 11,
      code: "JJ",
      crossInvoiceId: null,
      name: "White Cube Limited",
      vatno: "GB 12345",
      contact: {
        __typename: "Contact",
        id: 4449,
        forename: "Abbot_SCRUBBED",
        surname: "Nixon",
      },
    },
    currentWarehouseMove: {
      bondref: null,
      date: "2018-02-09",
      goodsCode: null,
      id: 942817,
      confirmed: null,
      itemId: 1000002,
      location: {
        id: 2597,
        description: "HH Module 1",
        capacity: null,
        siteId: 11,
        __typename: "WarehouseLocation",
      },
      locationId: 2597,
      locref: "Removed from 1089559",
      shipmentId: null,
      siteId: 11,
      site: {
        __typename: "WarehouseSite",
        description: "Bermondsey Lower basement",
      },
      ti: null,
      taDays: null,
      user: "michaelgrime",
      value: null,
      __typename: "WarehouseMove",
    },
    createdAt: "2024-02-23T11:51:38.000Z",
    description:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\nJJ77937\n",
    droitdesuite: 0,
    edition: {
      id: 53052,
      ap: 0,
      artwork: {
        id: 89629,
        artFair: null,
        artists: [
          {
            id: 4,
            contactId: 4,
            droitdesuite: null,
            name: "Tracey Emin",
            terms: "terms",
            __typename: "Artist",
          },
        ],
        authenticity: null,
        categoryId: 10,
        classId: null,
        confidential: 0,
        countryOfOriginId: null,
        createdAt: "2024-02-23T11:50:50.000Z",
        description: null,
        dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
        goodsCode: "970110",
        installation: null,
        installationLink: null,
        images: [
          {
            artworkId: 89629,
            archiveId: 216679,
            channelDisplayOnline: 1,
            description: null,
            downloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/t/t216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=dd57e0c182b1a65ebed1a2dc8b7dcfdedb96878fc4dd7cdd4326ebde05a5fc24&X-Amz-SignedHeaders=host",
            imgT: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: null,
            updatedAt: "2024-02-23T11:50:50.000Z",
            uploadedAt: null,
            xDownloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/x/x216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=9e8a2c74df194b674a6cc729de6cbc1d4a3a2b8864c7384d4e5fa24e17319973&X-Amz-SignedHeaders=host",
            __typename: "Image",
          },
          {
            artworkId: 89629,
            archiveId: 216680,
            channelDisplayOnline: 1,
            description: null,
            downloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/0/8/t/t216680.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=58c78bc0c0e23a358b6984b5c25043c591c0fa03075560cc4ad32cbb1c04d7e3&X-Amz-SignedHeaders=host",
            imgT: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: null,
            updatedAt: "2024-02-23T11:50:52.000Z",
            uploadedAt: null,
            xDownloadPath:
              "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/0/8/x/x216680.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a00d9a5c49b424af3f28ad00347364a62fa544ddc586218e927507ab37fafdba&X-Amz-SignedHeaders=host",
            __typename: "Image",
          },
        ],
        imagesSummary: {
          artworkId: 89627,
          archiveId: 216675,
          channelDisplayOnline: 1,
          description: null,
          downloadPath: "https://placehold.jp/600x600.png",
          imgT: "https://placehold.jp/600x600.png",
          imgX: "https://placehold.jp/600x600.png",
          order: null,
          photoMaterialId: null,
          photoMaterial: null,
          updatedAt: "2024-02-23T11:13:17.000Z",
          uploadedAt: null,
          xDownloadPath: "https://placehold.jp/600x600.png",
          __typename: "Image",
        },
        maintenance: null,
        medium: "Oil, ink and pencil on paper",
        packing: null,
        photographed: -1,
        photoLink: null,
        photoNote: null,
        precis: null,
        reference: null,
        series: "test",
        standardId: null,
        technicalDimensions: null,
        timestamp: "2024-02-23T11:50:50.000Z",
        title: "Who Cares Wins",
        travelPack: -1,
        videoLink: null,
        website: 0,
        __typename: "Artwork",
      },
      year: "2024",
      number: 1,
      __typename: "Edition",
    },
    editionNumber: 1,
    editionNumberFormatted: "1/2",
    fabricated: null,
    fabricatedDate: null,
    forSale: 0,
    framed: null,
    ipad: 0,
    insuranceValue: {
      __typename: "Value",
      currency: {
        id: 3,
        code: "EUR",
        description: "Euro",
        name: null,
        __typename: "Currency",
      },
      currencyId: 1,
      type: {
        __typename: "ValueType",
        id: 123,
        description: "Value Type",
      },
      value: 7000,
    },
    value: {
      id: 85669,
      authorisedId: null,
      currency: {
        id: 1,
        code: "GBP",
        description: "Pounds Sterling",
        name: null,
        __typename: "Currency",
      },
      currencyId: 1,
      date: "2025-01-29",
      maxDiscount: null,
      notes: null,
      typeId: 2,
      userId: 1,
      value: 100,
      grossProfit: 100,
      __typename: "Value",
    },
    location: "London",
    locationHistory: "New York",
    name: "JJ77937",
    notes:
      "For Kate Price - Harland will gift this work to Kate Price in person on Monday 26/02/2024 at the ICA \r\nCOA to be generated",
    parentOnline: 0,
    ref: 77937,
    reference: null,
    returns: 0,
    returnsDirector: 0,
    status: {
      id: 1,
      description: "Pending",
      name: "Sold",
      updatedAt: "2013-11-20T14:53:18.000Z",
      __typename: "Status",
    },
    statusId: 2,
    salesStrategy: null,
    salePrice: 2000.3,
    statusHistory: null,
    updatedAt: "2024-06-07T10:20:06.000Z",
    weight: "1kg",
    warehouseItem: [
      {
        __typename: "WarehouseItem",
        id: 1129746,
        container: 1113890,
        category: {
          __typename: "WarehouseCategory",
          id: 1,
          description: "Fine Art",
          weightPacked: 0,
        },
        description:
          "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
        destroyed: 0,
        dimh: 3,
        dimw: 2,
        dimd: 11,
        itemDescription: "test",
        itemSite: {
          __typename: "WarehouseMove",
          bondref: null,
          date: "2024-07-04",
          goodsCode: null,
          id: 1221328,
          confirmed: null,
          item: {
            __typename: "WarehouseItem",
            id: 1129737,
            artistId: null,
            categoryId: 1,
            container: null,
            description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
            destroyed: 0,
            dimh: null,
            dimw: null,
            dimd: null,
            externalRef: null,
            image: null,
            instanceId: 85096,
            itemDescription: null,
            link: null,
            mgroup: null,
            notes: null,
            packing: null,
            packingId: null,
            responsibleGroupId: null,
            weight: null,
            weightTypeId: 1,
          },
          itemId: 1129737,
          location: {
            id: 2,
            description: "Basement Gallery",
            siteId: 1,
            __typename: "WarehouseLocation",
          },
          locationId: 2,
          locref: null,
          siteId: 11,
          site: {
            __typename: "WarehouseSite",
            description: "Bermondsey Lower basement",
          },
        },
        mgroup: 1,
        packing: {
          __typename: "WarehousePacking",
          id: 58,
          description: "Barrel",
          updatedAt: "2011-01-04T12:09:35.000Z",
        },
        warehouseMoves: [
          {
            __typename: "WarehouseMove",
            bondref: null,
            date: "2024-07-04",
            goodsCode: null,
            id: 1221328,
            confirmed: null,
            item: {
              __typename: "WarehouseItem",
              id: 1129737,
              artistId: null,
              categoryId: 1,
              container: null,
              description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
              destroyed: 0,
              dimh: null,
              dimw: null,
              dimd: null,
              externalRef: null,
              image: null,
              instanceId: 85096,
              itemDescription: null,
              link: null,
              mgroup: null,
              notes: null,
              packing: null,
              packingId: null,
              responsibleGroupId: null,
              weight: null,
              weightTypeId: 1,
            },
            itemId: 1129737,
            location: {
              id: 2,
              description: "Upper Gallery",
              siteId: 1,
              __typename: "WarehouseLocation",
            },
            locationId: 2,
            locref: null,
            siteId: 1,
            site: {
              __typename: "WarehouseSite",
              description: "Bermondsey Lower basement",
            },
          },
        ],
      },
    ],
    volume: 0,
    offer: [
      {
        __typename: "Offer",
        id: 615308,
        amount: 500.55,
        contact: {
          id: 135841,
          address: "Luvre Fosselyngen 6",
          address2: " Leil. 424",
          address3: "address_3",
          affiliations: "None",
          biography:
            "ultrices posuere cubilia Curae Phasellus ornare. Fusce mollis. Duis sit",
          collection:
            "mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet,",
          collectionActive: -1,
          company: "",
          confidential: 0,
          contactSecondary: true,
          countryId: 225,
          county: " Vestsjeen",
          createdAt: "2023-10-30T23:17:02.000Z",
          details:
            "facilisis facilisis, magna tellus faucibus leo, in lobortis tellus justo",
          dob: "2020-01-01",
          email: "whitecube-237469@crvnprojects.com",
          eori: null,
          exhUserId: null,
          firstcontactdate: "2023-10-30",
          firstcontactlocation: "Intro via Mark Scala",
          firstcontacttype: 5,
          firstUserId: 487,
          forename: "Paula_SCRUBBED",
          greeting: null,
          img: null,
          invoicesLength: 0,
          level: 5,
          mailingname: "Vera Fernandez",
          middlename: null,
          name: "Paula_SCRUBBED Ortega",
          notes:
            "et, magna. Praesent interdum ligula eu enim. Etiam imperdiet dictum",
          postcode: " 6824",
          prefered:
            "Nunc ac sem ut dolor dapibus gravida. Aliquam tincidunt, nunc",
          rating: null,
          sagecode: null,
          salesUserId: 487,
          salesUser2Id: null,
          salutation: "Ori_SCRUBBED",
          siteId: null,
          storageCharge: 0,
          surname: "Ortega",
          title: "McKinnon Curator of Modern and Contemporary Art",
          town: " Vestsjeen",
          typeId: 27,
          type2Id: null,
          unsubscribed: false,
          updatedAt: "2024-05-22T07:31:46.000Z",
          vat: null,
          __typename: "Contact",
        },
        contactId: 135841,
        date: null,
        dateClosed: null,
        exchange: null,
        hold: {
          __typename: "Instance",
          id: 86482,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          company: {
            __typename: "Company",
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB 12345",
            contact: {
              __typename: "Contact",
              id: 4449,
              forename: "Abbot_SCRUBBED",
              surname: "Nixon",
            },
          },
          createdAt: "2024-02-22T14:55:05.000Z",
          description:
            "Franz Ackermann, Bryan Adams\n'Soulscapes', Dulwich Picture Gallery, London\n14 February - 2 June 2024\nJJ77934\n",
          edition: {
            id: 53049,
            ap: 0,
            artwork: {
              id: 89626,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: null,
              categoryId: 12,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-02-22T14:53:44.000Z",
              description: null,
              dimensions: "",
              goodsCode: "",
              installation: null,
              installationLink: null,
              images: [
                {
                  artworkId: 89626,
                  archiveId: 216667,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: 54613,
                  updatedAt: "2024-02-23T12:01:18.000Z",
                  uploadedAt: "2024-02-23T10:28:07.000Z",
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
                {
                  artworkId: 89626,
                  archiveId: 216668,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/t/t216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=0ac405e6ac34759a54654dc4966e7e748d4b098f2ed0a9e19e0bfd35dec82dc4&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: null,
                  updatedAt: "2024-02-22T14:53:46.000Z",
                  uploadedAt: null,
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/x/x216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=56e90a7d0bf94c1459f211fd4e4a249a45764d258c4ee0d22bcb2ead3531afa0&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
              ],
              imagesSummary: {
                artworkId: 89627,
                archiveId: 216675,
                channelDisplayOnline: 1,
                description: null,
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                order: null,
                photoMaterialId: null,
                photoMaterial: null,
                updatedAt: "2024-02-23T11:13:17.000Z",
                uploadedAt: null,
                xDownloadPath: "https://placehold.jp/600x600.png",
                __typename: "Image",
              },
              maintenance: null,
              medium: "Print on paper",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "Group exhibition",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2024-02-23T10:27:31.000Z",
              title: "'Soulscapes', Dulwich Picture Gallery, London",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "14 February - 2 June 2024",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          location: "London",
          locationHistory: null,
          name: "JJ77934",
          notes: null,
          parentOnline: 0,
          ref: 36973,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 1,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-06-07T10:53:44.000Z",
          weight: null,
          volume: 0,
        },
        holdId: 456,
        holdDate: "2015-09-15T12:10:50.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        status: {
          id: 5,
          description: "To Be Invoiced",
          updatedAt: "2007-07-23T12:30:55.000Z",
          __typename: "OfferStatus",
        },
        statusId: 5,
        tbiAmount: 222.11,
        tbiDate: null,
        transparency: null,
        user: "root",
        updatedAt: "2023-10-31T09:54:18.000Z",
      },
    ],
    item: [
      {
        __typename: "Item",
        id: 267681,
        amount: 25000,
        discount: 2500,
        discountRate: 10,
        exchange: 1,
        date: "2024-09-01",
        description:
          "Damien Hirst\nThe Physical Impossibility\n2023\nGlass, steel, silicone\nJJ86485\n",
        instanceId: 86485,
        invoiceId: 42724,
        price: 25000,
        instance: {
          __typename: "Instance",
          id: 86485,
          name: "The Physical Impossibility",
        },
        invoice: {
          __typename: "Invoice",
          id: 42724,
          exchange: 1.15,
          contact: {
            __typename: "Contact",
            id: 102943,
            forename: "Wing_SCRUBBED",
            surname: "Herman",
            name: "Wing_SCRUBBED Herman",
            company: "COMPANY_102943_SCRUBBED",
            address: "Bahe Sokak 211",
            address2: " Apt. 482",
            address3: "address_3",
            town: " Manisa",
            county: " Manisa",
            postcode: " 79732",
            countryId: 225,
            email: "whitecube-191105@crvnprojects.com",
          },
          country: {
            __typename: "Country",
            id: 225,
            continent: "Asia",
            digraph: "TR",
            name: "Turkey",
            sagecode: 1,
            updatedAt: "2024-03-20T15:30:43.000Z",
          },
          currency: {
            __typename: "Currency",
            id: 3,
            code: "EUR",
            description: "Euro",
            name: null,
          },
          invoiceTotals: {
            balance: 26438,
            balance30Days: 0,
            balance60Days: 0,
            current: 26438,
            grossProfit: 11250,
            net: 22500,
            tax: 3938,
            total: 26438,
            netExchange: "19565.22",
          },
        },
      },
    ],
  },
];

export const warehouseItems = [
  {
    __typename: "WarehouseItem",
    id: 1129746,
    artist: {
      __typename: "Artist",
      id: 3,
      bornCountry: {
        __typename: "Country",
        id: 3,
        continent: "South Asia",
        digraph: "AF",
        name: "Afghanistan",
        sagecode: 6,
        updatedAt: "2024-03-20T15:25:02.000Z",
      },
      bornCountryId: 3,
      bornDate: null,
      bornTown: "",
      contact: {
        __typename: "Contact",
        id: 3,
        address: "6 Apollo Place",
        address2: null,
        address3: null,
        affiliations: null,
        biography: null,
        collection: null,
        collectionActive: null,
        company: null,
        confidential: 0,
        contactCompany: null,
        contactNumbers: [
          {
            __typename: "ContactNumber",
            id: 55,
            donotcall: 0,
            identifier: null,
            number: "alimarr@bryanadams.com",
            prefere: -1,
            typeId: 1,
          },
        ],
        contactSecondary: false,
        countryId: 223,
        country: {
          __typename: "Country",
          id: 223,
          continent: "United Kingdom",
          digraph: "UK",
          name: "United Kingdom",
          sagecode: 0,
          updatedAt: "2024-03-20T15:30:43.000Z",
        },
        county: null,
        createdAt: "2015-09-15T12:10:50.000Z",
        dateEntered: null,
        details:
          "01/2012 SR\r\nAli Marr - PA to Bryan Adams\r\n\r\n\r\nFrom Art Fortnight Mailing List 2004",
        dob: null,
        email: "alimarr@bryanadams.com",
        eori: null,
        exhUserId: null,
        firstcontactdate: null,
        firstcontactlocation: "Frieze 2006",
        firstcontacttype: 2,
        firstUserId: 14,
        forename: "Bryan",
        greeting: null,
        img: "https://wc-preprod-sync.s3.eu-west-2.amazonaws.com/data/inventory/contact/3.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250109%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250109T155530Z&X-Amz-Expires=3600&X-Amz-Signature=5c127595f91894544561f59f8ff94803e549883e0b321e36fb31e838591496a0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
        invoicesLength: 0,
        level: null,
        mailingname: "Bryan Adams",
        middlename: null,
        name: "Bryan Adams",
        notes:
          "\r\n\r\nAM- met at Frieze 2006\r\n\r\nPreviously Alex Mollof client",
        postcode: "SW10 0ET",
        prefered: null,
        rating: null,
        sagecode: null,
        salesUserId: 940,
        salesUser2Id: null,
        salutation: "Bryan",
        siteId: null,
        storageCharge: 0,
        surname: "Adams",
        title: null,
        town: "London",
        typeId: 3,
        type2Id: null,
        unsubscribed: false,
        updatedAt: "2024-11-15T13:01:36.000Z",
        userEntered: null,
        user: "fredrika",
        vat: null,
      },
      confidential: 0,
      contactId: 3,
      copyright: null,
      defaultFabRate: 0,
      defaultSplitRate: null,
      droitdesuite: -1,
      mailingList: null,
      name: "Bryan Adams",
      represented: 0,
      sageCost: "TAB",
      sharedDiscount: null,
      terms: "terms",
    },
    artistId: 3,
    category: {
      __typename: "WarehouseCategory",
      id: 1,
      description: "Fine Art",
      weightPacked: 0,
    },
    categoryId: 1,
    container: null,
    description:
      "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
    destroyed: 0,
    dimh: 3,
    dimw: 2,
    dimd: 1,
    externalRef: "9",
    image: null,
    instance: {
      __typename: "Instance",
      id: 85099,
      arrApplicable: false,
      artistRef: "ref",
      artsy: 0,
      channelEcommerce: 0,
      channelPresentation: 1,
      certificate: null,
      certificateSent: null,
      company: {
        __typename: "Company",
        id: 11,
        active: -1,
        bondMinValue: 200000,
        code: "JJ",
        cds: "GBTEA98256657400020220929113111",
        consignmentCredit: null,
        consignmentTerms:
          'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
        consignmentSignOff: "For and on behalf of White Cube Limited",
        contactId: 4449,
        createdAt: "2015-09-15T11:46:59.000Z",
        creditCode: "WCC",
        creditRef: 3371,
        crossInvoiceId: null,
        currencyId: 1,
        currency: {
          __typename: "Currency",
          id: 1,
          code: "GBP",
          description: "Pounds Sterling",
          name: null,
        },
        hmrcAddress:
          "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
        invoiceCode: "WCA",
        invoiceDue: "1m",
        loanTerms:
          "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
        loanSignOff: "White Cube Limited acting as agent for the Artist",
        photoCredit: null,
        name: "White Cube Limited",
        notes: null,
        shippingEmail: null,
        vatno: "GB982 566 574",
      },
      condition: null,
      createdAt: "2024-11-05T15:09:39.000Z",
      description:
        "Robert Adams\nTest Artwork - Three screen prints\n\n2021\nThree screen prints in bespoke cloth bound portfolio Somerset Radiant White Tub Sized 410gsm paper with hand torn edges.\n\n27 9/16 x 39 3/8 in. | (70 x 100 cm)\n\nJJ76555\n",
      edition: {
        __typename: "Edition",
        id: 51807,
        ap: 2,
        artwork: {
          __typename: "Artwork",
          id: 188469,
          artFair: null,
          artists: [
            {
              __typename: "Artist",
              id: 2,
              bornCountry: null,
              bornCountryId: null,
              bornDate: null,
              bornTown: "",
              confidential: 0,
              contactId: 2,
              copyright: null,
              defaultFabRate: null,
              defaultSplitRate: null,
              droitdesuite: null,
              mailingList: null,
              name: "Robert Adams",
              represented: 0,
              sageCost: "AI",
              sharedDiscount: null,
              terms: "terms",
            },
          ],
          artworkCategory: {
            __typename: "ArtworkCategory",
            id: 19,
            name: "Prints and Multiples",
            goodsCode: null,
          },
          authenticity: null,
          categoryId: 19,
          classId: 1,
          confidential: 0,
          countryOfOriginId: 5,
          createdAt: "2024-07-08T15:52:49.000Z",
          description:
            "Unlocated. AG.ed 19/04/2017\n \n One signed edition gifted to Amanda McDermott - need to confirm number.\n Dims given are image and paper size (fullbleed)",
          dimensions: "27 9/16 x 39 3/8 in. | (70 x 100 cm)\n",
          goodsCode: null,
          installation: null,
          installationLink: null,
          maintenance: null,
          medium:
            "Three screen prints in bespoke cloth bound portfolio Somerset Radiant White Tub Sized 410gsm paper with hand torn edges.\n",
          packing: null,
          photographed: 0,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "White Cube Edition",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2024-11-15T13:16:46.000Z",
          title: "Test Artwork - Three screen prints\n",
          travelPack: -1,
          videoLink: null,
          website: 0,
        },
        year: "2021",
        number: 1,
      },
      editionNumber: 1,
      fabricated: null,
      fabricatedDate: null,
      forSale: 0,
      framed: 0,
      ipad: 0,
      bondType: null,
      isBond: false,
      isGuaranteed: false,
      isOnLoan: false,
      isSecondaryMarket: false,
      locationHistory: null,
      name: "JJ76555",
      notes:
        "Unlocated. AG.ed 19/04/2017\n \n One signed edition gifted to Amanda McDermott - need to confirm number.\n Dims given are image and paper size (fullbleed)",
      parentOnline: 0,
      ref: 76555,
      reference: null,
      returns: 0,
      returnsDirector: 0,
      status: {
        __typename: "Status",
        id: 4,
        name: "On Hold",
        online: true,
        createdAt: "2015-09-18T11:54:30.000Z",
      },
      statusId: 4,
      salesPrice: null,
      salesStrategy: "Sales Strategy",
      statusHistory: null,
      unpackedWeight: "12kg",
      updatedAt: "2024-11-15T13:20:44.000Z",
      value: {
        __typename: "Value",
        id: 85614,
        authorisedId: 1261,
        currency: {
          __typename: "Currency",
          id: 3,
          code: "EUR",
          description: "Euro",
          name: null,
        },
        currencyId: 3,
        date: "2024-11-05",
        maxDiscount: 13,
        notes: null,
        typeId: 2,
        userId: 1195,
        value: 13,
        grossProfit: 13,
      },
      volume: 0,
      weight: "12kg",
      location:
        "White Cube Limited [Bermondsey] null null 144 - 152 Bermondsey Street",
    },
    instanceId: 85099,
    itemDescription:
      "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
    itemSite: {
      __typename: "WarehouseMove",
      bondref: null,
      date: "2024-11-18",
      goodsCode: null,
      id: 1221370,
      confirmed: null,
      item: {
        __typename: "WarehouseItem",
        id: 1129746,
        artistId: 3,
        category: {
          __typename: "WarehouseCategory",
          id: 1,
          description: "Fine Art",
          weightPacked: 0,
        },
        categoryId: 1,
        container: null,
        description:
          "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
        destroyed: 0,
        dimh: 3,
        dimw: 2,
        dimd: 1,
        externalRef: "9",
        image: null,
        instanceId: 85099,
        itemDescription: null,
        link: null,
        mgroup: 1,
        notes: null,
        packing: {
          __typename: "WarehousePacking",
          id: 58,
          description: "Barrel",
          updatedAt: "2011-01-04T12:09:35.000Z",
        },
        packingId: 58,
        responsibleGroupId: 68,
        weight: 12,
        weightTypeId: 2,
      },
      itemId: 1129746,
      location: {
        id: 2417,
        description: "Aisle 1",
        capacity: 100.5,
        siteId: 7,
        __typename: "WarehouseLocation",
      },
      locationId: 4,
      locref: null,
      shipment: {
        __typename: "Shipment",
        id: 91948,
        agent: null,
        bondRef: "GB1234",
        bondReleaseRef: null,
        cancel: 0,
        categoryId: null,
        cds: null,
        condition: null,
        consigneeId: 4449,
        consignorId: 134953,
        currencyId: null,
        customsDate: null,
        customsCode: null,
        customsCodeMatch: null,
        customsCheck: 0,
        customsCheckDate: null,
        customsCheckUser: null,
        customsDeclaration: null,
        customsRef: null,
        customsRequest: 0,
        customsRequestDate: null,
        customsRequestUser: null,
        customsReceived: 0,
        customsReceivedDate: null,
        customsReceivedUser: null,
        date: "2024-11-18",
        declarant: null,
        delAddress: "144 - 152 Bermondsey Street",
        delAddress2: null,
        delAddress3: null,
        delCompany: "White Cube Limited [Bermondsey]",
        delContactId: 4449,
        delCountryId: 223,
        delCounty: "",
        delivered: null,
        delName: "null null",
        delPostcode: "SE1 3TQ",
        delTown: "London",
        destination: null,
        eori: null,
        examined: null,
        guaranteeAccountId: null,
        incoTerm: null,
        insurance: null,
        instructions: null,
        jobId: null,
        oriAddress: null,
        oriAddress2: null,
        oriAddress3: null,
        oriCompany: "ABC",
        oriContactId: 134953,
        oriCountryId: null,
        oriCounty: null,
        oriName: "charlessmith Second",
        oriPostcode: null,
        oriTown: null,
        shipperId: null,
        shipping: null,
        shippingRef: null,
        time: null,
        itemCount: 2,
        totalValue: null,
        unconfirmedItemCount: 2,
        updatedAt: "2024-11-18T16:56:48.000Z",
      },
      shipmentId: 91948,
      siteId: 1,
      site: {
        description: "Bermondsey Lower basement",
      },
      ti: null,
      taDays: null,
      user: "charles",
      value: null,
    },
    link: null,
    mgroup: 1,
    notes: null,
    packing: {
      __typename: "WarehousePacking",
      id: 58,
      description: "Barrel",
      updatedAt: "2011-01-04T12:09:35.000Z",
    },
    packingId: 58,
    responsibleGroupId: 68,
    warehouseMoves: [
      {
        __typename: "WarehouseMove",
        bondref: null,
        date: "2024-11-07",
        goodsCode: "491191",
        id: 1221353,
        confirmed: null,
        item: {
          __typename: "WarehouseItem",
          id: 1129746,
          artistId: 3,
          category: {
            __typename: "WarehouseCategory",
            id: 1,
            description: "Fine Art",
            weightPacked: 0,
          },
          categoryId: 1,
          container: null,
          description:
            "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
          destroyed: 0,
          dimh: 3,
          dimw: 2,
          dimd: 1,
          externalRef: "9",
          image: null,
          instanceId: 85099,
          itemDescription:
            "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
          link: null,
          mgroup: 1,
          notes: null,
          packing: {
            __typename: "WarehousePacking",
            id: 58,
            description: "Barrel",
            updatedAt: "2011-01-04T12:09:35.000Z",
          },
          packingId: 58,
          responsibleGroupId: 68,
          weight: 12,
          weightTypeId: 2,
        },
        itemId: 1129746,
        location: {
          id: 3,
          description: "Archive Room Display Cabinets",
          capacity: 100.5,
          siteId: 24,
        },
        locationId: 4,
        locref: null,
        shipment: {
          __typename: "Shipment",
          id: 91941,
          agent: null,
          bondRef: "GB1234",
          bondReleaseRef: null,
          cancel: 0,
          categoryId: 10,
          cds: null,
          condition: null,
          consigneeId: 134944,
          consignorId: 134940,
          currencyId: 2,
          customsDate: "2024-11-25",
          customsCode: "10 00 001",
          customsCodeMatch: null,
          customsCheck: 0,
          customsCheckDate: null,
          customsCheckUser: null,
          customsDeclaration: null,
          customsRef: null,
          customsRequest: 0,
          customsRequestDate: null,
          customsRequestUser: null,
          customsReceived: 0,
          customsReceivedDate: null,
          customsReceivedUser: null,
          date: "2024-11-07",
          declarant: null,
          delAddress: null,
          delAddress2: null,
          delAddress3: null,
          delCompany: "Luke Company Test",
          delContactId: 134944,
          delCountryId: null,
          delCounty: null,
          delivered: null,
          delName: "Luke Company Test LH",
          delPostcode: null,
          delTown: null,
          destination: null,
          eori: null,
          examined: null,
          guaranteeAccountId: null,
          incoTerm: 5,
          insurance: null,
          instructions: null,
          jobId: null,
          oriAddress: null,
          oriAddress2: null,
          oriAddress3: null,
          oriCompany: "White cube ltd",
          oriContactId: 134940,
          oriCountryId: null,
          oriCounty: null,
          oriName: "Charles Vtest",
          oriPostcode: null,
          oriTown: null,
          shipperId: 2539,
          shipping: null,
          shippingRef: null,
          time: null,
          itemCount: 2,
          totalValue: 6900,
          unconfirmedItemCount: 1,
          updatedAt: "2024-11-08T11:30:47.000Z",
        },
        shipmentId: 91941,
        siteId: 3,
        site: {
          description: "New York Upper Floors",
        },
        ti: 0,
        taDays: null,
        user: "soon",
        value: 5666,
      },
      {
        __typename: "WarehouseMove",
        bondref: null,
        date: "2024-11-18",
        goodsCode: null,
        id: 1221370,
        confirmed: null,
        item: {
          __typename: "WarehouseItem",
          id: 1129746,
          artistId: 3,
          category: {
            __typename: "WarehouseCategory",
            id: 1,
            description: "Fine Art",
            weightPacked: 0,
          },
          categoryId: 1,
          container: null,
          description:
            "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
          destroyed: 0,
          dimh: 3,
          dimw: 2,
          dimd: 1,
          externalRef: "9",
          image: null,
          instanceId: 85099,
          itemDescription: null,
          link: null,
          mgroup: 1,
          notes: null,
          packing: {
            __typename: "WarehousePacking",
            id: 58,
            description: "Barrel",
            updatedAt: "2011-01-04T12:09:35.000Z",
          },
          packingId: 58,
          responsibleGroupId: 68,
          weight: 12,
          weightTypeId: 2,
        },
        itemId: 1129746,
        location: {
          id: 2417,
          description: "Aisle 1",
          capacity: 100.5,
          siteId: 6,
          __typename: "WarehouseLocation",
        },
        locationId: null,
        locref: null,
        shipment: {
          __typename: "Shipment",
          id: 91948,
          agent: null,
          bondRef: "GB1234",
          bondReleaseRef: null,
          cancel: 0,
          categoryId: null,
          cds: null,
          condition: null,
          consigneeId: 4449,
          consignorId: 134953,
          currencyId: null,
          customsDate: null,
          customsCode: null,
          customsCodeMatch: null,
          customsCheck: 0,
          customsCheckDate: null,
          customsCheckUser: null,
          customsDeclaration: null,
          customsRef: null,
          customsRequest: 0,
          customsRequestDate: null,
          customsRequestUser: null,
          customsReceived: 0,
          customsReceivedDate: null,
          customsReceivedUser: null,
          date: "2024-11-18",
          declarant: null,
          delAddress: "144 - 152 Bermondsey Street",
          delAddress2: null,
          delAddress3: null,
          delCompany: "White Cube Limited [Bermondsey]",
          delContactId: 4449,
          delCountryId: 223,
          delCounty: "",
          delivered: null,
          delName: "null null",
          delPostcode: "SE1 3TQ",
          delTown: "London",
          destination: null,
          eori: null,
          examined: null,
          guaranteeAccountId: null,
          incoTerm: null,
          insurance: null,
          instructions: null,
          jobId: null,
          oriAddress: null,
          oriAddress2: null,
          oriAddress3: null,
          oriCompany: "ABC",
          oriContactId: 134953,
          oriCountryId: null,
          oriCounty: null,
          oriName: "charlessmith Second",
          oriPostcode: null,
          oriTown: null,
          shipperId: null,
          shipping: null,
          shippingRef: null,
          time: null,
          itemCount: 2,
          totalValue: null,
          unconfirmedItemCount: 2,
          updatedAt: "2024-11-18T16:56:48.000Z",
        },
        shipmentId: 91948,
        siteId: 1,
        site: {
          description: "Paris Back Rooms",
        },
        ti: null,
        taDays: null,
        user: "charles",
        value: null,
      },
    ],
    weight: 12,
    weightType: {
      __typename: "WarehouseWeightType",
      id: 2,
      name: "Packed Weight",
    },
    weightTypeId: 2,
  },
  {
    __typename: "WarehouseItem",
    id: 1129737,
    artist: null,
    artistId: null,
    category: {
      __typename: "WarehouseCategory",
      id: 1,
      description: "Fine Art",
      weightPacked: 0,
    },
    categoryId: 1,
    container: null,
    description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
    destroyed: 0,
    dimh: null,
    dimw: null,
    dimd: null,
    externalRef: null,
    image: null,
    instance: {
      __typename: "Instance",
      id: 85096,
      arrApplicable: false,
      artistRef: null,
      artsy: 0,
      channelEcommerce: 0,
      channelPresentation: 0,
      certificate: null,
      certificateSent: null,
      company: {
        __typename: "Company",
        id: 11,
        active: -1,
        bondMinValue: 200000,
        code: "JJ",
        cds: "GBTEA98256657400020220929113111",
        consignmentCredit: null,
        consignmentTerms:
          'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
        consignmentSignOff: "For and on behalf of White Cube Limited",
        contactId: 4449,
        createdAt: "2015-09-15T11:46:59.000Z",
        creditCode: "WCC",
        creditRef: 3371,
        crossInvoiceId: null,
        currencyId: 1,
        currency: {
          __typename: "Currency",
          id: 1,
          code: "GBP",
          description: "Pounds Sterling",
          name: null,
        },
        hmrcAddress:
          "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
        invoiceCode: "WCA",
        invoiceDue: "1m",
        loanTerms:
          "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
        loanSignOff: "White Cube Limited acting as agent for the Artist",
        photoCredit: null,
        name: "White Cube Limited",
        notes: null,
        shippingEmail: null,
        vatno: "GB982 566 574",
      },
      condition: null,
      createdAt: "2024-06-28T16:42:45.000Z",
      description: "Darren Almond\nT0206037\n2022\n\n\nJJ76550\n",
      edition: {
        __typename: "Edition",
        id: 51805,
        ap: 0,
        artwork: {
          __typename: "Artwork",
          id: 88422,
          artFair: null,
          artists: [
            {
              __typename: "Artist",
              id: 5,
              bornCountry: {
                __typename: "Country",
                id: 223,
                continent: "United Kingdom",
                digraph: "UK",
                name: "United Kingdom",
                sagecode: 0,
                updatedAt: "2024-03-20T15:30:43.000Z",
              },
              bornCountryId: 223,
              bornDate: "30.08.72",
              bornTown: "",
              confidential: 0,
              contactId: 5,
              copyright: "© Darren Almond",
              defaultFabRate: 50,
              defaultSplitRate: 50,
              droitdesuite: -1,
              mailingList: null,
              name: "Darren Almond",
              represented: 0,
              sageCost: "ALM",
              sharedDiscount: 10,
              terms: "terms",
            },
          ],
          artworkCategory: {
            __typename: "ArtworkCategory",
            id: 12,
            name: "Exhibition",
            goodsCode: null,
          },
          authenticity: null,
          categoryId: 12,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2023-11-06T11:41:25.000Z",
          description: null,
          dimensions: "\n ",
          goodsCode: null,
          installation: null,
          installationLink: null,
          maintenance: null,
          medium: null,
          packing: null,
          photographed: null,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: null,
          standardId: null,
          technicalDimensions: null,
          timestamp: "2024-07-04T10:21:32.000Z",
          title: "T0206037",
          travelPack: -1,
          videoLink: null,
          website: 0,
        },
        year: "2022",
        number: 1,
      },
      editionNumber: 1,
      fabricated: null,
      fabricatedDate: null,
      forSale: 0,
      framed: null,
      ipad: -1,
      bondType: null,
      isBond: false,
      isGuaranteed: false,
      isOnLoan: false,
      isSecondaryMarket: false,
      locationHistory: null,
      name: "JJ76550",
      notes: null,
      parentOnline: 0,
      ref: 76550,
      reference: null,
      returns: 0,
      returnsDirector: 0,
      status: {
        __typename: "Status",
        id: 3,
        name: "Sold",
        online: true,
        createdAt: "2015-09-18T11:54:30.000Z",
      },
      statusId: 3,
      salesPrice: null,
      salesStrategy: null,
      statusHistory: null,
      unpackedWeight: null,
      updatedAt: "2024-11-01T14:55:42.000Z",
      value: {
        __typename: "Value",
        id: 85606,
        authorisedId: 1020,
        currency: {
          __typename: "Currency",
          id: 1,
          code: "GBP",
          description: "Pounds Sterling",
          name: null,
        },
        currencyId: 1,
        date: "2024-07-09",
        maxDiscount: null,
        notes: null,
        typeId: 2,
        userId: 1020,
        value: 14500,
        grossProfit: 7250,
      },
      volume: 0,
      weight: null,
      location: "  ",
    },
    instanceId: 85096,
    itemDescription:
      "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
    itemSite: {
      __typename: "WarehouseMove",
      bondref: null,
      date: "2024-07-04",
      goodsCode: null,
      id: 1221328,
      confirmed: null,
      item: {
        __typename: "WarehouseItem",
        id: 1129737,
        artistId: null,
        category: {
          __typename: "WarehouseCategory",
          id: 1,
          description: "Fine Art",
          weightPacked: 0,
        },
        categoryId: 1,
        container: null,
        description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
        destroyed: 0,
        dimh: null,
        dimw: null,
        dimd: null,
        externalRef: null,
        image: null,
        instanceId: 85096,
        itemDescription: null,
        link: null,
        mgroup: null,
        notes: null,
        packing: null,
        packingId: null,
        responsibleGroupId: null,
        weight: null,
        weightTypeId: 1,
      },
      itemId: 1129737,
      location: {
        id: 2417,
        description: "Aisle 1",
        capacity: 100.5,
        siteId: 6,
        __typename: "WarehouseLocation",
      },
      locationId: null,
      locref: null,
      shipment: {
        __typename: "Shipment",
        id: 69,
        agent: null,
        bondRef: "GB1234",
        bondReleaseRef: null,
        cancel: 0,
        categoryId: null,
        cds: null,
        condition: null,
        consigneeId: 2551,
        consignorId: 2551,
        currencyId: null,
        customsDate: null,
        customsCode: null,
        customsCodeMatch: null,
        customsCheck: null,
        customsCheckDate: null,
        customsCheckUser: null,
        customsDeclaration: null,
        customsRef: null,
        customsRequest: null,
        customsRequestDate: null,
        customsRequestUser: null,
        customsReceived: null,
        customsReceivedDate: null,
        customsReceivedUser: null,
        date: "2001-05-17",
        declarant: null,
        delAddress: "20 Mansfield Street",
        delAddress2: "",
        delAddress3: "",
        delCompany: null,
        delContactId: 2551,
        delCountryId: 223,
        delCounty: "",
        delivered: "2001-05-17",
        delName: "Jay Jopling and Sam Taylor-Wood",
        delPostcode: "W1G 9NP",
        delTown: "London",
        destination: null,
        eori: null,
        examined: null,
        guaranteeAccountId: null,
        incoTerm: null,
        insurance: null,
        instructions: "Mansfield St",
        jobId: null,
        oriAddress: "20 Mansfield Street",
        oriAddress2: null,
        oriAddress3: "",
        oriCompany: null,
        oriContactId: 2551,
        oriCountryId: 223,
        oriCounty: "",
        oriName: "Jay Jopling and Sam Taylor-Wood 020 7566 5870 sam studio",
        oriPostcode: "W1G 9NP",
        oriTown: "London",
        shipperId: null,
        shipping: null,
        shippingRef: "",
        time: null,
        itemCount: 5,
        totalValue: null,
        unconfirmedItemCount: 4,
        updatedAt: "2005-12-22T11:30:21.000Z",
      },
      shipmentId: 69,
      siteId: 3,
      site: {
        description: "New York Upper Floors",
      },
      ti: null,
      taDays: null,
      user: "soon",
      value: null,
    },
    link: null,
    mgroup: null,
    notes: null,
    packing: null,
    packingId: null,
    responsibleGroupId: null,
    warehouseMoves: [
      {
        __typename: "WarehouseMove",
        bondref: null,
        date: "2024-07-04",
        goodsCode: null,
        id: 1221328,
        capacityUsed: 20,
        confirmed: null,
        item: {
          __typename: "WarehouseItem",
          id: 1129737,
          artistId: null,
          category: {
            __typename: "WarehouseCategory",
            id: 1,
            description: "Fine Art",
            weightPacked: 0,
          },
          categoryId: 1,
          container: null,
          description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
          destroyed: 0,
          dimh: null,
          dimw: null,
          dimd: null,
          externalRef: null,
          image: null,
          instanceId: 85096,
          itemDescription: null,
          link: null,
          mgroup: null,
          notes: null,
          packing: null,
          packingId: null,
          responsibleGroupId: null,
          weight: null,
          weightTypeId: 1,
        },
        itemId: 1129737,
        location: {
          id: 3,
          description: "Bermonsey",
          capacity: 100.5,
          siteId: 24,
        },
        locationId: null,
        locref: null,
        shipment: {
          __typename: "Shipment",
          id: 69,
          agent: null,
          bondRef: "GB1234",
          bondReleaseRef: null,
          cancel: 0,
          categoryId: null,
          cds: null,
          condition: null,
          consigneeId: 2551,
          consignorId: 2551,
          currencyId: null,
          customsDate: null,
          customsCode: null,
          customsCodeMatch: null,
          customsCheck: null,
          customsCheckDate: null,
          customsCheckUser: null,
          customsDeclaration: null,
          customsRef: null,
          customsRequest: null,
          customsRequestDate: null,
          customsRequestUser: null,
          customsReceived: null,
          customsReceivedDate: null,
          customsReceivedUser: null,
          date: "2001-05-17",
          declarant: null,
          delAddress: "20 Mansfield Street",
          delAddress2: "",
          delAddress3: "",
          delCompany: null,
          delContactId: 2551,
          delCountryId: 223,
          delCounty: "",
          delivered: "2001-05-17",
          delName: "Jay Jopling and Sam Taylor-Wood",
          delPostcode: "W1G 9NP",
          delTown: "London",
          destination: null,
          eori: null,
          examined: null,
          guaranteeAccountId: null,
          incoTerm: null,
          insurance: null,
          instructions: "Mansfield St",
          jobId: null,
          oriAddress: "20 Mansfield Street",
          oriAddress2: null,
          oriAddress3: "",
          oriCompany: null,
          oriContactId: 2551,
          oriCountryId: 223,
          oriCounty: "",
          oriName: "Jay Jopling and Sam Taylor-Wood 020 7566 5870 sam studio",
          oriPostcode: "W1G 9NP",
          oriTown: "London",
          shipperId: null,
          shipping: null,
          shippingRef: "",
          time: null,
          itemCount: 5,
          totalValue: null,
          unconfirmedItemCount: 4,
          updatedAt: "2005-12-22T11:30:21.000Z",
        },
        shipmentId: 69,
        siteId: 1,
        site: {
          description: "Bermondsey Lower basement",
        },
        ti: null,
        taDays: null,
        user: "soon",
        value: null,
      },
    ],
    weight: null,
    weightType: {
      __typename: "WarehouseWeightType",
      id: 1,
      name: "Unpacked Weight",
    },
    weightTypeId: 1,
  },
];

export const shipments = [
  {
    __typename: "Shipment",
    id: 92641,
    agent: null,
    bondRef: "GB1234",
    bondReleaseRef: null,
    cancel: 0,
    category: null,
    cds: "GBTEA982566574000202209123412",
    condition: null,
    consignee: {
      id: 136440,
      address: "Martin-Heidegger-Str. 16b",
      address2: " Zimmer 038",
      address3: "address_3",
      affiliations: "None",
      biography:
        "commodo ipsum. Suspendisse non leo. Vivamus nibh dolor, nonummy ac,",
      collection:
        "tincidunt vehicula risus. Nulla eget metus eu erat semper rutrum.",
      collectionActive: -1,
      company: "COMPANY_136440_SCRUBBED",
      confidential: 0,
      contactNumbers: [
        {
          id: 25993,
          donotcall: 0,
          identifier: null,
          number: "020 7930 5373",
          prefere: 0,
          typeId: 4,
          __typename: "ContactNumber",
        },
        {
          id: 25994,
          donotcall: 0,
          identifier: null,
          number: "020 7749 7460 / 7621",
          prefere: 0,
          typeId: 5,
          __typename: "ContactNumber",
        },
      ],
      contactSecondary: true,
      country: {
        id: 223,
        continent: "United Kingdom",
        digraph: "UK",
        name: "United Kingdom",
        sagecode: 0,
        updatedAt: "2024-03-20T15:30:43.000Z",
        __typename: "Country",
      },
      countryId: 225,
      county: " Jaredburg",
      createdAt: "2023-12-04T19:19:25.000Z",
      details: "a mi fringilla mi lacinia mattis. Integer eu lacus. Quisque",
      dob: "2020-01-01",
      email: "whitecube-238140@crvnprojects.com",
      eori: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: "New  York",
      firstcontacttype: 4,
      firstUserId: 1074,
      forename: "Ivan_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 0,
      level: 5,
      mailingname: "Rhiannon Burke",
      middlename: null,
      name: "Ivan_SCRUBBED Wilkerson",
      notes:
        "eget ipsum. Suspendisse sagittis. Nullam vitae diam. Proin dolor. Nulla",
      postcode: " 46157",
      prefered:
        "quis lectus. Nullam suscipit, est ac facilisis facilisis, magna tellus",
      rating: null,
      sagecode: null,
      salesUserId: 1074,
      salesUser2Id: null,
      salutation: "Ezra_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Wilkerson",
      title: null,
      town: " Jaredburg",
      typeId: 4,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:32:42.000Z",
      vat: "VAT_EX",
      __typename: "Contact",
    },
    consigneeId: 136440,
    consignor: {
      id: 136437,
      address: "877 Funk Keys",
      address2: " Apt. 235",
      address3: "address_3",
      affiliations: "None",
      biography:
        "litora torquent per conubia nostra, per inceptos hymenaeos. Mauris ut",
      collection:
        "consectetuer, cursus et, magna. Praesent interdum ligula eu enim. Etiam",
      collectionActive: -1,
      company: "COMPANY_136437_SCRUBBED",
      confidential: 0,
      contactNumbers: [
        {
          id: 25993,
          donotcall: 0,
          identifier: null,
          number: "020 7930 5373",
          prefere: 0,
          typeId: 4,
          __typename: "ContactNumber",
        },
        {
          id: 25994,
          donotcall: 0,
          identifier: null,
          number: "020 7749 7460 / 7621",
          prefere: 0,
          typeId: 5,
          __typename: "ContactNumber",
        },
      ],
      contactSecondary: true,
      country: {
        id: 223,
        continent: "United Kingdom",
        digraph: "UK",
        name: "United Kingdom",
        sagecode: 0,
        updatedAt: "2024-03-20T15:30:43.000Z",
        __typename: "Country",
      },
      countryId: 225,
      county: " Veyrier",
      createdAt: "2023-12-04T18:33:03.000Z",
      details:
        "Etiam laoreet, libero et tristique pellentesque, tellus sem mollis dui,",
      dob: "2020-01-01",
      email: null,
      eori: null,
      exhUserId: null,
      firstcontactdate: "2023-12-04",
      firstcontactlocation: "Miami",
      firstcontacttype: 12,
      firstUserId: 701,
      forename: "Wallace_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 0,
      level: 5,
      mailingname: "Brielle Yates",
      middlename: null,
      name: "Wallace_SCRUBBED Sexton",
      notes: "nec, mollis vitae, posuere at, velit. Cras lorem lorem, luctus",
      postcode: " 8086",
      prefered:
        "montes, nascetur ridiculus mus. Proin vel nisl. Quisque fringilla euismod",
      rating: null,
      sagecode: null,
      salesUserId: 701,
      salesUser2Id: null,
      salutation: "Orli_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Sexton",
      title: null,
      town: " Veyrier",
      typeId: 4,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:32:42.000Z",
      vat: "VAT_EX",
      __typename: "Contact",
    },
    consignorId: 136437,
    currency: {
      id: 2,
      code: "USD",
      description: "US Dollars",
      name: null,
      __typename: "Currency",
    },
    currencyId: 2,
    customsDate: null,
    customsCode: null,
    customsCodeMatch: null,
    customsCheck: 0,
    customsCheckDate: null,
    customsCheckUser: null,
    customsDeclaration: "Example customs declaration",
    customsRef: null,
    customsRequest: 0,
    customsRequestDate: null,
    customsRequestUser: null,
    customsReceived: 0,
    customsReceivedDate: null,
    customsReceivedUser: null,
    date: "2023-12-05",
    declarant: "Declarant Name",
    delAddress: "276 Marvin Islands",
    delAddress2: " Apt. 499",
    delAddress3: "address_3",
    delCompany: "COMPANY_136440_SCRUBBED",
    delContactId: 136440,
    delCountry: {
      id: 223,
      continent: "United Kingdom",
      digraph: "UK",
      name: "United Kingdom",
      sagecode: 0,
      updatedAt: "2024-03-20T15:30:43.000Z",
      __typename: "Country",
    },
    delCountryId: 223,
    delCounty: " Port Lempiburgh",
    delivered: null,
    delName: "Yolanda_SCRUBBED Hess",
    delPostcode: " 45874-9139",
    delTown: " Port Lempiburgh",
    destination: null,
    eori: "GB-123456-00",
    examined: null,
    guaranteeAccountId: null,
    incoTerm: null,
    insurance: null,
    instructions: null,
    jobId: "81235",
    oriAddress: "Piazza Marangon 490",
    oriAddress2: " Appartamento 38",
    oriAddress3: "address_3",
    oriCompany: "COMPANY_136437_SCRUBBED",
    oriContact: {
      id: 136437,
      address: "877 Funk Keys",
      address2: " Apt. 235",
      address3: "address_3",
      affiliations: "None",
      biography:
        "litora torquent per conubia nostra, per inceptos hymenaeos. Mauris ut",
      collection:
        "consectetuer, cursus et, magna. Praesent interdum ligula eu enim. Etiam",
      collectionActive: -1,
      company: "COMPANY_136437_SCRUBBED",
      confidential: 0,
      contactNumbers: [
        {
          id: 25993,
          donotcall: 0,
          identifier: null,
          number: "020 7930 5373",
          prefere: 0,
          typeId: 4,
          __typename: "ContactNumber",
        },
        {
          id: 25994,
          donotcall: 0,
          identifier: null,
          number: "020 7749 7460 / 7621",
          prefere: 0,
          typeId: 5,
          __typename: "ContactNumber",
        },
      ],
      contactSecondary: true,
      country: {
        id: 223,
        continent: "United Kingdom",
        digraph: "UK",
        name: "United Kingdom",
        sagecode: 0,
        updatedAt: "2024-03-20T15:30:43.000Z",
        __typename: "Country",
      },
      countryId: 225,
      county: " Veyrier",
      createdAt: "2023-12-04T18:33:03.000Z",
      details:
        "Etiam laoreet, libero et tristique pellentesque, tellus sem mollis dui,",
      dob: "2020-01-01",
      email: null,
      eori: null,
      exhUserId: null,
      firstcontactdate: "2023-12-04",
      firstcontactlocation: "Miami",
      firstcontacttype: 12,
      firstUserId: 701,
      forename: "Wallace_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 0,
      level: 5,
      mailingname: "Brielle Yates",
      middlename: null,
      name: "Wallace_SCRUBBED Sexton",
      notes: "nec, mollis vitae, posuere at, velit. Cras lorem lorem, luctus",
      postcode: " 8086",
      prefered:
        "montes, nascetur ridiculus mus. Proin vel nisl. Quisque fringilla euismod",
      rating: null,
      sagecode: null,
      salesUserId: 701,
      salesUser2Id: null,
      salutation: "Orli_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Sexton",
      title: null,
      town: " Veyrier",
      typeId: 4,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:32:42.000Z",
      vat: null,
      __typename: "Contact",
    },
    oriContactId: 136437,
    oriCountry: {
      id: 225,
      continent: "North America",
      digraph: "US",
      name: "United States",
      sagecode: 2,
      updatedAt: "2023-05-22T11:39:04.000Z",
      __typename: "Country",
    },
    oriCountryId: 225,
    oriCounty: " 36842",
    oriName: "Kenneth_SCRUBBED Adams",
    oriPostcode: " Appartamento 64",
    oriTown: " 36842",
    shipmentDescriptions:
      "1129324\r\nFine Art\r\n33 x 27 x 25.4 cm\r\nMore of You\r\n2015\r\nNeon\r\n52 3/8 x 58 11/16 in. (133 x 149 cm)\r\nJJ74883\r\n\r\n1129318\r\nFine Art\r\n0 x 0 x 0 cm\r\nWe Were Promised a Fat One\r\n2023\r\nPen and acrylic on paper\r\n18 x 24 in. (45.7 x 61 cm)\r\nJJ76197\r\n\r\n1129319\r\nFine Art\r\n0 x 0 x 0 cm\r\nLiberty sat uneasy\r\n2023\r\nPen and acrylic on paper\r\n24 x 18 in. (61 x 45.7 cm)\r\n26 3/8 x 20 3/8 x 1 1/2 in. (67 x 51.8 x 3.8 cm) (framed)\r\nJJ76198",
    shipper: {
      id: 100003,
      address: "Gamle Elvevika 50",
      address2: "Oppgang B",
      address3: "address_3",
      affiliations: "None",
      biography: "Curabitur ut odio vel est tempor bibendum. Donec felis orci,",
      collection:
        "pede. Cum sociis natoque penatibus et magnis dis parturient montes,",
      collectionActive: null,
      company: "Shipper Company Name",
      confidential: 0,
      contactNumbers: [
        {
          id: 25993,
          donotcall: 0,
          identifier: null,
          number: "020 7930 5373",
          prefere: 0,
          typeId: 4,
          __typename: "ContactNumber",
        },
        {
          id: 25994,
          donotcall: 0,
          identifier: null,
          number: "020 7749 7460 / 7621",
          prefere: 0,
          typeId: 5,
          __typename: "ContactNumber",
        },
      ],
      contactSecondary: true,
      country: {
        id: 223,
        continent: "United Kingdom",
        digraph: "UK",
        name: "United Kingdom",
        sagecode: 0,
        updatedAt: "2024-03-20T15:30:43.000Z",
        __typename: "Country",
      },
      countryId: 223,
      county: " Maly",
      createdAt: "2016-09-16T09:54:32.000Z",
      details: "tempor, est ac mattis semper, dui lectus rutrum urna, nec",
      dob: "2020-01-01",
      email: "whitecube-186370@crvnprojects.com",
      eori: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: null,
      firstcontacttype: null,
      firstUserId: null,
      forename: "Melissa_SCRUBBED",
      greeting: "Dear",
      img: null,
      invoicesLength: 0,
      level: null,
      mailingname: "Brielle Yates",
      middlename: null,
      name: "Melissa_SCRUBBED Clemons",
      notes:
        "feugiat placerat velit. Quisque varius. Nam porttitor scelerisque neque. Nullam",
      postcode: " 9061",
      prefered:
        "metus. In lorem. Donec elementum, lorem ut aliquam iaculis, lacus",
      rating: null,
      sagecode: null,
      salesUserId: null,
      salesUser2Id: null,
      salutation: "Merrill_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Clemons",
      title: null,
      town: " Maly",
      typeId: 2,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T06:44:48.000Z",
      vat: null,
      __typename: "Contact",
    },
    shipperId: 100003,
    shipping: null,
    shippingRef: "Ref.12345",
    time: null,
    itemCount: 3,
    totalValue: null,
    unconfirmedItemCount: 0,
    updatedAt: "2023-12-05T13:14:39.000Z",
    warehouseMoves: [
      {
        bondref: "1234",
        date: "2024-09-23",
        goodsCode: null,
        id: 1285363,
        confirmed: null,
        item: {
          id: 1129761,
          artist: {
            id: 83,
            bornCountry: {
              id: 122,
              continent: "Middle East and North Africa ",
              digraph: "LB",
              name: "Lebanon",
              sagecode: 4,
              updatedAt: "2024-03-20T15:25:03.000Z",
              __typename: "Country",
            },
            bornCountryId: 122,
            bornDate: null,
            bornTown: "",
            confidential: 0,
            contactId: 83,
            copyright: "© Mona Hatoum",
            defaultFabRate: 60,
            defaultSplitRate: 60,
            droitdesuite: -1,
            mailingList: null,
            name: "Mona Hatoum",
            represented: 1,
            sageCost: "HAT",
            sharedDiscount: 10,
            terms: null,
            __typename: "Artist",
          },
          artistId: 83,
          category: {
            id: 9,
            description: "Plinth",
            weightPacked: 0,
            __typename: "WarehouseCategory",
          },
          categoryId: 9,
          container: null,
          description: "Phillip Allen\nTest new sysem\n1999\n1 of 2\nJJ76551",
          destroyed: 0,
          dimh: 10,
          dimw: 10,
          dimd: 10,
          externalRef: "123",
          image: null,
          instance: {
            id: 85259,
            artistRef: "artistRef",
            artsy: 0,
            channelEcommerce: 0,
            channelPresentation: 0,
            certificate: null,
            certificateSent: null,
            createdAt: "2024-11-19T19:56:21.000Z",
            edition: {
              id: 51903,
              ap: 0,
              artwork: {
                id: 188544,
                artFair: null,
                artists: [
                  {
                    id: 4,
                    bornCountry: null,
                    bornCountryId: null,
                    bornDate: null,
                    bornTown: "",
                    confidential: 0,
                    contactId: 4,
                    copyright: null,
                    defaultFabRate: null,
                    defaultSplitRate: null,
                    droitdesuite: -1,
                    mailingList: null,
                    name: "Phillip Allen",
                    represented: 3,
                    sageCost: null,
                    sharedDiscount: null,
                    terms: null,
                    __typename: "Artist",
                  },
                ],
                artworkCategory: {
                  id: 4,
                  name: "Painting",
                  goodsCode: "970110",
                  __typename: "ArtworkCategory",
                },
                authenticity: null,
                categoryId: 4,
                classId: 1,
                confidential: 0,
                countryOfOriginId: 65,
                createdAt: "2024-11-19T12:11:34.000Z",
                description: "New item",
                dimensions: "4.72 x 4.72 x 6.30 in. | (12 x 12 x 16 cm)",
                goodsCode: "970110",
                installation: null,
                installationLink: null,
                maintenance: null,
                medium: "Glass",
                packing: null,
                photographed: null,
                photoLink: null,
                photoNote: null,
                precis: null,
                reference: null,
                series: "2",
                standardId: 0,
                technicalDimensions: null,
                timestamp: "2024-11-19T12:12:25.000Z",
                title: "The Guards",
                travelPack: -1,
                videoLink: null,
                website: 0,
                __typename: "Artwork",
              },
              year: "2021",
              number: 3,
              __typename: "Edition",
            },
            editionNumber: 2,
            fabricated: null,
            fabricatedDate: null,
            forSale: 0,
            framed: null,
            ipad: 0,
            bondType: null,
            locationHistory: null,
            market: null,
            name: "WCK4",
            notes: null,
            parentOnline: 0,
            ref: 76681,
            reference: null,
            returns: 0,
            returnsDirector: 0,
            statusId: 0,
            salesPrice: null,
            salesStrategy: null,
            statusHistory: null,
            updatedAt: "2024-12-23T11:43:38.000Z",
            __typename: "Instance",
          },
          instanceId: 85097,
          itemDescription: "test",
          link: null,
          mgroup: null,
          notes: null,
          packing: {
            id: 34,
            description: "Standard Case",
            updatedAt: "2014-03-06T16:16:01.000Z",
            __typename: "WarehousePacking",
          },
          packingId: 31,
          responsibleGroupId: null,
          weight: 12,
          weightTypeId: 1,
          __typename: "WarehouseItem",
        },
        itemId: 1129761,
        location: {
          id: 2417,
          description: "Aisle 1",
          capacity: 100.5,
          siteId: 6,
          __typename: "WarehouseLocation",
        },
        locationId: 2417,
        locref: null,
        shipment: {
          id: 92028,
          agent: "Test",
          bondRef: "GB1234",
          bondReleaseRef: null,
          cancel: 0,
          categoryId: null,
          cds: "GBTEA98256657400020220929113111",
          condition: null,
          consigneeId: 4449,
          consignorId: 4449,
          currencyId: 1,
          customsDate: null,
          customsCode: null,
          customsCodeMatch: null,
          customsCheck: 0,
          customsCheckDate: null,
          customsCheckUser: null,
          customsDeclaration: null,
          customsRef: null,
          customsRequest: 0,
          customsRequestDate: null,
          customsRequestUser: null,
          customsReceived: 0,
          customsReceivedDate: null,
          customsReceivedUser: null,
          date: "2024-09-23",
          declarant: null,
          delAddress: "144 - 152 Bermondsey Street",
          delAddress2: null,
          delAddress3: null,
          delCompany: "White Cube Limited [Bermondsey]",
          delContactId: 4449,
          delCountryId: 223,
          delCounty: "",
          delivered: "2024-09-23",
          delName: "null null",
          delPostcode: "SE1 3TQ",
          delTown: "London",
          destination: 3,
          eori: "GB982566574000",
          examined: 1,
          guaranteeAccountId: null,
          incoTerm: null,
          insurance: null,
          instructions: "Test",
          jobId: null,
          oriAddress: "144 - 152 Bermondsey Street",
          oriAddress2: null,
          oriAddress3: null,
          oriCompany: "White Cube Limited [Bermondsey]",
          oriContactId: 4449,
          oriCountryId: 223,
          oriCounty: "",
          oriName: " ",
          oriPostcode: "SE1 3TQ",
          oriTown: "London",
          shipperId: null,
          shipping: 3,
          shippingRef: null,
          time: null,
          itemCount: 2,
          totalValue: null,
          unconfirmedItemCount: 0,
          updatedAt: "2024-10-01T09:30:44.000Z",
          __typename: "Shipment",
        },
        shipmentId: 92028,
        siteId: 6,
        site: {
          id: 6,
          name: "Bermondsey",
          updatedAt: "2019-05-20T16:53:05.000Z",
          __typename: "WarehouseSite",
        },
        ti: null,
        taDays: null,
        user: "charles",
        value: null,
        __typename: "WarehouseMove",
      },
      {
        bondref: null,
        date: "2024-09-23",
        goodsCode: null,
        id: 1285363,
        confirmed: null,
        item: {
          id: 1129761,
          artist: {
            id: 83,
            bornCountry: {
              id: 122,
              continent: "Middle East and North Africa ",
              digraph: "LB",
              name: "Lebanon",
              sagecode: 4,
              updatedAt: "2024-03-20T15:25:03.000Z",
              __typename: "Country",
            },
            bornCountryId: 122,
            bornDate: null,
            bornTown: "",
            confidential: 0,
            contactId: 83,
            copyright: "© Mona Hatoum",
            defaultFabRate: 60,
            defaultSplitRate: 60,
            droitdesuite: -1,
            mailingList: null,
            name: "Mona Hatoum",
            represented: 1,
            sageCost: "HAT",
            sharedDiscount: 10,
            terms: null,
            __typename: "Artist",
          },
          artistId: 83,
          category: {
            id: 9,
            description: "Plinth",
            weightPacked: 0,
            __typename: "WarehouseCategory",
          },
          categoryId: 9,
          container: null,
          description: "Phillip Allen\nTest new sysem\n1999\n1 of 2\nJJ76551",
          destroyed: 0,
          dimh: 10,
          dimw: 10,
          dimd: 10,
          externalRef: "123",
          image: null,
          instance: {
            id: 85259,
            artistRef: "artistRef",
            artsy: 0,
            channelEcommerce: 0,
            channelPresentation: 0,
            certificate: null,
            certificateSent: null,
            createdAt: "2024-11-19T19:56:21.000Z",
            edition: {
              id: 51903,
              ap: 0,
              artwork: {
                id: 188544,
                artFair: null,
                artists: [
                  {
                    id: 4,
                    bornCountry: null,
                    bornCountryId: null,
                    bornDate: null,
                    bornTown: "",
                    confidential: 0,
                    contactId: 4,
                    copyright: null,
                    defaultFabRate: null,
                    defaultSplitRate: null,
                    droitdesuite: -1,
                    mailingList: null,
                    name: "Phillip Allen",
                    represented: 3,
                    sageCost: null,
                    sharedDiscount: null,
                    terms: null,
                    __typename: "Artist",
                  },
                ],
                artworkCategory: {
                  id: 4,
                  name: "Painting",
                  goodsCode: "970110",
                  __typename: "ArtworkCategory",
                },
                authenticity: null,
                categoryId: 4,
                classId: 1,
                confidential: 0,
                countryOfOriginId: 65,
                createdAt: "2024-11-19T12:11:34.000Z",
                description: "New item",
                dimensions: "4.72 x 4.72 x 6.30 in. | (12 x 12 x 16 cm)",
                goodsCode: "970110",
                installation: null,
                installationLink: null,
                maintenance: null,
                medium: "Glass",
                packing: null,
                photographed: null,
                photoLink: null,
                photoNote: null,
                precis: null,
                reference: null,
                series: "2",
                standardId: 0,
                technicalDimensions: null,
                timestamp: "2024-11-19T12:12:25.000Z",
                title: "The Guards",
                travelPack: -1,
                videoLink: null,
                website: 0,
                __typename: "Artwork",
              },
              year: "2021",
              number: 3,
              __typename: "Edition",
            },
            editionNumber: 2,
            fabricated: null,
            fabricatedDate: null,
            forSale: 0,
            framed: null,
            ipad: 0,
            bondType: null,
            locationHistory: null,
            market: null,
            name: "WCK4",
            notes: null,
            parentOnline: 0,
            ref: 76681,
            reference: null,
            returns: 0,
            returnsDirector: 0,
            statusId: 0,
            salesPrice: null,
            salesStrategy: null,
            statusHistory: null,
            updatedAt: "2024-12-23T11:43:38.000Z",
            __typename: "Instance",
          },
          instanceId: 85097,
          itemDescription: "test",
          link: null,
          mgroup: null,
          notes: null,
          packing: {
            id: 34,
            description: "Standard Case",
            updatedAt: "2014-03-06T16:16:01.000Z",
            __typename: "WarehousePacking",
          },
          packingId: 31,
          responsibleGroupId: null,
          weight: 12,
          weightTypeId: 1,
          __typename: "WarehouseItem",
        },
        itemId: 1129761,
        location: {
          id: 2417,
          description: "Aisle 1",
          siteId: 6,
          __typename: "WarehouseLocation",
        },
        locationId: 2417,
        locref: null,
        shipment: {
          id: 92028,
          agent: "Test",
          bondRef: "GB1234",
          bondReleaseRef: null,
          cancel: 0,
          categoryId: null,
          cds: "GBTEA98256657400020220929113111",
          condition: null,
          consigneeId: 4449,
          consignorId: 4449,
          currencyId: 1,
          customsDate: null,
          customsCode: null,
          customsCodeMatch: null,
          customsCheck: 0,
          customsCheckDate: null,
          customsCheckUser: null,
          customsDeclaration: null,
          customsRef: null,
          customsRequest: 0,
          customsRequestDate: null,
          customsRequestUser: null,
          customsReceived: 0,
          customsReceivedDate: null,
          customsReceivedUser: null,
          date: "2024-09-23",
          declarant: null,
          delAddress: "144 - 152 Bermondsey Street",
          delAddress2: null,
          delAddress3: null,
          delCompany: "White Cube Limited [Bermondsey]",
          delContactId: 4449,
          delCountryId: 223,
          delCounty: "",
          delivered: "2024-09-23",
          delName: "null null",
          delPostcode: "SE1 3TQ",
          delTown: "London",
          destination: 3,
          eori: "GB982566574000",
          examined: 1,
          guaranteeAccountId: null,
          incoTerm: null,
          insurance: null,
          instructions: "Test",
          jobId: null,
          oriAddress: "144 - 152 Bermondsey Street",
          oriAddress2: null,
          oriAddress3: null,
          oriCompany: "White Cube Limited [Bermondsey]",
          oriContactId: 4449,
          oriCountryId: 223,
          oriCounty: "",
          oriName: " ",
          oriPostcode: "SE1 3TQ",
          oriTown: "London",
          shipperId: null,
          shipping: 3,
          shippingRef: null,
          time: null,
          itemCount: 2,
          totalValue: null,
          unconfirmedItemCount: 0,
          updatedAt: "2024-10-01T09:30:44.000Z",
          __typename: "Shipment",
        },
        shipmentId: 92028,
        siteId: 6,
        site: {
          id: 6,
          name: "Bermondsey",
          updatedAt: "2019-05-20T16:53:05.000Z",
          __typename: "WarehouseSite",
        },
        ti: null,
        taDays: null,
        user: "charles",
        value: null,
        __typename: "WarehouseMove",
      },
    ],
  },
];

export const artworks = [
  {
    __typename: "Artwork",
    id: 89627,
    artFair: null,
    artists: [
      {
        __typename: "Artist",
        id: 83,
        bornCountry: {
          __typename: "Country",
          id: 122,
          continent: "Middle East and North Africa ",
          digraph: "LB",
          name: "Lebanon",
          sagecode: 4,
          updatedAt: "2024-03-20T15:25:03.000Z",
        },
        bornCountryId: 122,
        bornDate: null,
        bornTown: "",
        confidential: 0,
        contactId: 83,
        copyright: "© Mona Hatoum",
        defaultFabRate: 60,
        defaultSplitRate: 60,
        droitdesuite: -1,
        mailingList: null,
        name: "Mona Hatoum",
        represented: 0,
        sageCost: "HAT",
        sharedDiscount: 10,
        terms: "terms",
      },
    ],
    artistDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\n\n",
    authenticity: null,
    categoryId: 10,
    classId: null,
    confidential: 0,
    countryOfOriginId: null,
    createdAt: "2024-02-23T11:13:17.000Z",
    description: null,
    dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
    editions: [
      {
        id: 53050,
        ap: 0,
        artwork: {
          id: 89627,
          artFair: null,
          authenticity: null,
          categoryId: 10,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2024-02-23T11:13:17.000Z",
          description: null,
          dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
          goodsCode: "970110",
          installation: null,
          installationLink: null,
          maintenance: null,
          medium: "Oil, ink and pencil on paper",
          packing: null,
          photographed: -1,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "test",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2024-02-23T11:14:01.000Z",
          title: "Who Cares Wins",
          travelPack: -1,
          videoLink: null,
          website: 0,
          __typename: "Artwork",
        },
        availableNumbers: [],
        instances: [
          {
            id: 86483,
            artistRef: null,
            artsy: 0,
            channelEcommerce: 0,
            channelPresentation: 0,
            certificate: null,
            certificateSent: null,
            createdAt: "2024-02-23T11:14:07.000Z",
            editionNumber: 1,
            fabricated: null,
            fabricatedDate: null,
            forSale: 0,
            framed: null,
            ipad: 0,
            locationHistory: "New York",
            name: "JJ77935",
            notes:
              "For Soraya\r\n- No condition check, no photography\r\nCOA to be generated",
            parentOnline: 0,
            ref: 36972,
            reference: null,
            returns: 0,
            returnsDirector: 0,
            statusId: 1,
            salesStrategy: null,
            statusHistory: null,
            updatedAt: "2024-06-07T10:53:37.000Z",
            __typename: "Instance",
          },
        ],
        type: null,
        year: "2024",
        number: 1,
        __typename: "Edition",
      },
    ],
    fullDescription:
      "Who Cares Wins\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\nEditions:\nEdition 53050\nInstances: JJ77935\n",
    pressDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n",
    goodsCode: "970110",
    installation: null,
    installationLink: null,
    images: [
      {
        artworkId: 89627,
        archiveId: 216675,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T143140Z&X-Amz-Expires=3600&X-Amz-Signature=1e8645339d00a4471b51798ed6f6d6cec02bf367e69b8e5244bb08df5a88a9fa&X-Amz-SignedHeaders=host",
        imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T143140Z&X-Amz-Expires=3600&X-Amz-Signature=1e8645339d00a4471b51798ed6f6d6cec02bf367e69b8e5244bb08df5a88a9fa&X-Amz-SignedHeaders=host",
        imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x216675.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=f082199917af97b25dfc0319012dd59f9d38739299d89a3f9556951378961327&X-Amz-SignedHeaders=host",
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:13:17.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x216675.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=f082199917af97b25dfc0319012dd59f9d38739299d89a3f9556951378961327&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
      {
        artworkId: 89627,
        archiveId: 216676,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t216676.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=d25b224fe250746e2be1c8ece4b79114743ec1f8cab84371e91515976265e4d5&X-Amz-SignedHeaders=host",
        imgT: null,
        imgX: null,
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:13:18.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x216676.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=fc4d1cb7cd54363060bc433539ce9f6b4bb1d970ed062509dc7a225ea928db97&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
    ],
    imagesSummary: {
      artworkId: 89627,
      archiveId: 216675,
      channelDisplayOnline: 1,
      description: null,
      downloadPath: "https://placehold.jp/600x600.png",
      imgT: "https://placehold.jp/600x600.png",
      imgX: "https://placehold.jp/600x600.png",
      order: null,
      photoMaterialId: null,
      photoMaterial: null,
      updatedAt: "2024-02-23T11:13:17.000Z",
      uploadedAt: null,
      xDownloadPath: "https://placehold.jp/600x600.png",
      __typename: "Image",
    },
    maintenance: null,
    medium: "Oil, ink and pencil on paper",
    packing: null,
    photographed: -1,
    photoLink: null,
    photoNote: null,
    precis: null,
    reference: null,
    series: "test",
    standardId: null,
    technicalDimensions: null,
    timestamp: "2024-02-23T11:14:01.000Z",
    title: "Who Cares Wins",
    travelPack: -1,
    videoLink: null,
    website: 0,
  },
  {
    __typename: "Artwork",
    id: 89628,
    artFair: null,
    artists: [],
    artistDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\n\n",
    authenticity: null,
    categoryId: 10,
    classId: null,
    confidential: 0,
    countryOfOriginId: null,
    createdAt: "2024-02-23T11:15:08.000Z",
    description: null,
    dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
    editions: [
      {
        id: 53051,
        ap: 0,
        artwork: {
          id: 89628,
          artFair: null,
          authenticity: null,
          categoryId: 10,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2024-02-23T11:15:08.000Z",
          description: null,
          dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
          goodsCode: "970110",
          installation: null,
          installationLink: null,
          maintenance: null,
          medium: "Oil, ink and pencil on paper",
          packing: null,
          photographed: -1,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "test",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2024-02-23T11:15:08.000Z",
          title: "Who Cares Wins",
          travelPack: -1,
          videoLink: null,
          website: 0,
          __typename: "Artwork",
        },
        availableNumbers: [],
        instances: [
          {
            id: 86484,
            artistRef: null,
            artsy: 0,
            channelEcommerce: 0,
            channelPresentation: 0,
            certificate: null,
            certificateSent: null,
            createdAt: "2024-02-23T11:15:42.000Z",
            editionNumber: 1,
            fabricated: null,
            fabricatedDate: null,
            forSale: 0,
            framed: null,
            ipad: 0,
            locationHistory: null,
            name: "JJ77936",
            notes:
              "For Leila\r\n- No condition check, no photography\r\nCOA to be generated",
            parentOnline: 0,
            ref: 77936,
            reference: null,
            returns: 0,
            returnsDirector: 0,
            statusId: 5,
            salesStrategy: null,
            statusHistory: null,
            updatedAt: "2024-06-20T14:11:12.000Z",
            __typename: "Instance",
          },
        ],
        type: null,
        year: "2024",
        number: 1,
        __typename: "Edition",
      },
    ],
    fullDescription:
      "Who Cares Wins\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\nEditions:\nEdition 53051\nInstances: JJ77936\n",
    pressDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n",
    goodsCode: "970110",
    installation: null,
    installationLink: null,
    images: [
      {
        artworkId: 89628,
        archiveId: 216677,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t216677.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=55b73ffd311f693f18b5d0d24dca852170a266e1cd3f0ad110054fcf174dc7ba&X-Amz-SignedHeaders=host",
        imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t216677.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=55b73ffd311f693f18b5d0d24dca852170a266e1cd3f0ad110054fcf174dc7ba&X-Amz-SignedHeaders=host",
        imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x216677.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=a7834b146ff6fd93e71e0c35f4ee4cbb80323e6761fcf8ceb373ad10653bf4d7&X-Amz-SignedHeaders=host",
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:15:08.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x216677.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=a7834b146ff6fd93e71e0c35f4ee4cbb80323e6761fcf8ceb373ad10653bf4d7&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
      {
        artworkId: 89628,
        archiveId: 216678,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/7/t/t216678.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=4cadd272400a0f7355e604de9e9f37bde726af78b440250044af0a22529b8b97&X-Amz-SignedHeaders=host",
        imgT: null,
        imgX: null,
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:15:09.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/7/x/x216678.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=3b323612fcc5adb7da692c15806fc6580255dbb320ac263a7e45d482217b1a12&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
    ],
    imagesSummary: {
      artworkId: 89628,
      archiveId: 216677,
      channelDisplayOnline: 1,
      description: null,
      downloadPath: "https://placehold.jp/600x600.png",
      imgT: "https://placehold.jp/600x600.png",
      imgX: "https://placehold.jp/600x600.png",
      order: null,
      photoMaterialId: null,
      photoMaterial: null,
      updatedAt: "2024-02-23T11:15:08.000Z",
      uploadedAt: null,
      xDownloadPath: "https://placehold.jp/600x600.png",
      __typename: "Image",
    },
    maintenance: null,
    medium: "Oil, ink and pencil on paper",
    packing: null,
    photographed: -1,
    photoLink: null,
    photoNote: null,
    precis: null,
    reference: null,
    series: "test",
    standardId: null,
    technicalDimensions: null,
    timestamp: "2024-02-23T11:15:08.000Z",
    title: "Who Cares Wins",
    travelPack: -1,
    videoLink: null,
    website: 0,
  },
  {
    __typename: "Artwork",
    id: 89629,
    artFair: null,
    artists: [],
    artistDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\n\n",
    authenticity: null,
    categoryId: 10,
    classId: null,
    confidential: 0,
    countryOfOriginId: null,
    createdAt: "2024-02-23T11:50:50.000Z",
    description: null,
    dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
    editions: [
      {
        id: 53052,
        ap: 0,
        artwork: {
          id: 89629,
          artFair: null,
          authenticity: null,
          categoryId: 10,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2024-02-23T11:50:50.000Z",
          description: null,
          dimensions: "39 3/8 x 27 9/16 in. | (100 x 70 cm) ",
          goodsCode: "970110",
          installation: null,
          installationLink: null,
          maintenance: null,
          medium: "Oil, ink and pencil on paper",
          packing: null,
          photographed: -1,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "test",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2024-02-23T11:50:50.000Z",
          title: "Who Cares Wins",
          travelPack: -1,
          videoLink: null,
          website: 0,
          __typename: "Artwork",
        },
        availableNumbers: [],
        instances: [
          {
            id: 86485,
            artistRef: null,
            artsy: 0,
            channelEcommerce: 0,
            channelPresentation: 0,
            certificate: null,
            certificateSent: null,
            createdAt: "2024-02-23T11:51:38.000Z",
            editionNumber: 1,
            fabricated: null,
            fabricatedDate: null,
            forSale: 0,
            framed: null,
            ipad: 0,
            locationHistory: null,
            name: "JJ77937",
            notes:
              "For Kate Price - Harland will gift this work to Kate Price in person on Monday 26/02/2024 at the ICA \r\nCOA to be generated",
            parentOnline: 0,
            ref: 77937,
            reference: null,
            returns: 0,
            returnsDirector: 0,
            statusId: 2,
            salesStrategy: null,
            statusHistory: null,
            updatedAt: "2024-06-07T10:20:06.000Z",
            __typename: "Instance",
          },
        ],
        type: null,
        year: "2024",
        number: 1,
        __typename: "Edition",
      },
    ],
    fullDescription:
      "Who Cares Wins\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n\nEditions:\nEdition 53052\nInstances: JJ77937\n",
    pressDescription:
      "Who Cares Wins\n2024\nOil, ink and pencil on paper\n39 3/8 x 27 9/16 in. (100 x 70 cm)\n",
    goodsCode: "970110",
    installation: null,
    installationLink: null,
    images: [
      {
        artworkId: 89629,
        archiveId: 216679,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/t/t216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=92d3e448948fb46eeeeef80c8ac3c57647f5d353ff8f24679ef539abba9fddfe&X-Amz-SignedHeaders=host",
        imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/t/t216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=92d3e448948fb46eeeeef80c8ac3c57647f5d353ff8f24679ef539abba9fddfe&X-Amz-SignedHeaders=host",
        imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/x/x216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=6e04e82ab7654e9ca0dd91218f353d78f39c37f3e391fd016a244e827f51d5a6&X-Amz-SignedHeaders=host",
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:50:50.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/x/x216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=6e04e82ab7654e9ca0dd91218f353d78f39c37f3e391fd016a244e827f51d5a6&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
      {
        artworkId: 89629,
        archiveId: 216680,
        channelDisplayOnline: 1,
        description: null,
        downloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/0/8/t/t216680.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=ad25ceb31ee85034f989b04f3351433cbdb86b84df45836af853495457b92119&X-Amz-SignedHeaders=host",
        imgT: null,
        imgX: null,
        order: null,
        photoMaterialId: null,
        photoMaterial: null,
        updatedAt: "2024-02-23T11:50:52.000Z",
        uploadedAt: null,
        xDownloadPath:
          "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/0/8/x/x216680.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=c7ee7930e72b8f79df93cdab684b598ca120ab6a9fa416160c595e853b97e080&X-Amz-SignedHeaders=host",
        __typename: "Image",
      },
    ],
    imagesSummary: {
      artworkId: 89629,
      archiveId: 216679,
      channelDisplayOnline: 1,
      description: null,
      downloadPath: "https://placehold.jp/600x600.png",
      imgT: "https://placehold.jp/600x600.png",
      imgX: "https://placehold.jp/600x600.png",
      order: null,
      photoMaterialId: null,
      photoMaterial: null,
      updatedAt: "2024-02-23T11:50:50.000Z",
      uploadedAt: null,
      xDownloadPath:
        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/7/x/x216679.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240701%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240701T114820Z&X-Amz-Expires=3600&X-Amz-Signature=6e04e82ab7654e9ca0dd91218f353d78f39c37f3e391fd016a244e827f51d5a6&X-Amz-SignedHeaders=host",
      __typename: "Image",
    },
    maintenance: null,
    medium: "Oil, ink and pencil on paper",
    packing: null,
    photographed: -1,
    photoLink: null,
    photoNote: null,
    precis: null,
    reference: null,
    series: "test",
    standardId: null,
    technicalDimensions: null,
    timestamp: "2024-02-23T11:50:50.000Z",
    title: "Who Cares Wins",
    travelPack: -1,
    videoLink: null,
    website: 0,
  },
];

export const contacts = [
  {
    __typename: "Contact",
    id: 137352,
    address: "Gloslis Gate 3",
    address2: " Leil. 997",
    address3: "address_3",
    affiliations: "None",
    biography: "at arcu. Vestibulum ante ipsum primis in faucibus orci luctus",
    collection:
      "semper tellus id nunc interdum feugiat. Sed nec metus facilisis",
    collectionActive: -1,
    company: "",
    confidential: 0,
    contactAddresses: [
      {
        id: 1149,
        address: "address 1",
        address2: "address 2",
        address3: "address 3",
        contactId: 137352,
        countryId: 223,
        county: "County",
        do_not_call: 0,
        expired: 0,
        postcode: "W1G",
        town: "town",
        typeId: 6,
        use_billing: 0,
        use_catalogue: 0,
        use_delivery: 0,
        use_event: 0,
        use_statement: 0,
        use_vat: 0,
        use_default: 0,
        __typename: "ContactAddress",
      },
    ],
    contactArtists: [
      {
        artist: {
          __typename: "Artist",
          id: 3,
          bornCountry: {
            __typename: "Country",
            id: 3,
            continent: "South Asia",
            digraph: "AF",
            name: "Afghanistan",
            sagecode: 6,
            updatedAt: "2024-03-20T15:25:02.000Z",
          },
          bornCountryId: 3,
          bornDate: null,
          bornTown: "",
          contact: {
            __typename: "Contact",
            id: 3,
            address: "6 Apollo Place",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: null,
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                __typename: "ContactNumber",
                id: 55,
                donotcall: 0,
                identifier: null,
                number: "alimarr@bryanadams.com",
                prefere: -1,
                typeId: 1,
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              __typename: "Country",
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
            },
            county: null,
            createdAt: "2015-09-15T12:10:50.000Z",
            dateEntered: null,
            details:
              "01/2012 SR\r\nAli Marr - PA to Bryan Adams\r\n\r\n\r\nFrom Art Fortnight Mailing List 2004",
            dob: null,
            email: "alimarr@bryanadams.com",
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: "Frieze 2006",
            firstcontacttype: 2,
            firstUserId: 14,
            forename: "Bryan",
            greeting: null,
            img: "https://wc-preprod-sync.s3.eu-west-2.amazonaws.com/data/inventory/contact/3.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250109%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250109T155530Z&X-Amz-Expires=3600&X-Amz-Signature=5c127595f91894544561f59f8ff94803e549883e0b321e36fb31e838591496a0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
            invoicesLength: 0,
            level: null,
            mailingname: "Bryan Adams",
            middlename: null,
            name: "Bryan Adams",
            notes:
              "\r\n\r\nAM- met at Frieze 2006\r\n\r\nPreviously Alex Mollof client",
            postcode: "SW10 0ET",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: 940,
            salesUser2Id: null,
            salutation: "Bryan",
            siteId: null,
            storageCharge: 0,
            surname: "Adams",
            title: null,
            town: "London",
            typeId: 3,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2024-11-15T13:01:36.000Z",
            userEntered: null,
            user: "fredrika",
            vat: null,
          },
          confidential: 0,
          contactId: 3,
          copyright: null,
          defaultFabRate: 0,
          defaultSplitRate: null,
          droitdesuite: -1,
          mailingList: null,
          name: "Bryan Adams",
          represented: 0,
          sageCost: "TAB",
          sharedDiscount: null,
          terms: "terms",
        },
        artistId: 1,
        contactId: 134968,
        id: 40093,
        updatedAt: "2025-02-10T18:43:50.000Z",
      },
    ],
    contactLinks: [
      {
        id: 8123,
        contactId: 137352,
        description: "PA to Bryan Adams",
        expired: 0,
        linkId: 3,
        link: {
          id: 3,
          name: "Bryan Adams",
          __typename: "Contact",
        },
        typeId: 2,
        type: {
          id: 2,
          description: "Professional",
          __typename: "ContactLinkType",
        },
        __typename: "ContactLink",
      },
    ],
    contactCompany: {
      id: 11,
      code: "JJ",
      crossInvoiceId: null,
      name: "White Cube Limited",
      vatno: "GB982 566 574",
      __typename: "Company",
    },
    contactFocuses: [
      {
        id: 501,
        contactId: 137352,
        focusId: 12,
        rank: 1,
        focus: {
          id: 12,
          description: "Painting",
          __typename: "Focus",
        },
        __typename: "ContactFocus",
      },
    ],
    contactMailingLists: [
      {
        id: 123,
        mailingList: {
          id: 123,
          createdAt: "",
          description: "Artists list",
          updatedAt: "",
        },
        mailingListId: 567,
        updatedAt: "",
      },
      {
        id: 345,
        mailingList: {
          id: 345,
          createdAt: "2024-02-23",
          description: "Client list",
          updatedAt: "2025-06-23",
        },
        mailingListId: 117,
        updatedAt: "2025-06-23",
      },
    ],
    contactNumbers: [
      {
        id: 239335,
        donotcall: 0,
        identifier: "identifier_Scrubbed",
        number: "whitecube-239335@crvnprojects.com",
        prefere: 0,
        type: {
          id: 1,
          description: "Email",
          __typename: "ContactNumberType",
        },
        typeId: 1,
        __typename: "ContactNumber",
      },
    ],
    contactSecondary: true,
    countryId: 223,
    country: {
      id: 223,
      continent: "United Kingdom",
      digraph: "UK",
      name: "United Kingdom",
      sagecode: 0,
      updatedAt: "2023-05-22T11:39:04.000Z",
      __typename: "Country",
    },
    county: " Nordhavn",
    createdAt: "2024-02-23T13:42:52.000Z",
    details:
      "quam quis diam. Pellentesque habitant morbi tristique senectus et netus",
    dob: "2020-01-01",
    documents: {
      IsTruncated: false,
      Contents: [],
      Name: "wc-main-sync",
      Prefix: "data/inventory/contact/137352/",
      MaxKeys: 1000,
      CommonPrefixes: [],
      KeyCount: 0,
    },
    email: "whitecube-239335@crvnprojects.com",
    eori: null,
    exhUser: null,
    exhUserId: null,
    firstcontactdate: "2024-02-23",
    firstcontactlocation: "Sales enquiry",
    firstcontacttype: 5,
    firstUser: {
      id: 542,
      name: "paulgaraizabal",
      __typename: "Entity",
    },
    firstUserId: 542,
    forename: "Silas_SCRUBBED",
    greeting: null,
    img: "https://placehold.jp/700x200.png",
    invoicesLength: 0,
    level: 5,
    mailingname: "Clayton Kinney",
    middlename: null,
    name: "Silas_SCRUBBED Love",
    notes: "consequat, lectus sit amet luctus vulputate, nisi sem semper erat,",
    offer: [
      {
        __typename: "Offer",
        id: 615308,
        amount: 300,
        artwork: {
          id: 89627,
          title: "Artwork Title",
          artistsNames: "Artist Name",
          imagesSummary: {
            artworkId: 89627,
            archiveId: 216675,
            channelDisplayOnline: 1,
            description: null,
            downloadPath: "https://placehold.jp/600x600.png",
            imgT: "https://placehold.jp/600x600.png",
            imgX: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: null,
            photoMaterial: null,
            updatedAt: "2024-02-23T11:13:17.000Z",
            uploadedAt: null,
            xDownloadPath: "https://placehold.jp/600x600.png",
            __typename: "Image",
          },
        },
        contact: {
          id: 135841,
          address: "Luvre Fosselyngen 6",
          address2: " Leil. 424",
          address3: "address_3",
          affiliations: "None",
          biography:
            "ultrices posuere cubilia Curae Phasellus ornare. Fusce mollis. Duis sit",
          collection:
            "mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet,",
          collectionActive: -1,
          company: "",
          confidential: 0,
          contactSecondary: true,
          countryId: 225,
          county: " Vestsjeen",
          createdAt: "2023-10-30T23:17:02.000Z",
          details:
            "facilisis facilisis, magna tellus faucibus leo, in lobortis tellus justo",
          dob: "2020-01-01",
          email: "whitecube-237469@crvnprojects.com",
          eori: null,
          exhUserId: null,
          firstcontactdate: "2023-10-30",
          firstcontactlocation: "Intro via Mark Scala",
          firstcontacttype: 5,
          firstUserId: 487,
          forename: "Paula_SCRUBBED",
          greeting: null,
          img: null,
          invoicesLength: 0,
          level: 5,
          mailingname: "Vera Fernandez",
          middlename: null,
          name: "Paula_SCRUBBED Ortega",
          notes:
            "et, magna. Praesent interdum ligula eu enim. Etiam imperdiet dictum",
          postcode: " 6824",
          prefered:
            "Nunc ac sem ut dolor dapibus gravida. Aliquam tincidunt, nunc",
          rating: null,
          sagecode: null,
          salesUserId: 487,
          salesUser2Id: null,
          salutation: "Ori_SCRUBBED",
          siteId: null,
          storageCharge: 0,
          surname: "Ortega",
          title: "McKinnon Curator of Modern and Contemporary Art",
          town: " Vestsjeen",
          typeId: 27,
          type2Id: null,
          unsubscribed: false,
          updatedAt: "2024-05-22T07:31:46.000Z",
          vat: null,
          __typename: "Contact",
        },
        contactId: 135841,
        currency: {
          id: 3,
          code: "EUR",
          description: "Euro",
          name: null,
          __typename: "Currency",
        },
        currencyId: 3,
        date: null,
        dateClosed: null,
        exchange: null,
        hold: {
          __typename: "Instance",
          id: 86482,
          artistRef: "artistRef",
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          company: {
            __typename: "Company",
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB 12345",
            contact: {
              __typename: "Contact",
              id: 4449,
              forename: "Abbot_SCRUBBED",
              surname: "Nixon",
            },
          },
          createdAt: "2024-02-22T14:55:05.000Z",
          description:
            "Franz Ackermann, Bryan Adams\n'Soulscapes', Dulwich Picture Gallery, London\n14 February - 2 June 2024\nJJ77934\n",
          edition: {
            id: 53049,
            ap: 0,
            artwork: {
              id: 89626,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: null,
              categoryId: 12,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-02-22T14:53:44.000Z",
              description: null,
              dimensions: "",
              goodsCode: "",
              installation: null,
              installationLink: null,
              images: [
                {
                  artworkId: 89626,
                  archiveId: 216667,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: 54613,
                  updatedAt: "2024-02-23T12:01:18.000Z",
                  uploadedAt: "2024-02-23T10:28:07.000Z",
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
                {
                  artworkId: 89626,
                  archiveId: 216668,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/t/t216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=0ac405e6ac34759a54654dc4966e7e748d4b098f2ed0a9e19e0bfd35dec82dc4&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: null,
                  updatedAt: "2024-02-22T14:53:46.000Z",
                  uploadedAt: null,
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/x/x216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=56e90a7d0bf94c1459f211fd4e4a249a45764d258c4ee0d22bcb2ead3531afa0&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
              ],
              imagesSummary: {
                artworkId: 89627,
                archiveId: 216675,
                channelDisplayOnline: 1,
                description: null,
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                order: null,
                photoMaterialId: null,
                photoMaterial: null,
                updatedAt: "2024-02-23T11:13:17.000Z",
                uploadedAt: null,
                xDownloadPath: "https://placehold.jp/600x600.png",
                __typename: "Image",
              },
              maintenance: null,
              medium: "Print on paper",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "Group exhibition",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2024-02-23T10:27:31.000Z",
              title: "'Soulscapes', Dulwich Picture Gallery, London",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "14 February - 2 June 2024",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          location: "London",
          locationHistory: null,
          name: "JJ77934",
          notes: null,
          parentOnline: 0,
          ref: 36973,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 1,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-06-07T10:53:44.000Z",
          weight: null,
          volume: 0,
        },
        holdId: 123,
        holdDate: "2007-07-23T12:30:55.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        status: {
          id: 5,
          name: "To Be Invoiced",
          updatedAt: "2007-07-23T12:30:55.000Z",
          __typename: "OfferStatus",
        },
        statusId: 5,
        tbiAmount: 222.11,
        tbiDate: null,
        transparency: null,
        user: null,
        updatedAt: "2023-10-31T09:54:18.000Z",
      },
    ],
    postcode: " 0168",
    prefered: "hendrerit a, arcu. Sed et libero. Proin mi. Aliquam gravida",
    purchases: [
      {
        amount: 14400,
        artistNames: "Mary Herbert\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 8640,
        consigneeSplitRate: 60,
        creditId: null,
        customs: 0,
        date: "2024-04-02",
        description:
          "Mary Herbert\nLook Between the Rain\n2023\nOil on linen\n78 3/4 x 47 1/4 in. (200 x 120 cm)\nJJ75823\n",
        discount: 0,
        discountRate: 0,
        id: 277665,
        instanceId: 84178,
        instance: {
          id: 84178,
          artistRef: "artistRef",
          description: "This is a description of the instance",
          edition: {
            artwork: {
              id: "ARTWORK-ID-007",
              title: "Artwork Title",
              imagesSummary: {
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
              },
            },
          },
        },
        invoice: {
          id: 41798,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-04-02",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-05-02",
          items: [
            {
              amount: 14400,
              artistNames: "Mary Herbert\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 8640,
              consigneeSplitRate: 60,
              creditId: null,
              customs: 0,
              date: "2024-04-02",
              description:
                "Mary Herbert\nLook Between the Rain\n2023\nOil on linen\n78 3/4 x 47 1/4 in. (200 x 120 cm)\nJJ75823\n",
              discount: 0,
              discountRate: 0,
              id: 277665,
              instance: {
                id: 84178,
                artistNames: "Mary Herbert\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 1,
                channelPresentation: 1,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-06-08T15:59:12.000Z",
                droitdesuite: null,
                edition: {
                  id: 51100,
                  ap: 0,
                  artwork: {
                    id: 87715,
                    artFair: null,
                    artists: [
                      {
                        id: 1080,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 132871,
                        copyright: null,
                        defaultFabRate: 60,
                        defaultSplitRate: 60,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Mary Herbert",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: 0,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 4,
                      name: "Painting",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 4,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: 223,
                    createdAt: "2023-06-08T15:58:31.000Z",
                    description: "purple abstract painting",
                    dimensions: "78 3/4 x 47 1/4 in. | (200 x 120 cm) ",
                    goodsCode: "970110",
                    installation: null,
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Mary%20Herbert/Look%20Between%20the%20Rain%20JJ75823?csf=1&web=1&e=zWRq2G",
                    imagesSummary: {
                      artworkId: 87715,
                      archiveId: 204132,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/t/t204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=7f697da471d4531c7fc6f90ff2c81841a09019719fcb8c2c7f0e8db17734e159&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/t/t204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=7f697da471d4531c7fc6f90ff2c81841a09019719fcb8c2c7f0e8db17734e159&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 53069,
                      updatedAt: "2023-07-12T10:53:52.000Z",
                      uploadedAt: "2023-07-12T10:51:28.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/x/x204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=57b3c93b888d8b09fd6835e16d87292530b56783af1b173f27d69aa2421d21c4&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil on linen",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "In her introspective paintings, Mary Herbert weaves together inner worlds and the realms of the visible to foster deep reflection and empathy. Spectral figures, natural elements and luminous landscapes appear in and out of focus throughout thin veils of colour skilfully applied by the artist. Shrouded in a soft, glowing light, the works evoke hazy visions and dreams.   \r\n\r\nLook Between the Rain (2023) is inspired by a passage in Agnes Martin’s text ‘The Untroubled Mind’, published in 1972:  \r\n\r\n‘The whole wave \r\nit applies to life, the wave \r\nAs it was in the beginning, there was no division and no separation \r\nDon’t look at the stars  \r\nThen your mind goes freely - way, way beyond \r\nLook between the rain \r\nthe drops are insular'  \r\n\r\nThis extract broaches the meditative act of looking closely at the rain and at what is between it. Comparing the raindrops to thoughts, Herbert sees this as a call to dissolve our ego. She explains: ‘I feel like this connects a little to the way the figures are rendered [in this work], and their act of looking, but also to the airiness and lightness of the whole painting and how when you rest your eyes it can dissolve.’ \r\n\r\n- ES 17/07/23",
                    reference: null,
                    series: "",
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:37.000Z",
                    title: "Look Between the Rain",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: -1,
                fabricatedDate: "2023-07-13",
                forSale: 0,
                framed: null,
                ipad: -1,
                bondType: null,
                locationHistory: null,
                market: 1,
                name: "JJ75823",
                notes:
                  "No discounts\r\n\r\nThis work is part of our online exhibition 'In the Shadow' (July - Sep 2023). It is currently at Bermondsey. - ES 10/07/23\r\n\r\nInitialled, titled and dated on the back.\r\n\r\nconfirmed dims: h200 x 120.3 x 3.8cm SB03.07.223",
                parentOnline: 0,
                ref: 75823,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:35.000Z",
                __typename: "Instance",
              },
              instanceId: 84178,
              invoiceId: 41798,
              nominalId: 4008,
              price: 14400,
              quantity: 1,
              ref: "JJ75823",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2520,
              typeId: 8,
              exported: 0,
              artworkDimensions: "78 3/4 x 47 1/4 in. (200 x 120 cm)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          invoiceTotals: {
            balance: 16920,
            balance30Days: 16920,
            balance60Days: 16920,
            current: 0,
            grossProfit: 5760,
            net: 14400,
            tax: 2520,
            total: 16920,
            netExchange: "14400.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4610,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4610",
          registrarId: null,
          shedule: null,
          salesUser: {
            id: 346,
            name: "denis",
            __typename: "Entity",
          },
          sagecode: "ARTFAIR-FIAC-11",
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \r\n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \r\n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\r\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \r\n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \r\n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \r\n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\r\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\r\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \r\n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n14.\tIf the Purchaser makes the Work available for resale:\r\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\r\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \r\n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\r\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \r\n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales.\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41798,
        nominalId: 4008,
        price: 14400,
        quantity: 1,
        ref: "JJ75823",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 2520,
        typeId: 8,
        exported: 0,
        artworkDimensions: "78 3/4 x 47 1/4 in. (200 x 120 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 12000,
        artistNames: "Harland Miller\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 6000,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-07-16",
        description:
          "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
        discount: 0,
        discountRate: 0,
        id: 277799,
        instanceId: 83431,
        instance: {
          id: 83431,
          artistRef: "artistRef",
          description: "This is a description of the instance",
          edition: {
            artwork: {
              id: "ARTWORK-ID-007",
              title: "Artwork Title",
            },
          },
        },
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4208,
        price: 12000,
        quantity: 1,
        ref: "JJ75101",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 2100,
        typeId: 8,
        exported: 0,
        artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 21000,
        artistNames: "Harland Miller\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 10500,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-07-16",
        description:
          "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
        discount: 0,
        discountRate: 0,
        id: 277798,
        instanceId: 83445,
        instance: {
          id: 83445,
          artistRef: "artistRef",
          description: "This is a description of the instance",
          edition: {
            artwork: {
              id: "ARTWORK-ID-007",
              title: "Artwork Title",
            },
          },
        },
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=bd7e5c640df29d03cfd572bc07e6378561db2718aad00451373f8409cfc8240f&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=258d09801694b4be287dae4cc0302874a1663983372344fde69c842743940571&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4208,
        price: 21000,
        quantity: 1,
        ref: "JJ75115",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 3675,
        typeId: 8,
        exported: 0,
        artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 4000,
        artistNames: "Christina Kimeze\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 2000,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-05-20",
        description:
          "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
        discount: 0,
        discountRate: 0,
        id: 277687,
        instanceId: 83861,
        instance: {
          id: 83861,
          artistRef: "artistRef",
          description: "This is a description of the instance",
          edition: {
            artwork: {
              id: "ARTWORK-ID-007",
              title: "Artwork Title",
            },
          },
        },
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=bd7e5c640df29d03cfd572bc07e6378561db2718aad00451373f8409cfc8240f&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=33f9e268049ceb58ae82521e887af3c82a01664bd3da26011a05ba2dd1575884&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=258d09801694b4be287dae4cc0302874a1663983372344fde69c842743940571&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4008,
        price: 4000,
        quantity: 1,
        ref: "JJ75518",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 700,
        typeId: 8,
        exported: 0,
        artworkDimensions:
          "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
        currency: "GBP",
        __typename: "Item",
      },
    ],
    purchasesTotal: {
      converted: 317,
      original: 300,
    },
    rating: null,
    sagecode: null,
    salesUser: {
      id: 542,
      name: "Paul Garaizabal",
      __typename: "Entity",
    },
    salesUserId: 542,
    salesUser2: {
      id: 345,
      name: "Jane Doe",
      __typename: "Entity",
    },
    salesUser2Id: 345,
    salutation: "Amela_SCRUBBED",
    siteId: null,
    storageCharge: 0,
    surname: "Love",
    title: null,
    town: " Nordhavn",
    type: {
      id: 19,
      name: "Web Buyer",
      description: "Web Buyer",
      __typename: "ContactType",
    },
    typeId: 19,
    type2: {
      id: 20,
      name: "Exhibition Buyer",
      description: "Exhibition Buyer",
      __typename: "ContactType",
    },
    type2Id: 20,
    unsubscribed: false,
    updatedAt: "2024-05-22T07:34:03.000Z",
    vat: null,
    requests: [
      {
        __typename: "Request",
        id: 4201,
        artist: {
          __typename: "Artist",
          id: 83,
          name: "Mona Hatoum",
        },
        artistId: 83,
        budgetFrom: 10000,
        budgetTo: 50000,
        contactId: 137352,
        contact: {
          __typename: "Contact",
          id: 137352,
          name: "John Doe",
        },
        date: "2024-11-15T00:00:00.000Z",
        dateClosed: null,
        description:
          "Looking for large-scale installation work, preferably from the early 2000s series",
        notes:
          "Client has space in new gallery wing, ceiling height 4m. Interested in Hot Spot or similar globe works. Budget flexible for the right piece.",
        salesUser: {
          __typename: "Entity",
          id: 487,
          name: "Sarah Mitchell",
        },
        salesUserId: 487,
        type: {
          __typename: "RequestType",
          id: 1,
          name: "Primary",
        },
        typeId: 1,
        updatedAt: "2025-01-10T14:22:00.000Z",
      },
      {
        __typename: "Request",
        id: 4202,
        artist: {
          __typename: "Artist",
          id: 1108,
          name: "Julie Curtiss",
        },
        artistId: 1108,
        budgetFrom: 25000,
        budgetTo: 75000,
        contactId: 137352,
        contact: {
          __typename: "Contact",
          id: 137352,
          name: "Fred West",
        },
        date: "2025-02-01T00:00:00.000Z",
        dateClosed: "2025-03-15T00:00:00.000Z",
        description:
          "Seeking painting on canvas, medium scale, figurative work with hair motif",
        notes:
          "Collector saw recent show at Bermondsey and interested in acquiring. Prefers works on canvas over paper.",
        salesUser: {
          __typename: "Entity",
          id: 312,
          name: "James Whitfield",
        },
        salesUserId: 312,
        type: {
          __typename: "RequestType",
          id: 1,
          name: "Primary",
        },
        typeId: 1,
        updatedAt: "2025-03-15T09:30:00.000Z",
      },
    ],
  },
  {
    __typename: "Contact",
    id: 137352,
    address: "Gloslis Gate 3",
    address2: " Leil. 997",
    address3: "address_3",
    affiliations: "None",
    biography: "at arcu. Vestibulum ante ipsum primis in faucibus orci luctus",
    collection:
      "semper tellus id nunc interdum feugiat. Sed nec metus facilisis",
    collectionActive: -1,
    company: "",
    confidential: 0,
    contactAddresses: [
      {
        id: 1149,
        address: "address 1",
        address2: "address 2",
        address3: "address 3",
        contactId: 137352,
        countryId: 223,
        county: "County",
        do_not_call: 0,
        expired: 0,
        postcode: "W1G",
        town: "town",
        typeId: 6,
        use_billing: 0,
        use_catalogue: 0,
        use_delivery: 0,
        use_event: 0,
        use_statement: 0,
        use_vat: 0,
        use_default: 0,
        __typename: "ContactAddress",
      },
    ],
    contactArtists: [
      {
        artist: {
          __typename: "Artist",
          id: 3,
          bornCountry: {
            __typename: "Country",
            id: 3,
            continent: "South Asia",
            digraph: "AF",
            name: "Afghanistan",
            sagecode: 6,
            updatedAt: "2024-03-20T15:25:02.000Z",
          },
          bornCountryId: 3,
          bornDate: null,
          bornTown: "",
          contact: {
            __typename: "Contact",
            id: 3,
            address: "6 Apollo Place",
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: null,
            company: null,
            confidential: 0,
            contactCompany: null,
            contactNumbers: [
              {
                __typename: "ContactNumber",
                id: 55,
                donotcall: 0,
                identifier: null,
                number: "alimarr@bryanadams.com",
                prefere: -1,
                typeId: 1,
              },
            ],
            contactSecondary: false,
            countryId: 223,
            country: {
              __typename: "Country",
              id: 223,
              continent: "United Kingdom",
              digraph: "UK",
              name: "United Kingdom",
              sagecode: 0,
              updatedAt: "2024-03-20T15:30:43.000Z",
            },
            county: null,
            createdAt: "2015-09-15T12:10:50.000Z",
            dateEntered: null,
            details:
              "01/2012 SR\r\nAli Marr - PA to Bryan Adams\r\n\r\n\r\nFrom Art Fortnight Mailing List 2004",
            dob: null,
            email: "alimarr@bryanadams.com",
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: "Frieze 2006",
            firstcontacttype: 2,
            firstUserId: 14,
            forename: "Bryan",
            greeting: null,
            img: "https://wc-preprod-sync.s3.eu-west-2.amazonaws.com/data/inventory/contact/3.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250109%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250109T155530Z&X-Amz-Expires=3600&X-Amz-Signature=5c127595f91894544561f59f8ff94803e549883e0b321e36fb31e838591496a0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
            invoicesLength: 0,
            level: null,
            mailingname: "Bryan Adams",
            middlename: null,
            name: "Bryan Adams",
            notes:
              "\r\n\r\nAM- met at Frieze 2006\r\n\r\nPreviously Alex Mollof client",
            postcode: "SW10 0ET",
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: 940,
            salesUser2Id: null,
            salutation: "Bryan",
            siteId: null,
            storageCharge: 0,
            surname: "Adams",
            title: null,
            town: "London",
            typeId: 3,
            type2Id: null,
            unsubscribed: false,
            updatedAt: "2024-11-15T13:01:36.000Z",
            userEntered: null,
            user: "fredrika",
            vat: null,
          },
          confidential: 0,
          contactId: 3,
          copyright: null,
          defaultFabRate: 0,
          defaultSplitRate: null,
          droitdesuite: -1,
          mailingList: null,
          name: "Bryan Adams",
          represented: 0,
          sageCost: "TAB",
          sharedDiscount: null,
          terms: "terms",
        },
        artistId: 1,
        contactId: 134968,
        id: 40093,
        updatedAt: "2025-02-10T18:43:50.000Z",
      },
    ],
    contactCompany: {
      id: 11,
      code: "JJ",
      crossInvoiceId: null,
      name: "White Cube Limited",
      vatno: "GB982 566 574",
      __typename: "Company",
    },
    contactFocuses: [],
    contactMailingLists: [
      {
        id: 123,
        mailingList: {
          id: 123,
          createdAt: "",
          description: "Artists list",
          updatedAt: "",
        },
        mailingListId: 567,
        updatedAt: "",
      },
      {
        id: 345,
        mailingList: {
          id: 345,
          createdAt: "2024-02-23",
          description: "Client list",
          updatedAt: "2025-06-23",
        },
        mailingListId: 117,
        updatedAt: "2025-06-23",
      },
    ],
    contactNumbers: [
      {
        id: 239335,
        donotcall: 0,
        identifier: "identifier_Scrubbed",
        number: "whitecube-239335@crvnprojects.com",
        prefere: 0,
        type: {
          id: 1,
          description: "Email",
          __typename: "ContactNumberType",
        },
        typeId: 1,
        __typename: "ContactNumber",
      },
    ],
    contactSecondary: true,
    countryId: 223,
    country: {
      id: 223,
      continent: "United Kingdom",
      digraph: "UK",
      name: "United Kingdom",
      sagecode: 0,
      updatedAt: "2023-05-22T11:39:04.000Z",
      __typename: "Country",
    },
    county: " Nordhavn",
    createdAt: "2024-02-23T13:42:52.000Z",
    details:
      "quam quis diam. Pellentesque habitant morbi tristique senectus et netus",
    dob: "2020-01-01",
    documents: {
      IsTruncated: false,
      Contents: [],
      Name: "wc-main-sync",
      Prefix: "data/inventory/contact/137352/",
      MaxKeys: 1000,
      CommonPrefixes: [],
      KeyCount: 0,
    },
    email: "whitecube-239335@crvnprojects.com",
    eori: null,
    exhUser: null,
    exhUserId: null,
    firstcontactdate: "2024-02-23",
    firstcontactlocation: "Sales enquiry",
    firstcontacttype: 5,
    firstUser: {
      id: 542,
      name: "paulgaraizabal",
      __typename: "Entity",
    },
    firstUserId: 542,
    forename: "Silas_SCRUBBED",
    greeting: null,
    img: "https://placehold.jp/700x200.png",
    invoicesLength: 0,
    lastOffer: {
      id: 616502,
      artwork: {
        id: 88834,
        artFair: null,
        artists: [
          {
            __typename: "Artist",
            id: 83,
            bornCountry: {
              __typename: "Country",
              id: 122,
              continent: "Middle East and North Africa ",
              digraph: "LB",
              name: "Lebanon",
              sagecode: 4,
              updatedAt: "2024-03-20T15:25:03.000Z",
            },
            bornCountryId: 122,
            bornDate: null,
            bornTown: "",
            confidential: 0,
            contactId: 83,
            copyright: "© Mona Hatoum",
            defaultFabRate: 60,
            defaultSplitRate: 60,
            droitdesuite: -1,
            mailingList: null,
            name: "Mona Hatoum",
            represented: 0,
            sageCost: "HAT",
            sharedDiscount: 10,
            terms: "terms",
          },
        ],
        authenticity: null,
        categoryId: 4,
        classId: null,
        confidential: 0,
        countryOfOriginId: null,
        createdAt: "2023-10-30T15:49:17.000Z",
        description: null,
        dimensions:
          "15 3/4 x 23 5/8 in. | (40 x 60 cm)\r\n16 | 1/2 x 24 3/16 x 1 1/16 in. | (41.9 x 61.5 x 2.7 cm) | (framed) ",
        goodsCode: "970110",
        installation: null,
        installationLink:
          "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Leon%20Wuidar/2%20mai%202020%20JJ77060?csf=1&web=1&e=JhH0Ki",
        maintenance: null,
        medium: "Oil on canvas",
        packing: null,
        photographed: 0,
        photoLink: null,
        photoNote: null,
        precis: null,
        reference: null,
        series: "test",
        standardId: null,
        technicalDimensions: null,
        timestamp: "2023-12-05T17:40:43.000Z",
        title: "2 mai 2020",
        travelPack: -1,
        videoLink: null,
        website: 0,
        __typename: "Artwork",
      },
      amount: 10000,
      contactId: 137352,
      currency: {
        id: 3,
        code: "EUR",
        description: "Euro",
        name: "Euro",
        __typename: "Currency",
      },
      currencyId: 1,
      date: "2024-05-16",
      dateClosed: null,
      exchange: null,
      holdId: 86485,
      holdDate: "2024-05-16T10:42:37.000Z",
      notes: null,
      priority: 0,
      rank: 1,
      statusId: 1,
      tbiAmount: 10000,
      tbiDate: "2024-05-16",
      transparency: null,
      user: "root",
      updatedAt: "2024-05-16T10:43:18.000Z",
      __typename: "Offer",
    },
    level: 5,
    mailingname: "Clayton Kinney",
    middlename: null,
    name: "Silas_SCRUBBED Love",
    notes: "consequat, lectus sit amet luctus vulputate, nisi sem semper erat,",
    offer: [
      {
        __typename: "Offer",
        id: 615308,
        amount: 300,
        artwork: {
          id: 89627,
          title: "Artwork Title",
          artistsNames: "Artist Name",
          imagesSummary: {
            artworkId: 89627,
            archiveId: 216675,
            channelDisplayOnline: 1,
            description: null,
            downloadPath: "https://placehold.jp/600x600.png",
            imgT: "https://placehold.jp/600x600.png",
            imgX: "https://placehold.jp/600x600.png",
            order: null,
            photoMaterialId: null,
            photoMaterial: null,
            updatedAt: "2024-02-23T11:13:17.000Z",
            uploadedAt: null,
            xDownloadPath: "https://placehold.jp/600x600.png",
            __typename: "Image",
          },
        },
        contact: {
          id: 135841,
          address: "Luvre Fosselyngen 6",
          address2: " Leil. 424",
          address3: "address_3",
          affiliations: "None",
          biography:
            "ultrices posuere cubilia Curae Phasellus ornare. Fusce mollis. Duis sit",
          collection:
            "mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet,",
          collectionActive: -1,
          company: "",
          confidential: 0,
          contactSecondary: true,
          countryId: 225,
          county: " Vestsjeen",
          createdAt: "2023-10-30T23:17:02.000Z",
          details:
            "facilisis facilisis, magna tellus faucibus leo, in lobortis tellus justo",
          dob: "2020-01-01",
          email: "whitecube-237469@crvnprojects.com",
          eori: null,
          exhUserId: null,
          firstcontactdate: "2023-10-30",
          firstcontactlocation: "Intro via Mark Scala",
          firstcontacttype: 5,
          firstUserId: 487,
          forename: "Paula_SCRUBBED",
          greeting: null,
          img: null,
          invoicesLength: 0,
          level: 5,
          mailingname: "Vera Fernandez",
          middlename: null,
          name: "Paula_SCRUBBED Ortega",
          notes:
            "et, magna. Praesent interdum ligula eu enim. Etiam imperdiet dictum",
          postcode: " 6824",
          prefered:
            "Nunc ac sem ut dolor dapibus gravida. Aliquam tincidunt, nunc",
          rating: null,
          sagecode: null,
          salesUserId: 487,
          salesUser2Id: null,
          salutation: "Ori_SCRUBBED",
          siteId: null,
          storageCharge: 0,
          surname: "Ortega",
          title: "McKinnon Curator of Modern and Contemporary Art",
          town: " Vestsjeen",
          typeId: 27,
          type2Id: null,
          unsubscribed: false,
          updatedAt: "2024-05-22T07:31:46.000Z",
          vat: null,
          __typename: "Contact",
        },
        contactId: 135841,
        currency: {
          id: 3,
          code: "EUR",
          description: "Euro",
          name: null,
          __typename: "Currency",
        },
        currencyId: 3,
        date: null,
        dateClosed: null,
        exchange: null,
        hold: {
          __typename: "Instance",
          id: 86482,
          artistRef: "artistRef",
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          company: {
            __typename: "Company",
            id: 11,
            code: "JJ",
            crossInvoiceId: null,
            name: "White Cube Limited",
            vatno: "GB 12345",
            contact: {
              __typename: "Contact",
              id: 4449,
              forename: "Abbot_SCRUBBED",
              surname: "Nixon",
            },
          },
          createdAt: "2024-02-22T14:55:05.000Z",
          description:
            "Franz Ackermann, Bryan Adams\n'Soulscapes', Dulwich Picture Gallery, London\n14 February - 2 June 2024\nJJ77934\n",
          edition: {
            id: 53049,
            ap: 0,
            artwork: {
              id: 89626,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: null,
              categoryId: 12,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-02-22T14:53:44.000Z",
              description: null,
              dimensions: "",
              goodsCode: "",
              installation: null,
              installationLink: null,
              images: [
                {
                  artworkId: 89626,
                  archiveId: 216667,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=a2f1d7ca02c1c4d8f2fab824a75c9614bcbf938ebee342adfb2080ed825aac63&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: 54613,
                  updatedAt: "2024-02-23T12:01:18.000Z",
                  uploadedAt: "2024-02-23T10:28:07.000Z",
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x216667.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=3baefc27ef75e549f610bc43812e88848e2bdc0c5f54395eecfc3549fd33761b&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
                {
                  artworkId: 89626,
                  archiveId: 216668,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/t/t216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=0ac405e6ac34759a54654dc4966e7e748d4b098f2ed0a9e19e0bfd35dec82dc4&X-Amz-SignedHeaders=host",
                  imgT: "https://placehold.jp/600x600.png",
                  order: null,
                  photoMaterialId: null,
                  updatedAt: "2024-02-22T14:53:46.000Z",
                  uploadedAt: null,
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/8/6/x/x216668.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWJW7LU3GX%2F20240628%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240628T093643Z&X-Amz-Expires=3600&X-Amz-Signature=56e90a7d0bf94c1459f211fd4e4a249a45764d258c4ee0d22bcb2ead3531afa0&X-Amz-SignedHeaders=host",
                  __typename: "Image",
                },
              ],
              imagesSummary: {
                artworkId: 89627,
                archiveId: 216675,
                channelDisplayOnline: 1,
                description: null,
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                order: null,
                photoMaterialId: null,
                photoMaterial: null,
                updatedAt: "2024-02-23T11:13:17.000Z",
                uploadedAt: null,
                xDownloadPath: "https://placehold.jp/600x600.png",
                __typename: "Image",
              },
              maintenance: null,
              medium: "Print on paper",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis: null,
              reference: null,
              series: "Group exhibition",
              standardId: null,
              technicalDimensions: null,
              timestamp: "2024-02-23T10:27:31.000Z",
              title: "'Soulscapes', Dulwich Picture Gallery, London",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "14 February - 2 June 2024",
            number: 1,
            __typename: "Edition",
          },
          editionNumber: 1,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          location: "London",
          locationHistory: null,
          name: "JJ77934",
          notes: null,
          parentOnline: 0,
          ref: 36973,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 1,
          salesStrategy: null,
          statusHistory: null,
          updatedAt: "2024-06-07T10:53:44.000Z",
          weight: null,
          volume: 0,
        },
        holdId: 123,
        holdDate: "2007-07-23T12:30:55.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        status: {
          id: 5,
          name: "To Be Invoiced",
          updatedAt: "2007-07-23T12:30:55.000Z",
          __typename: "OfferStatus",
        },
        statusId: 5,
        tbiAmount: 222.11,
        tbiDate: null,
        transparency: null,
        user: null,
        updatedAt: "2023-10-31T09:54:18.000Z",
      },
    ],
    postcode: " 0168",
    prefered: "hendrerit a, arcu. Sed et libero. Proin mi. Aliquam gravida",
    purchases: [
      {
        amount: 14400,
        artistNames: "Mary Herbert\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 8640,
        consigneeSplitRate: 60,
        creditId: null,
        customs: 0,
        date: "2024-04-02",
        description:
          "Mary Herbert\nLook Between the Rain\n2023\nOil on linen\n78 3/4 x 47 1/4 in. (200 x 120 cm)\nJJ75823\n",
        discount: 0,
        discountRate: 0,
        id: 277665,
        instanceId: 84178,
        invoice: {
          id: 41798,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-04-02",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-05-02",
          items: [
            {
              amount: 14400,
              artistNames: "Mary Herbert\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 8640,
              consigneeSplitRate: 60,
              creditId: null,
              customs: 0,
              date: "2024-04-02",
              description:
                "Mary Herbert\nLook Between the Rain\n2023\nOil on linen\n78 3/4 x 47 1/4 in. (200 x 120 cm)\nJJ75823\n",
              discount: 0,
              discountRate: 0,
              id: 277665,
              instance: {
                id: 84178,
                artistNames: "Mary Herbert\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 1,
                channelPresentation: 1,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-06-08T15:59:12.000Z",
                droitdesuite: null,
                edition: {
                  id: 51100,
                  ap: 0,
                  artwork: {
                    id: 87715,
                    artFair: null,
                    artists: [
                      {
                        id: 1080,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 132871,
                        copyright: null,
                        defaultFabRate: 60,
                        defaultSplitRate: 60,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Mary Herbert",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: 0,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 4,
                      name: "Painting",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 4,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: 223,
                    createdAt: "2023-06-08T15:58:31.000Z",
                    description: "purple abstract painting",
                    dimensions: "78 3/4 x 47 1/4 in. | (200 x 120 cm) ",
                    goodsCode: "970110",
                    installation: null,
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Mary%20Herbert/Look%20Between%20the%20Rain%20JJ75823?csf=1&web=1&e=zWRq2G",
                    imagesSummary: {
                      artworkId: 87715,
                      archiveId: 204132,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/t/t204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=7f697da471d4531c7fc6f90ff2c81841a09019719fcb8c2c7f0e8db17734e159&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/t/t204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=7f697da471d4531c7fc6f90ff2c81841a09019719fcb8c2c7f0e8db17734e159&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 53069,
                      updatedAt: "2023-07-12T10:53:52.000Z",
                      uploadedAt: "2023-07-12T10:51:28.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/2/3/x/x204132.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=57b3c93b888d8b09fd6835e16d87292530b56783af1b173f27d69aa2421d21c4&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil on linen",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "In her introspective paintings, Mary Herbert weaves together inner worlds and the realms of the visible to foster deep reflection and empathy. Spectral figures, natural elements and luminous landscapes appear in and out of focus throughout thin veils of colour skilfully applied by the artist. Shrouded in a soft, glowing light, the works evoke hazy visions and dreams.   \r\n\r\nLook Between the Rain (2023) is inspired by a passage in Agnes Martin’s text ‘The Untroubled Mind’, published in 1972:  \r\n\r\n‘The whole wave \r\nit applies to life, the wave \r\nAs it was in the beginning, there was no division and no separation \r\nDon’t look at the stars  \r\nThen your mind goes freely - way, way beyond \r\nLook between the rain \r\nthe drops are insular'  \r\n\r\nThis extract broaches the meditative act of looking closely at the rain and at what is between it. Comparing the raindrops to thoughts, Herbert sees this as a call to dissolve our ego. She explains: ‘I feel like this connects a little to the way the figures are rendered [in this work], and their act of looking, but also to the airiness and lightness of the whole painting and how when you rest your eyes it can dissolve.’ \r\n\r\n- ES 17/07/23",
                    reference: null,
                    series: "",
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:37.000Z",
                    title: "Look Between the Rain",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: -1,
                fabricatedDate: "2023-07-13",
                forSale: 0,
                framed: null,
                ipad: -1,
                bondType: null,
                locationHistory: null,
                market: 1,
                name: "JJ75823",
                notes:
                  "No discounts\r\n\r\nThis work is part of our online exhibition 'In the Shadow' (July - Sep 2023). It is currently at Bermondsey. - ES 10/07/23\r\n\r\nInitialled, titled and dated on the back.\r\n\r\nconfirmed dims: h200 x 120.3 x 3.8cm SB03.07.223",
                parentOnline: 0,
                ref: 75823,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:35.000Z",
                __typename: "Instance",
              },
              instanceId: 84178,
              invoiceId: 41798,
              nominalId: 4008,
              price: 14400,
              quantity: 1,
              ref: "JJ75823",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2520,
              typeId: 8,
              exported: 0,
              artworkDimensions: "78 3/4 x 47 1/4 in. (200 x 120 cm)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 16920,
            balance30Days: 16920,
            balance60Days: 16920,
            current: 0,
            grossProfit: 5760,
            net: 14400,
            tax: 2520,
            total: 16920,
            netExchange: "14400.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4610,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4610",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \r\n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \r\n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\r\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \r\n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \r\n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \r\n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\r\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\r\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \r\n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n14.\tIf the Purchaser makes the Work available for resale:\r\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\r\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \r\n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\r\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \r\n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales.\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41798,
        nominalId: 4008,
        price: 14400,
        quantity: 1,
        ref: "JJ75823",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 2520,
        typeId: 8,
        exported: 0,
        artworkDimensions: "78 3/4 x 47 1/4 in. (200 x 120 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 12000,
        artistNames: "Harland Miller\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 6000,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-07-16",
        description:
          "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
        discount: 0,
        discountRate: 0,
        id: 277799,
        instanceId: 83431,
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4208,
        price: 12000,
        quantity: 1,
        ref: "JJ75101",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 2100,
        typeId: 8,
        exported: 0,
        artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 21000,
        artistNames: "Harland Miller\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 10500,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-07-16",
        description:
          "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
        discount: 0,
        discountRate: 0,
        id: 277798,
        instanceId: 83445,
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=bd7e5c640df29d03cfd572bc07e6378561db2718aad00451373f8409cfc8240f&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=258d09801694b4be287dae4cc0302874a1663983372344fde69c842743940571&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4208,
        price: 21000,
        quantity: 1,
        ref: "JJ75115",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 3675,
        typeId: 8,
        exported: 0,
        artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
        currency: "GBP",
        __typename: "Item",
      },
      {
        amount: 4000,
        artistNames: "Christina Kimeze\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 2000,
        consigneeSplitRate: 50,
        creditId: null,
        customs: 0,
        date: "2024-05-20",
        description:
          "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
        discount: 0,
        discountRate: 0,
        id: 277687,
        instanceId: 83861,
        invoice: {
          id: 41819,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bankId: 15,
          channelId: 1,
          chargeStorage: 0,
          company: {
            id: 11,
            active: -1,
            bondMinValue: 200000,
            code: "JJ",
            cds: "GBTEA98256657400020220929113111",
            consignmentCredit: null,
            consignmentTerms:
              'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
            consignmentSignOff: "For and on behalf of White Cube Limited",
            contactId: 4449,
            createdAt: "2015-09-15T11:46:59.000Z",
            creditCode: "WCC",
            creditRef: 3371,
            crossInvoiceId: null,
            currencyId: 1,
            currency: {
              id: 1,
              code: "GBP",
              description: "Pounds Sterling",
              name: null,
              __typename: "Currency",
            },
            hmrcAddress:
              "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
            invoiceCode: "WCA",
            invoiceDue: "1m",
            lobMarket: 1,
            loanTerms:
              "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
            loanSignOff: "White Cube Limited acting as agent for the Artist",
            photoCredit: null,
            name: "White Cube Limited",
            notes: null,
            shippingEmail: null,
            vatno: "GB982 566 574",
            __typename: "Company",
          },
          companyId: 11,
          companyName: null,
          conduit: 1,
          contactId: 134754,
          county: null,
          countryId: null,
          currencyId: 1,
          date: "2024-05-20",
          debtChase: -1,
          deliveryAddress: null,
          deliveryAddress2: null,
          deliveryAddress3: null,
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-06-20",
          items: [
            {
              amount: 12000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 6000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XL)\n2023\nEdition 29 / 50\nWoodcut\n40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)\nJJ75101\n",
              discount: 0,
              discountRate: 0,
              id: 277799,
              instance: {
                id: 83431,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:37:28.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50589,
                  ap: 0,
                  artwork: {
                    id: 87192,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:36:21.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "40 3/8 x 27 11/16 in. | (102.5 x 70.4 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87192,
                      archiveId: 197639,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=1c7cfb0639ddbad1c5db70c0346f11a88bf4a24a45153c87bbc2b9632b140550&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/t/t197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=bd7e5c640df29d03cfd572bc07e6378561db2718aad00451373f8409cfc8240f&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52383,
                      updatedAt: "2023-03-07T17:00:53.000Z",
                      uploadedAt: "2023-03-07T17:00:53.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/9/3/x/x197639.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=9fa4d34964b73848f8f551b41396058be0ec5cf8129401678a7f1218376ef027&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 29,
                editionNumberFormatted: "29/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75101",
                notes: null,
                parentOnline: 0,
                ref: 75101,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 1,
                statusUndo: 3,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:22:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83431,
              invoiceId: 41819,
              nominalId: 4208,
              price: 12000,
              quantity: 1,
              ref: "JJ75101",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 2100,
              typeId: 8,
              exported: 0,
              artworkDimensions: "40 3/8 x 27 11/16 in. (102.5 x 70.4 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 21000,
              artistNames: "Harland Miller\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 10500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-07-16",
              description:
                "Harland Miller\nLUV (XXL)\n2023\nEdition 41 / 50\nWoodcut\n67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)\nJJ75115\n",
              discount: 0,
              discountRate: 0,
              id: 277798,
              instance: {
                id: 83445,
                artistNames: "Harland Miller\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-03-03T14:44:47.000Z",
                droitdesuite: -1,
                edition: {
                  id: 50590,
                  ap: 0,
                  artwork: {
                    id: 87193,
                    artFair: null,
                    artists: [
                      {
                        id: 149,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: "1964-03-11",
                        bornTown: "",
                        confidential: 0,
                        contactId: 149,
                        copyright: "© Harland Miller",
                        defaultFabRate: 50,
                        defaultSplitRate: 50,
                        droitdesuite: -1,
                        mailingList: null,
                        name: "Harland Miller",
                        represented: 0,
                        sageCost: "MIL",
                        sharedDiscount: 10,
                        terms:
                          "CONSIGNMENT AGREEMENT\r\n\r\n\r\nThis Agreement sets out the terms on which the Artist agrees to consign to White Cube the artworks listed in the attached Schedule (together the “Works” and individually the “Work”).  \r\n\r\n1.\tDefinitions\r\n\r\nIn this Agreement, the following expressions shall have the following meanings:\r\n\r\n1.1\t“Agreement” shall mean this consignment agreement, including the Schedule; \r\n\r\n1.2\t“Artist” shall mean Harland Miller; \r\n\r\n1.3\t“Consignment Period” shall mean the consignment period specified in the Schedule, as may be extended pursuant to clause 2.3 below;\r\n\r\n1.4\t“Retail Price” shall mean, for each Work, the retail price set out against such Work in the Schedule;\r\n\r\n1.5\t“White Cube” shall mean, jointly and severally, White Cube Limited and its affiliated entities; \r\n\r\n1.6\t“White Cube Limited” shall mean White Cube Limited, whose business address is at 144-152 Bermondsey Street, London SE1 3TQ.\r\n\r\n2.\tConsignment\r\n\r\n2.1\tThe Artist hereby appoints White Cube to act as its exclusive agent for the Works during the Consignment Period and on the terms of this Agreement, for the purposes of the exhibition and sale of the Works (including, but not limited to, the exhibiting, promotion, marketing, offering for sale and selling of the Works), to the intent that White Cube shall be entitled to enter into agreements on behalf of the Artist for the exhibition and/or sale of the Works, including but not limited to, lending the Works to third parties for exhibition and consigning the Works to third parties for exhibition and/or sale.   \r\n\r\n2.2\tThe Artist hereby authorises White Cube to delegate to third parties its authority to exhibit and sell the Works. In addition, White Cube may assign the Agreement to any of its affiliated companies to exhibit and sell the Works without the Artist’s prior consent.\r\n\r\n2.3\tShould White Cube wish to extend the Consignment Period, it shall write to the Artist requesting an extension.  Subject to the Artist agreeing to such request in writing, the Consignment Period shall be extended on the same terms as those contained in this Agreement, unless otherwise agreed in writing between both parties.\r\n\r\n3.\tTransportation and Insurance\r\n\r\n3.1\tSubject to the Artist’s designated premises being in the United Kingdom, White Cube undertakes to arrange and to pay for packing and transporting of the Works from the Artist’s designated premises to White Cube’s designated premises at the start of the Consignment Period, and for the packing and transporting of any unsold Works back to the Artist’s original designated premises at the end of the Consignment Period. \r\n\r\n3.2\tWhite Cube shall:\r\n\r\n3.2.1\tensure that it adheres to all instructions for packaging and transportation which are supplied in a timely manner by or on behalf of the Artist;\r\n\r\n3.2.2\tuse reasonable endeavours to ensure that any consignee and/or borrower of a Work adheres to any instructions provided in accordance with clause 3.2.1 that relate to such Work until such time as risk in such Work passes to the buyer of the Work or the Work is returned to White Cube (as applicable); \r\n\r\n3.2.3\tensure that a condition check is carried out on each Work as soon as practicable after White Cube comes into possession of the Work; and\r\n\r\n3.2.4\tinsure each Work for its Retail Price and ‘nail to nail’ under an ‘All Risks’ insurance policy at its own cost from the date that such Work is released to White Cube by the Artist until the earlier of: (a) the Work being returned to the Artist; (b) risk in the Work passing to a buyer of the Work; (c) risk in the Work passing to a consignee (in which case White Cube undertakes to re-insure the Work if the Work is returned to White Cube from the moment it is returned until (a), (b) or (d) applies); or (d) risk in the Work passing to a borrower (in which case White Cube undertakes to re-insure the Work from the moment the Work is returned to White Cube until (a), (b) or (c) applies). \r\n\r\n\r\n4.\tHandling of the Works\r\n\r\nFor each Work, White Cube shall, from the date that such Work is released to White Cube by the Artist until such time as risk in the Work passes to the buyer or the Work is returned to the Artist (as applicable):\r\n\r\n4.1\texercise, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party exercises, all due care and diligence in the transportation, handling, storage and display of the Work;\r\n\r\n4.2\ttake, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure that such third party takes, all necessary precautions to prevent risk of loss or damage to the Work;\r\n\r\n4.3\tensure, or, if the Work is consigned or loaned to a third party, use reasonable endeavours to ensure, that the Work is installed and displayed in accordance with any installation instructions supplied in a timely manner by or on behalf of the Artist; and\r\n\r\n4.4\tinform the Artist of any loss of or damage to the Work as soon as reasonably practicable.\r\n\r\n5.\tSale of Works\r\n\r\n5.1\tEach Retail Prices is in GBP and does not include VAT or any other applicable taxes which may be added to the sale price of a Work. \r\n\r\n5.2\tFor each Work, White Cube shall be entitled to extend a discount of up to 10% of the Retail Price for such Work to potential buyers.  White Cube and the Artist shall share the discount equally for any discount up to and including 10%. Any higher discount must be agreed with the Artist, otherwise any discount in excess of 10% shall be absorbed by White Cube. \r\n\r\n5.3\tIn the event of the sale of any Work, title to such Work shall pass from the Artist to the buyer of the Work at such time as White Cube has received payment of the sale price in full and cleared funds.\r\n\r\n5.4\tWhite Cube shall notify the Artist in writing of the sale of a Work, together with the name of the buyer of the Work and city in which the buyer is located (unless prohibited to do so for reasons of confidentiality or data protection).  Each of White Cube and the Artist shall keep such information confidential.\r\n\r\n5.5\tAt the end of the Consignment Period, White Cube shall return any unsold Works to the Artist. \r\n\r\n6.\tSale Proceeds and Commission\r\n\r\n6.1\tSubject to clause 6.2 below, should any of the Works sell, White Cube shall pay amounts due to the Artist for the sale of such Works in accordance with previously agreed practice through the Artist’s monthly statement and shall be entitled to receive a commission of 50% of the sale proceeds of each Work (net of VAT or other applicable taxes). \r\n\r\n6.2\tShould the Work(s) be sold through White Cube Hong Kong Limited or White Cube Inc, after sending the Artist written notice of such sale, White Cube shall be entitled to deduct from the sale proceeds a commission of 50% of the sale proceeds (net of VAT or other applicable taxes). On receipt of an invoice from the Artist, and only after White Cube has received full payment in cleared funds in its bank account from the buyer of the Work(s), White Cube shall pay the Artist the balance of the sale proceeds.\r\n\r\n6.3\tIn the event that White Cube delegates its authority to a third party pursuant to clause 2.2, or obtains assistance from a third party to sell a Work, and such third party sells a Work, or assists in the selling of a Work, the Artist agrees that such third party shall be entitled to retain as commission on the sale such portion of the commission due to White Cube pursuant to clause 6.1 as White Cube and such third party may in their discretion agree.\r\n\r\n\r\n7.\tWarranties\r\n\r\nThe Artist warrants that: (a) the Artist has the right, power and authority to consign the Works for sale and to enter into this Agreement and to perform all his/her obligations hereunder; (b) the Artist has unencumbered title to the Works; (c) the Works are in compliance with the description of them given by the Artist; (d) the Works do not infringe the intellectual property or any other rights of any third party; and (e) in the case of any Work which is part of a limited edition, such edition will not exceed the number stated in the Schedule. \r\n\r\n8.\tCopyright\r\n\r\n8.1\tThe copyright in the Works remains with the Artist and the Artist hereby asserts his/her right to be identified as the author of the Works under s77 of the Copyright, Design and Patents Act 1988 and expressly reserves all his/her other moral rights arising under the Copyright, Designs and Patents Act 1988 and, so far as is legally possible, any broadly equivalent rights the Artist may have in any territory of the world.\r\n\r\n8.2\tThe Artist hereby irrevocably authorises White Cube: \r\n\r\n8.2.1\tto create photographs and films of the Works and to reproduce and use such photographs and films (including any photographs taken pursuant to clause 10), and any photographs and films of the Works supplied by the Artist, in connection with the exercise of White Cube’s rights and the carrying out of White Cube’s role under this Agreement.  It is acknowledged that such authorisation includes, but is not limited to, allowing White Cube to use the images of the Works for promotional and marketing purposes in connection with the sale and exhibition of the Works, including on its website, on social media channels and for its archive; \r\n\r\n8.2.2\tto authorise any party to whom the Works are sold, consigned or loaned to photograph the Works purely for non-commercial purposes, including but not limited to the reproduction and use of such photographs for archival and educational reasons; \r\n\r\n8.2.3\tin respect of any Works which are in the form of a film, to show the Works in public and to authorise any party to whom such Works are sold, consigned or loaned to show (or authorise the showing of) the Works in public; and\r\n\r\n8.2.4\tin the case of Works consigned for a group exhibition, to share installation photographs of the Works with other artists participating in the group exhibition strictly for the purposes of the other artists promoting the exhibition and for archival purposes. \r\n\r\n9.\tPhotographs\r\n\r\nWhite Cube shall meet the cost of photographs which the Artist reasonably requires to be taken of the Works during the Consignment Period.  If the Works have not been photographed before being released to White Cube, White Cube agrees, on receipt of the Works, to photograph the Works in high resolution tiff format for the archives of the Artist and for use by the Artist. Please note that, as a general policy, White Cube does not prohibit members of the public from taking photographs in its galleries.\r\n\r\n10.\tCredits\r\n\r\nWhite Cube shall use reasonable endeavours to credit (or to procure a credit for) both the Artist and White Cube on any promotional or other material that incorporates any image of the Works and where the Works are displayed at a public exhibition in a form similar to the following: “Courtesy of Harland Miller and White Cube”.\r\n\r\n11.\tCertificate of Authenticity\r\n\r\nShould the Artist wish to provide a certificate of authenticity for a Work, the Artist shall supply such certificate to White Cube on release of such Work to White Cube.  The Artist acknowledges that any failure to provide such a certificate of authenticity may affect the sale of the Work.\r\n\r\n12.\tGeneral\r\n\r\n12.1\tNo variation may be made to this Agreement unless it is agreed in writing by or on behalf of the Artist and White Cube.\r\n\r\n12.2\tIf any court or competent authority finds that any provision of this Agreement is invalid, illegal or unenforceable, that provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this Agreement shall not be affected. \r\n\r\n12.3\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n12.4\tThis Agreement and any non-contractual disputes or claims arising out of it shall be governed by the laws of England and Wales and subject to the exclusive jurisdiction of the courts of England and Wales.",
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 8,
                      name: "Edition",
                      goodsCode: "9702",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 8,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-03-03T14:43:59.000Z",
                    description:
                      "Edition of 50\r\n\r\nSigned by the artist on the front, numbered on the reverse. Published by Manifold Editions",
                    dimensions: "67 15/16 x 46 5/8 in. | (172.5 x 118.5 cm) ",
                    goodsCode: "9702",
                    installation: null,
                    installationLink: null,
                    imagesSummary: {
                      artworkId: 87193,
                      archiveId: 197641,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=f39348a96694f9f79c8e51992de786beca35540fa7ee461e76d27e58f675eae0&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/t/t197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=33f9e268049ceb58ae82521e887af3c82a01664bd3da26011a05ba2dd1575884&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52384,
                      updatedAt: "2023-03-07T17:02:27.000Z",
                      uploadedAt: "2023-03-07T17:02:19.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/4/x/x197641.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=4e9dc343f6e79f2741a7368a79630dd14f77b40c19b2b8203d0a388a2a7a650c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Woodcut",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:31.000Z",
                    title: "LUV (XXL)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2023",
                  number: 50,
                  __typename: "Edition",
                },
                editionNumber: 41,
                editionNumberFormatted: "41/50",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: null,
                ipad: 0,
                bondType: null,
                locationHistory: null,
                market: null,
                name: "JJ75115",
                notes: null,
                parentOnline: 0,
                ref: 75115,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 1,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-07-16T16:02:03.000Z",
                __typename: "Instance",
              },
              instanceId: 83445,
              invoiceId: 41819,
              nominalId: 4208,
              price: 21000,
              quantity: 1,
              ref: "JJ75115",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 3675,
              typeId: 8,
              exported: 0,
              artworkDimensions: "67 15/16 x 46 5/8 in. (172.5 x 118.5 cm)",
              currency: "GBP",
              __typename: "Item",
            },
            {
              amount: 4000,
              artistNames: "Christina Kimeze\n",
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2000,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-05-20",
              description:
                "Christina Kimeze\nPurple Interior (II)\n2022\nOil and gouache on paper\n14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)\nJJ75518\n",
              discount: 0,
              discountRate: 0,
              id: 277687,
              instance: {
                id: 83861,
                artistNames: "Christina Kimeze\n",
                artistRef: "artistRef",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 0,
                certificate: null,
                certificateSent: null,
                createdAt: "2023-04-17T11:00:38.000Z",
                droitdesuite: null,
                edition: {
                  id: 50820,
                  ap: 0,
                  artwork: {
                    id: 87427,
                    artFair: null,
                    artists: [
                      {
                        id: 1062,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: null,
                        confidential: 0,
                        contactId: 131244,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Christina Kimeze",
                        represented: 3,
                        sageCost: null,
                        sharedDiscount: null,
                        terms: null,
                        __typename: "Artist",
                      },
                    ],
                    artworkCategory: {
                      id: 10,
                      name: "Works on Paper",
                      goodsCode: "970110",
                      __typename: "ArtworkCategory",
                    },
                    authenticity: null,
                    categoryId: 10,
                    classId: null,
                    confidential: 0,
                    countryOfOriginId: null,
                    createdAt: "2023-04-17T11:00:06.000Z",
                    description: null,
                    dimensions:
                      "14 1/8 x 9 13/16 in. | (35.8 x 25 cm)\r\n16 | 1/4 x 12 x 1 9/16 in. | (41.2 x 30.5 x 4 cm) | (framed) ",
                    goodsCode: "970110",
                    installation:
                      "Custom walnut 10 x 40mm moulding\r\nClear matt oil finish\r\nArtwork float mounted on 403 heritage board with 15-20mm space\r\nUV filtering and anti-glare glass",
                    installationLink:
                      "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Christina%20Kimeze/Purple%20Interior%20(II)%20JJ75518?csf=1&web=1&e=R4I1eg",
                    imagesSummary: {
                      artworkId: 87427,
                      archiveId: 200161,
                      channelDisplayOnline: 1,
                      description: null,
                      downloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=2ca3bfe91a432e6fbb06929d8a2e8c6cf6bbb6ec73e609a83a474985e4f1801e&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/t/t200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131539Z&X-Amz-Expires=3600&X-Amz-Signature=258d09801694b4be287dae4cc0302874a1663983372344fde69c842743940571&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      order: null,
                      photoMaterialId: 52698,
                      updatedAt: "2023-04-27T12:15:29.000Z",
                      uploadedAt: "2023-04-27T12:14:55.000Z",
                      xDownloadPath:
                        "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/1/6/x/x200161.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250401%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250401T131538Z&X-Amz-Expires=3600&X-Amz-Signature=ee56b67e06a5b5d797657daf0da26d070a8552a36d44fe138f63bc76eda4f2c9&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                      __typename: "Image",
                    },
                    maintenance: null,
                    medium: "Oil and gouache on paper",
                    packing: null,
                    photographed: -1,
                    photoLink: null,
                    photoNote: null,
                    precis:
                      "Kimeze’s beautiful works on paper were all created this year and last, and although they are artworks in their own right and not studies for larger paintings, they often help to trigger ideas for her larger works, forming a crucial role in her practice. Painted in watercolour, oil paint, and gouache on paper, the artist made many of these drawings in quiet moments while watching Senegalese films at home, their compositions and small details often inspired by something she saw on the screen in front of her. These works capture moments of reflection, interaction, and intimacy and the artist’s sumptuous use of colours bring the compositions to life. To continue the notion of tenderness and immediacy, the deckled edging of the paper has been left visible, showing us traces of the artist’s hand. Although much of Kimeze works could be semi-autobiographical, her focus on collective memory and other multiple sources converge here; memories or snippets of her own life such as scenes of her husband in the bath are combined with the films by the godfathers of African film, Ousmane Sembene and Diop-Mambety. \r\n\r\nChristina Kimeze lives and works in London. She received her undergraduate degree in Biological Sciences from the University of Oxford and her postgraduate degree from The Royal Drawing School, London. Unusual surface materials form an important part of Kimeze’s practice, which she uses to explore how texture and luminosity help to investigate themes of interiority, oneness and belonging. Frequently working on suede matboard, Kimeze combines dry chalks, oil pastel and wet paints, applying, crushing and crunching them on the surfaces. Kimeze recently completed a residency at the Palazzo Monti in Brescia, Italy and has been included in several recent group exhibitions such as Palazzo Monti, Brescia, Italy (2022); Michael Werner, London (2022); Buckingham Palace, London (2022); and Borgo Pignano Royal Drawing School, Volterra, Italy (2022). In 2022 she was awarded the Sir Denis Mahon Award.\r\n\r\nVE 06/06/2023",
                    reference: null,
                    series: null,
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:33.000Z",
                    title: "Purple Interior (II)",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                    __typename: "Artwork",
                  },
                  year: "2022",
                  number: 1,
                  __typename: "Edition",
                },
                editionNumber: 1,
                editionNumberFormatted: "1/1",
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: -1,
                ipad: -1,
                bondType: "TA",
                locationHistory: null,
                market: 1,
                name: "JJ75518",
                notes: "For Paris exhibition VE 24/04/2023",
                parentOnline: 0,
                ref: 75518,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                statusId: 3,
                statusUndo: 10,
                salePrice: null,
                salesStrategy: null,
                statusHistory: null,
                updatedAt: "2024-11-15T13:20:32.000Z",
                __typename: "Instance",
              },
              instanceId: 83861,
              invoiceId: 41819,
              nominalId: 4008,
              price: 4000,
              quantity: 1,
              ref: "JJ75518",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 700,
              typeId: 8,
              exported: 0,
              artworkDimensions:
                "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
              currency: "GBP",
              __typename: "Item",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: 43475,
            balance30Days: 4700,
            balance60Days: 4700,
            current: 0,
            grossProfit: 18500,
            net: 37000,
            tax: 6475,
            total: 43475,
            netExchange: "37000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: "Luke Test Lowles-Hourigan",
          number: 123,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: 4620,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "4620",
          registrarId: null,
          shedule: null,
          sagecode: "ARTFAIR-FIAC-11",
          invoiceSalesPersons: [
            {
              id: 9242,
              salesUser: {
                id: 346,
                name: "denis",
                __typename: "Entity",
              },
              salesUserId: 346,
              split: 1,
              timestamp: "2013-06-10T11:40:07.000Z",
              __typename: "InvoiceSalesPerson",
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer by the date(s) specified on this invoice.\r\n\r\nYour attention is drawn to clause 5 on the reverse of this invoice. White Cube will only pay for storage of the Work for 30 days after it has notified the Purchaser that the Work is ready for collection. The Purchaser is liable and will be invoiced directly for any storage costs incurred thereafter. See the reverse of the invoice for full details.\r\n\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.\r\n\r\nFrom 10 January 2020, White Cube is regulated for the purposes of anti money laundering and is required to carry out statutory customer due diligence checks on all of its purchasers. Unless agreed otherwise in advance, White Cube can only accept payment from the person to whom the invoice is addressed (the Purchaser). Any funds received from a third party will be rejected and title to the Work will not pass to the Purchaser in accordance with clause 2 on the reverse of the invoice, unless White Cube has both (i) been notified in advance; and (ii) confirmed to the Purchaser it has carried out the necessary due diligence on the paying party to enable payment to be received.",
          termsback:
            "1.\tThese terms and conditions, together with any terms set out on the front of the invoice and those set out in the email confirming sale, set out the entire agreement between the addressee of the invoice (the “Purchaser”) and White Cube Limited relating to the sale of the Work. The Purchaser acknowledges that the Purchaser has not agreed to buy the Work in reliance on any statement, representation or warranty which is not expressly identified in these terms and conditions. \n2.\tTitle to the artwork (the “Work”) shall pass to the Purchaser on receipt of the amount stated on the invoice (the “Purchase Price”) in full by White Cube in cleared funds.  \n3.\tAny direct or indirect taxes and/or duties stemming from, or any necessary licences in connection with, the Purchaser’s purchase of, ownership of or re-sale of the Work, including all export and import duties, shall be the Purchaser’s responsibility.\n4.\tIf payment of the full Purchase Price has not been paid by the due date provided for on the front of this invoice, White Cube reserves the right (without limitation to White Cube’s other remedies) to charge interest at 3% over RBS base rate per annum on any such late payments until the date of actual payment; and/or elect to terminate the sale of the Work by giving written notice to the Purchaser and to keep any amount expressed to be a non-refundable deposit.  \n5.\tWhite Cube shall notify the Purchaser in writing once the Work is available for collection. If the Purchaser does not collect the Work within 30 days after White Cube has notified the Purchaser in writing that the Work is available for collection, the Purchaser shall be liable for the costs of storage from that date until the date of collection and shall pay such storage costs on receipt of an invoice from White Cube, or White Cube’s external client storage facilities, as applicable. \n6.\tThe Work shall not be released to the Purchaser until White Cube has received the full Purchase Price in cleared funds and the Purchaser has paid any storage costs due under clause 5 above. \n7.\tThe Purchaser is responsible for shipping and casing costs.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\n8.\tFrom the time and date title passes to the Purchaser, the Purchaser shall be responsible for the Work and risk shall pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\n9.\tWhilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube shall not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  From the date that title to the Work passes to the Purchaser, the Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been given by or on behalf of White Cube.\n10.\tWhere the Work is being exported, the Purchaser must send proof of export to White Cube within three months of the date of this invoice. Should the Purchaser fail to provide such proof of export satisfactory to White Cube, White Cube shall be entitled to charge the Purchaser VAT on the Purchase Price.\n11.\tWhite Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\n12.\tThe Purchaser or any borrower of the Work shall not charge a separate entry fee to view the Work (but may charge a general admission fee to view multiple works).  \n13.\tNo copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\n14.\tIf the Purchaser makes the Work available for resale:\na.\tit must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value. Fair market value shall be determined by White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable; and\nb.\tthe Purchaser shall ensure that the party acquiring the Work (the “Re-Purchaser”) enters into a binding agreement which gives White Cube equivalent rights in relation to the Work to those provided for at clause 14(a) above should such Re-Purchaser wish to sell the Work. \n15.\tWhite Cube shall deal with personal data in accordance with our privacy policy at whitecube.com. White Cube uses personal data supplied by the Purchaser for administrative purposes and to fulfil its obligations to the Purchaser related to the sale, including, where reasonably necessary, sharing the personal data with third parties, such as shippers, storage companies and professional advisors, and to keep the Purchaser informed of White Cube’s activities, unless you notify us otherwise. White Cube sells the Work as agent to the Artist and you grant White Cube the authorisation to share the invoice with the Artist’s studio for provenance records. We also transfer your personal data within White Cube’s group of companies outside the EEA.\n16.\tIf the Work is donated or sold (subject to clause 14 above) to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\n17.\tAny notices to be served under these terms and conditions shall be sent to the address of the party being served set out on the invoice. Any notices sent to White Cube shall be marked for the attention of the Finance Department. \n18.\tThese terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\n19.\tThe contract of sale of the Work and any contractual or non-contractual dispute or claim arising from or in connection with it shall be governed by the law of England and Wales. For claims against the Artist and White Cube, the courts of England and Wales shall have exclusive jurisdiction to settle all disputes arising under or in connection with the sale, but that the Artist and White Cube shall have the right to bring proceedings in any other court of competent jurisdiction within or outside of England and Wales\n\n\n\n\n\n\n\n\nPlease Note : Cyber-crime is on the increase. If you receive an email or invoice containing updated payment details, please telephone your contact at White Cube on + 44 (0)207 036 1501 to verify payment details before transferring funds.",
          typeId: 2,
          updatedAt: "2024-11-15T13:14:35.000Z",
          user: "luke",
          vatno: null,
          __typename: "Invoice",
        },
        invoiceId: 41819,
        nominalId: 4008,
        price: 4000,
        quantity: 1,
        ref: "JJ75518",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 700,
        typeId: 8,
        exported: 0,
        artworkDimensions:
          "14 1/8 x 9 13/16 in. (35.8 x 25 cm)\r\n16 1/4 x 12 x 1 9/16 in. (41.2 x 30.5 x 4 cm) (framed)",
        currency: "GBP",
        __typename: "Item",
      },
    ],
    purchasesTotal: {
      converted: 317,
      original: 300,
    },
    rating: null,
    sagecode: null,
    salesUser: {
      id: 542,
      name: "Paul Garaizabal",
      __typename: "Entity",
    },
    salesUserId: 542,
    salesUser2: {
      id: 345,
      name: "Jane Doe",
      __typename: "Entity",
    },
    salesUser2Id: 345,
    salutation: "Amela_SCRUBBED",
    siteId: null,
    storageCharge: 0,
    surname: "Love",
    title: null,
    town: " Nordhavn",
    type: {
      id: 19,
      name: "Web Buyer",
      description: "Web Buyer",
      __typename: "ContactType",
    },
    typeId: 19,
    type2: {
      id: 20,
      name: "Exhibition Buyer",
      description: "Exhibition Buyer",
      __typename: "ContactType",
    },
    type2Id: 20,
    unsubscribed: false,
    updatedAt: "2024-05-22T07:34:03.000Z",
    vat: null,
    requests: [
      {
        __typename: "Request",
        id: 4203,
        artist: {
          __typename: "Artist",
          id: 83,
          name: "Mona Hatoum",
        },
        artistId: 83,
        budgetFrom: 5000,
        budgetTo: 15000,
        contactId: 137352,
        contact: {
          __typename: "Contact",
          id: 137352,
          name: "Fred West",
        },
        date: "2024-09-20T00:00:00.000Z",
        dateClosed: null,
        description:
          "Edition or multiple, works on paper considered. For private residence.",
        notes:
          "Secondary market collector building survey of contemporary Middle Eastern artists. Also interested in Shirin Neshat if available.",
        salesUser: {
          __typename: "Entity",
          id: 487,
          name: "Sarah Mitchell",
        },
        salesUserId: 487,
        type: {
          __typename: "RequestType",
          id: 2,
          name: "Secondary",
        },
        typeId: 2,
        updatedAt: "2024-12-05T16:45:00.000Z",
      },
    ],
  },
];

export const jobs = [
  {
    __typename: "Job",
    id: 1234677,
    artworkDescriptions:
      "Berger & Simon McBurney\r\nTitle changed\r\n2021\r\nEdition 3 of 3\r\nGlass\r\n17.72 x 4.72 x 17.72 in. | (45 x 12 x 45 cm)\n13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)\r\nArchive Id 1234677",
    artistNames: "Anselm Kiefer\n",
    chargeOut: 0,
    consignmentId: null,
    costOfJob: 0,
    date: "2024-09-26T16:00:08.000Z",
    description: "Artwork needs to be checked",
    dueDate: "2024-10-12",
    duetime: "2024-10-12T11:12:00.000Z",
    expenses: null,
    hours: null,
    hoursvan: null,
    issueId: null,
    jobItems: [
      {
        id: 299509,
        jobId: 1234677,
        instance: {
          id: 85105,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          createdAt: "2024-09-26T12:53:23.000Z",
          edition: {
            id: 51811,
            ap: 0,
            artwork: {
              id: 188478,
              artFair: "Artfair",
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: "test",
              categoryId: 5,
              classId: 1,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-09-23T10:22:50.000Z",
              description:
                "13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              dimensions:
                "17.72 x 4.72 x 17.72 in. | (45 x 12 x 45 cm)\n13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              goodsCode: "9702",
              installation: null,
              installationLink: null,
              maintenance: null,
              medium: "Glass",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis:
                "For her new series of ceramic wall-based reliefs, Humeau took inspiration from Polish artist Adam Kossowski’s large mosaic panel for the Peckham Civic Center, called ‘The History of the Old Kent Road’ (1965). As the former civic centre and its Grade-II listed mural are scheduled for demolition, Humeau sought to explore the implications of a human community dismantled.\n",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2024-09-27T13:53:21.000Z",
              title: "Title changed",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2021",
            number: 3,
            __typename: "Edition",
          },
          editionNumber: 3,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ76565",
          notes: null,
          parentOnline: 0,
          ref: 76565,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 0,
          salesStrategy: null,
          statusHistory: null,
          status: {
            id: 13,
            name: "Allocated",
            online: true,
            createdAt: "2015-09-18T11:54:30.000Z",
            __typename: "Status",
          },
          updatedAt: "2024-09-26T12:53:23.000Z",
          warehouseItem: [
            {
              __typename: "WarehouseItem",
              id: 1129746,
              container: 1113890,
              category: {
                __typename: "WarehouseCategory",
                id: 1,
                description: "Fine Art",
                weightPacked: 0,
              },
              description:
                "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
              destroyed: 0,
              dimh: 3,
              dimw: 2,
              dimd: 11,
              instance: {
                __typename: "Instance",
                id: 85099,
                arrApplicable: false,
                artistRef: "ref",
                artsy: 0,
                channelEcommerce: 0,
                channelPresentation: 1,
                certificate: null,
                certificateSent: null,
                company: {
                  __typename: "Company",
                  id: 11,
                  active: -1,
                  bondMinValue: 200000,
                  code: "JJ",
                  cds: "GBTEA98256657400020220929113111",
                  consignmentCredit: null,
                  consignmentTerms:
                    'This Agreement sets out the terms on which the Consignor agrees to consign to the Consignee the Work(s). \r\n\r\n1\tDEFINITIONS \r\n\r\nIn this Agreement the following expressions shall have the following meanings:\r\n\r\n“Agreement” shall mean this Consignment Agreement;\r\n“Artist” in relation to a Work shall mean the artist specified in the consignment form above;\r\n“Collection Address” shall mean the collection address notified to the Consignee by the Consignor in advance of the collection of the Work(s); \r\n“Collection Date” shall mean the date for collection of the Work(s) by the Consignee as notified to the Consignee by the Consignor;  \r\n“Consignee” shall mean the person(s) specified as such in the consignment form;\r\n“Consignee’s Premises” shall mean the premises specified in the consignment form (or such other premises as notified to the Consignor by the Consignee in advance of the collection of the Work(s));    \r\n“Consignment Period” shall mean the period specified in the consignment form, and the same may be extended at the request of the Consignor and / or the Consignee with the written agreement of the Consignor from time to time; \r\n“Consignor” shall mean White Cube Limited whose business address is at 144-152 Bermondsey Street, London, SE1 3TQ, United Kingdom; \r\n “Return Date” shall mean the deadline for the return of the Work(s) to the Consignor which shall be the last day of the Consignment Period; \r\n“Retail Price” shall mean the retail price of the Work(s) as specified in the consignment form;\r\n“Return Delivery Address” shall mean such other delivery address as notified to the Consignee by the Consignor in advance of the delivery of the Work(s); and \r\n“Work(s)” shall mean the artwork(s) specified above.\r\n\r\n2\tCONSIGNMENT\r\n\r\n2.1\tThe Work(s) are consigned to the Consignee for display and for sale during the Consignment Period at the Retail Price (subject to clause 9.2), strictly in accordance with the terms set out in this Agreement. \r\n\r\n2.2\tThe Consignee undertakes to return any unsold Work(s) by the Return Date.\r\n\r\n2.3\tThe Consignor reserves the right to request in writing the return of any unsold Work(s) during the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request.\r\n\r\n2.4\tThe Consignor reserves the right to request in writing the return of any Work(s) in respect of which the Consignee has given notification of an agreed sale in the event that the Consignor does not receive the amount invoiced in accordance with clause 9.3.3 below in full and cleared funds within 45 days of the end of the Consignment Period and the Consignee agrees to return such Work(s) at its own cost immediately on receiving such written request. \r\n\r\n\r\n3\tCOSTS \r\n\r\nThe Consignee shall be liable for all costs associated with the consignment, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, crating, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Consignor, the cost of a technician specified by the Consignor to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). In the event that the Consignor and/or the Artist incur any costs specified under this clause 3, the Consignee shall reimburse the Consignor and/or the Artist (as appropriate) these costs promptly on receipt of an invoice. \r\n\r\n4\tFABRICATION COSTS\r\n\r\n4.1\tIf known, the fabrication costs for the Work(s) are set out in the consignment form. If the fabrication costs for the Work(s) are yet to be confirmed, such costs shall be notified to the Consignee by the Consignor.\r\n\r\n4.2\t[OPTION A: The Consignee is liable for the percentage of the fabrication costs of the Work(s) as set out in the consignment form and shall pay its share of the fabrication costs within 14 days of receiving an invoice from the Consignor for the same.]\r\n\r\n[OPTION B: If a Work sells, the Consignee shall be liable for the percentage of the fabrication costs for that Work as set out in the consignment form and shall pay its share of the fabrication costs for such Work within 14 days of receiving an invoice from the Consignor for the same.] [Use option A if the consignee is paying for fabrication irrespective of whether the Work sells but use option B if the consignee is only paying for fabrication if the work sells..]\r\n\r\n4.3\tThe Consignee shall not, and shall not authorise any third party to, undertake any work (fabrication, restoration, alteration, framing or other) on the Work(s) in any way whatsoever, without the Consignor’s prior written permission. Should the Consignor approve any such work, the Consignor agrees to pay [X]% of such costs following receipt of an invoice from the Consignee in respect thereof, together with copies of all applicable receipts in relation to such costs. \r\n\r\n5\tTRANSPORT AND CONDITION CHECKING\r\n\r\n5.1\tThe Consignee undertakes to arrange and to pay for packing and transporting of the Work(s) from the Collection Address to the Consignee’s Premises on the Collection Date, and for the packing and transporting of any unsold Work(s) back to the Return Delivery Address on or before the Return Date, at the Consignee’s cost.\r\n\r\n5.2\tThe Consignee is obliged to provide details to the Consignor of the Fine Art transport company that will be used to ship the Work(s) to the Consignee’s Premises and, if applicable, back to the Return Delivery Address and the Consignor reserves the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Consignee not, in the Consignor’s opinion, be of a suitable standard. \r\n\r\n5.3\tIf the Work(s) are transported by road, the Consignee must ensure that the Fine Art Transport company vehicle is air-ride and climate controlled and at least two people travel with the Work(s) to ensure the Work(s) are never left unattended in the vehicle. \r\n\r\n5.4\tThe Consignee shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Consignor are adhered to in full by the Consignee. The Work(s) must be returned to the Consignor in the Consignor’s crating (or such other crate as approved by the Consignor in writing). \r\n\r\n5.5\tA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of any unsold Work(s) to the Consignor at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Consignor and all associated costs shall be borne by the Consignee.\r\n\r\n5.6\tIf the Consignee’s Premises is outside the UK, the Consignee shall provide proof of export within 30 days of the Work(s) being exported from the UK.\r\n\r\n6\tINSURANCE \r\n\r\n6.1\tThe Consignee undertakes to insure the Work(s) at its own cost from the date that the Work(s) is/are released to the Consignee by the Consignor until the earlier of: (a) the Work(s) being returned to the Consignor at the Return Delivery Address; or (b) risk in the Work(s) passing to a buyer of the Work(s) (the “Insurance Period”), with an insurer approved by the Consignor and in accordance with the full Retail Price for the Work(s) appropriately and ‘nail to nail’ under an ‘All Risks’ insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) and shall, on request from the Consignor, supply the Consignor with a copy of the applicable insurance policy.  \r\n\r\n6.2\tThe interests of the Consignor and the relevant Artist in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee. Such policy and any accompanying certificate are referred to below as a "Qualifying Insurance Policy".\r\n\r\n6.3\tIt is a condition of the consignment that a copy of a Qualifying Insurance Policy must be provided to the Consignor prior to the Consignor releasing the Work(s) to the Consignee and the Consignor reserves the right to request that additional insurance is taken out if the Consignor considers this to be necessary.\r\n\r\n6.4\tIf the Work(s) suffer(s) any loss or damage during the Insurance Period which is not covered by the Qualifying Insurance Policy then the Consignee must nonetheless cover the cost of such loss or damage.\r\n\r\n6.5\tThe Consignee shall do nothing which would invalidate or restrict the ability of the Consignor, Consignee or Artist to make any claim or recover monies under the Qualifying Insurance Policy.\r\n\r\n6.6\tFor the avoidance of doubt, from the date that a Work is released to the Consignee by the Consignor neither White Cube nor the Artist shall be responsible for any subsequent deterioration of such Work, however occasioned.  \r\n\r\n7\tRIGHTS AND RESTRICTIONS \r\n\r\n7.1\tNo copyright or other intellectual property rights in the Work(s) are granted to the Consignee or the buyer and the Consignee acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n\r\n7.2\tSave as expressly permitted under clause 7.3, the Consignee shall not, and shall not authorise any third party to, do any of the following without the Consignor’s prior written permission: \r\n\r\n7.2.1\tmake any copies of the Work(s) (including any images supplied to the Consignee by the Consignor) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and \r\n\r\n7.2.2\totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public. \r\n\r\n7.3\tNotwithstanding clause 7.1 or 7.2, the Consignor requires the Consignee to take images of the Work(s) for the following purposes and to forward such images to the Consignor’s Archival Department in accordance with this clause 7.3 with the appropriate caption and credit to be used in any reproduction of the images. The Consignee shall cover the cost of such images and shall ensure that the Consignor, and the relevant Artist, have the right to exploit such images in perpetuity without further permission from or payment to the Consignee or the relevant photographers: \r\n\r\n7.3.1\tshould the Work(s) be displayed in an exhibition, the Consignee shall take high resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 100 mb) and the Consignee agrees to provide the Consignor with two (2) copies of such installation shots for each of the Works within a reasonable period of time of the exhibition opening, and in any event no later than one month after the closing of the exhibition.\r\n\r\n7.3.2\tIf the Work(s) have not been photographed before being released to the Consignee, the Consignee agrees, on receipt of the Work(s), to have the Work(s) photographed and supply 100 mb tif files for the archives of the applicable Artist(s) and for use by the Consignor and shall promptly send such files to the Consignor for the attention of the “Archive Department”. \r\n\r\n7.4\tIn addition, should the Consignor grant the Consignee permission to make any copies of the Work(s) or to exploit the Work(s) in accordance with clause 7.2 above, the Consignee agrees to provide the Consignor with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Consignor for the attention of the Archive Department:\r\n\r\n7.4.1\tall authorised printed matter (including, but not limited to, exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for any exhibition, recorded Artist’s talks, radio interviews or reviews, TV interviews or reviews); and \r\n7.4.2\tall press received in connection with any exhibition. \r\n\r\n7.5\tShould the Consignor permit the Consignee to take images of the Work(s), or provide the Consignee with images of the Work to use, in accordance with clause 7.2 above, the Consignee shall not be permitted to crop or edit such images or overlay them with text.  \r\n\r\n8\tHANDLING AND EXHIBITION OF THE WORKS \r\n\r\n8.1\tThe Work(s) are not to be sub-consigned to third parties or to be shown at art fairs or publicly displayed other than for the purposes of an Exhibition without the prior written consent of the Consignor.\r\n8.2\tFor each Work, and not withstanding clause 8.1, from the date that such Work is released to the Consignee until such time as risk in the Work passes to the buyer or the Work is returned to the Consignor (as applicable), the Consignee shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall):\r\n8.2.1\texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n\r\n8.2.2\ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n\r\n8.2.3\tensure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Consignor and that no variation from such instructions is permitted unless it has received the Consignor’s prior written approval and if this clause is not complied with, the Consignor reserves the right to request that the Work(s) is/are returned to the Consignor immediately at the Consignee’s cost;\r\n\r\n8.2.4\tensure that the Work(s) is/are displayed in a gallery complying with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Consignor or have received the Consignor’s prior written approval:  Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for works on paper;\r\n\r\n8.2.5\tensure that only personnel suitably qualified and experienced to the Consignor’s satisfaction are responsible for the handling and installation of the Work(s); \r\n\r\n8.2.6\tinform the Consignor of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) by way of a written report on how the damage/loss/alteration occurred as soon as reasonably practicable and in any event within 48 hours of any such event occurring and ensure that no restoration, re-framing or alteration of any kind is undertaken without the consultation and prior written authorisation of the Consignor; \r\n\r\n8.2.7\tensure that the Artist and the Consignor are credited in the following manner: “Courtesy of the Artist  and White Cube”, such credits to appear in a suitable place where the Work(s) is/are publicly displayed and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s), as permitted under this Agreement; and\r\n\r\n8.2.8\tensure that the Work(s) are not exhibited in connection with the promotion, advertisement or sponsorship of any person, business, product or service.\r\n\r\n9\tSALE OF WORKS  \r\n\r\n9.1\tThe Retail Price(s) are in [INSERT CURRENCY] and do not include VAT, tax or duties and any applicable taxes which are required to be added by the Consignee to the Retail Price(s) on sale. The Consignor reserves the right to request in writing confirmation of the Consignee’s VAT number at the time of invoicing. \r\n\r\n9.2\tFor each Work, the Consignee shall be entitled to extend a discount of up to [X] % of the Retail Price for such Work to potential buyers, such discount to be shared by the Consignor and the Consignee. For the avoidance of doubt, the Consignee is not permitted to extend a higher discount than [X]% but is welcome to contact the Consignor to discuss discounts for special circumstances however the Consignor shall be under no obligation to agree to the proposed discounts. \r\n\r\n9.3\tIn the event that the Consignee agrees a sale of a Work:\r\n\r\n9.3.1\tThe Consignee shall immediately notify the Consignor in writing of the agreed sale and the name and city of the collection, business or individual (the “Buyer”) to whom the Consignee has agreed to sell the Work. This information will be retained by the Consignor and the relevant Artist for their own records and will be kept confidential by the Consignor, such Artist and the Consignee.\r\n9.3.2\tThe Consignee shall, at the request of the Consignor, provide any information and verification documents required by the Consignor to enable it to carry out customer due diligence on the Consignee and the Buyer in compliance with applicable UK and EU anti-money laundering obligations. Such verification documents may include a certified scan of the passport of the Buyer of the Work. This information and documentation will be kept confidential by the Consignor and used strictly for compliance purposes only. \r\n9.3.3\tThe Consignee shall be entitled to receive a commission equating to [X] % of the sale proceeds for each Work (net of VAT or other applicable taxes) as stated on the Consignment Form. \r\n9.3.4\tAfter receiving written notice of an agreed sale from the Consignee, and provided that the Consignee has provided information and documents requested by the Consignor in accordance with clause 9.3.2 above, the Consignor shall invoice the Consignee for [X] % of the sale proceeds, together with any relevant fabrication costs for the relevant Work for which the Consignee is liable. \r\n9.3.5\tTitle to such Work(s) shall remain with the relevant Artist, and the Work(s) shall not be released to the Buyer, until the Consignor receives the amount invoiced in accordance with clause 9.3.4 in full and cleared funds. \r\n9.3.6\tThe Consignee shall ensure that the following terms are conditions of sale of the Work(s): \r\n9.3.6.1\tWhere a sale is agreed with a Buyer before the end of the Consignment Period, the Buyer must pay to the Consignee in full and cleared funds at least the amount invoiced by the Consignor to the Consignee pursuant to clause 9.3.4. above within 30 days of the end of the Consignment Period (the “Buyer Deadline”), failing which the Consignee shall have the right to cancel the sale immediately upon giving written notice to the Buyer;\r\n9.3.6.2\tThe Buyer shall comply with all instructions in relation to the installation, handling and maintenance of the Work which have been provided by or on behalf of the Artist; \r\n9.3.6.3\tThe Work shall not be sold at auction for ten years from the date that title passes to the Buyer. \r\n9.3.6    In the event that the Buyer fails to comply with the term of sale set out at clause 9.3.6.1 above such that the Consignee has not received the relevant amount in full and cleared funds by the Buyer Deadline, the Consignee agrees to give immediate written notification to the Consignor of the Buyer’s failure to comply. For the avoidance of doubt, any such notification must be given on the day after the Buyer Deadline.  \r\n\r\n10\tEND OF THE CONSIGNMENT PERIOD\r\n\r\nIf the Consignment Period is not extended with the written agreement of the Consignor, at the end of the Consignment Period: \r\n10.1\tthe Consignee shall have no right to sell or display the Work(s); and\r\n10.2\tthe Consignee shall immediately return any unsold Work(s) to the Consignor in accordance with Clause 5.\r\n\r\n11\tGENERAL \r\n\r\n11.1\tThe Consignee agrees to indemnify the Consignor and the relevant Artist fully against any loss, damage or costs  (including legal costs) which the Consignor and / or such Artist may suffer or incur as a direct or indirect result of any breach by the Consignee of any provision of this Agreement. \r\n\r\n11.2\tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n\r\n11.3\tNo variation may be made to this Agreement unless agreed in writing by both the Consignor and the Consignee. \r\n\r\n11.4\tThis Agreement shall be governed by English law and the Consignor and the Consignee submit to the exclusive jurisdiction of the English courts in relation to any disputes which may arise in connection with this Agreement. \r\n\r\nBefore the consignment(s) can be confirmed, please sign and date this Agreement to confirm your acceptance of its terms.',
                  consignmentSignOff: "For and on behalf of White Cube Limited",
                  contactId: 4449,
                  createdAt: "2015-09-15T11:46:59.000Z",
                  creditCode: "WCC",
                  creditRef: 3371,
                  crossInvoiceId: null,
                  currencyId: 1,
                  currency: {
                    __typename: "Currency",
                    id: 1,
                    code: "GBP",
                    description: "Pounds Sterling",
                    name: null,
                  },
                  hmrcAddress:
                    "HMRC\r\nIndia Buildings \r\nLiverpool Regional Centre \r\n31 Water Street copies \r\nLiverpool \r\nL2 0RD",
                  invoiceCode: "WCA",
                  invoiceDue: "1m",
                  loanTerms:
                    "1 \tDefinitions\r\n“Agent” means White Cube Limited\r\n“Agreement” means this Loan Agreement including the Loan Schedule\r\n“Artist” means the creator of the Work(s) as identified above\r\n“Borrower” means institution, gallery or individual identified in the Schedule\r\n“Collection Address” means the address from which the Work(s) shall be collected as specified in the Schedule (or such other collection address as notified to the Borrower by the Lender or Agent in advance of the collection of the Work(s)) \r\n“Collection Date” means the date for collection of the Work(s) by the Borrower as specified in the Schedule\r\n“Exhibition” means the exhibition specified in the Schedule\r\n“Exhibition Dates” means the exhibition dates specified in the Schedule\r\n“Exhibition Venue” means the exhibition venue specified in the Schedule\r\n“Lender” means the person identified as such in the Schedule\r\n“Loan Period” means the period from Collection Date until the Work(s) is/are returned by the Borrower to the Return Delivery Address\r\n“Return Date” means the deadline for return of the Work(s) to the Lender as specified in the Schedule\r\n“Return Delivery Address” means the address to which Work(s) shall be returned as specified in the Schedule (or such other delivery address as notified to the Borrower by the Lender or Agent in advance of the delivery of the Work(s)) \r\n“Work(s)” means the work(s) of art identified above\r\n\r\n2 \tLoan\r\nThe Lender agrees to loan the Work(s) to the Borrower for the purposes of the Exhibition on the terms set out in this Agreement for the Loan Period and the Borrower undertakes to return the Work(s) by the Return Date (such obligation being the essence of this Agreement).\r\n3 \tRights and Restrictions\r\n3.1 \tThe Borrower shall have the right to exhibit the Work(s) as part of the Exhibition at the Exhibition Venue for the duration of the Exhibition Dates and strictly in accordance with the terms set out in this Agreement.\r\n3.2 \tThe Borrower’s right to show the Work(s) at the Exhibition shall be limited to non-commercial exhibition of the Work(s). The Borrower shall have no right to exhibit the Work(s) in connection with the promotion, advertisement or sponsorship of any person, business, product or service PROVIDED that it is acknowledged that the foregoing restriction shall not prevent the showing of the Work(s) at the Exhibition Venue if it charges a general admission fee to view all the works (including the Work(s)) at such venue as distinct from an entry fee to view the specific Work(s). \r\n3.3 \tThe Borrower shall not, and shall not authorise any third party to, do any of the following:\r\n3.3.1 \tmake any alteration to the Work(s);\r\n3.3.2 \tsubject to clause 10.1 below, make any copies of the Work(s) or any part thereof by any means or in any media including, but not limited to, by making any film or taking any photograph of the Work(s); and\r\n3.3.3 \totherwise exploit the Work(s) by any means or in any media including, but not limited to, by including the Work(s) in any broadcast, webcast or otherwise communicating the Work(s) to the public.\r\n3.4 \tWithout limitation to the foregoing, if the Borrower wishes to make available any photographs or films of the Work(s) in connection with the publicity or advertising of the Exhibition, it shall seek the prior written authorisation of the Lender (via the Agent).\r\n3.5 \tNothing in this Agreement shall give the Borrower any proprietary rights in the Work(s). The Lender agrees to inform the Borrower of any change in ownership of the Work(s) that may occur during the Loan Period if required.\r\n3.6 \tThe Artist remains the copyright owner of the Work(s) and the Borrower acknowledges that the Artist’s moral rights in relation to the Work(s) (including his right to be identified as author and director of the Work(s)) are hereby asserted.\r\n3.7 \tFor the avoidance of doubt, save for the rights granted to the Borrower under this Agreement, all rights in the Work(s) are retained by the Artist.\r\n4 \tCredits\r\nThe Borrower agrees to credit the Lender and the Agent in the form specified on the Schedule, such credits to appear in a suitable place at the Exhibition Venue and wherever the Work(s) is/are reproduced in any medium, including but not limited to, any promotional or other publicity materials relating to the exhibition of the Work(s) or exhibition brochures, as permitted hereunder.\r\n5 \tCosts\r\n5.1 \tThe Borrower shall be liable for all costs associated with the loan, including but not limited to, all insurance, transport, installation, delivery costs (including all handling out, receiving in, condition checking, packing, casing charges and courier costs required for the safe transport of the Work(s)) and, if considered necessary by the Lender and/or Agent, the cost of a technician specified by the Lender to carry out the installation of the Work(s) (including, but not limited to, their fee and travel and accommodation expenses) together with any applicable taxes or duties (including any VAT due). \r\n5.2 \tIn the event that the Lender and/or Agent incurs any costs specified at clause 5.1 above, the Borrower shall reimburse the Agent and/or Lender these costs promptly on receipt of an invoice. \r\n5.3 \tThe Borrower shall also reimburse any costs incurred by the Lender and/or the Agent due to the failure of the Borrower to return the Work(s) by the Return Date including (without limitation) costs incurred by the Work(s) being unavailable for subsequent exhibitions or for shipment to a third party, such costs to be reimbursed promptly after the Borrower receives notice of the same.\r\n6 \tTransport\r\n6.1 \tThe Borrower shall be responsible for arranging the collection of the Work(s) from the Collection Address on the Collection Date and its/their transportation to the Exhibition Venue and return to the Return Delivery Address on or before the Return Date.  \r\n6.2 \tThe Borrower is obliged to provide details to the Agent of the Fine Art transport company that will be used to ship the Work(s) to the Exhibition Venue and back to the Return Delivery Address and the Lender and Agent reserve the right to insist upon an alternative Fine Art transport company should the Fine Art transport company proposed by the Borrower not, in the Lender’s or Agent’s opinion, be of a suitable standard.\r\n6.3 \tThe Borrower shall ensure that all instructions for packaging and transportation which are supplied by or on behalf of the Lender are adhered to in full.  \r\n6.4 \tNotwithstanding clause 6.2, when the Work(s) is/are to be transported by road at any point during the Loan Period, the Borrower must ensure that the Fine Art transport company vehicle is air-ride and climate controlled.\r\n7 \tCondition Report \r\nA condition report must be carried out on the Work(s) on the collection of the Work(s) at the Collection Address and again on the return of the Work(s) to the Lender at the Return Delivery Address. Such condition reports must be completed by a suitably experienced person approved in advance by the Agent and all associated costs shall be borne by the Borrower.\r\n8 \tHandling and Display\r\nThe Borrower shall (and shall be responsible for ensuring that its employees, officers, consultants, agents and any persons under its control shall) during the Loan Period:\r\n8.1 \texercise all due care and diligence in the transportation, handling, storage and display of the Work(s);\r\n8.2 \ttake all necessary precautions to prevent risk of loss or damage to the Work(s);\r\n8.3 \tprocure that the Work(s) is/are installed and displayed in accordance with any installation instructions (including the use of all specified equipment and materials) supplied by or on behalf of the Lender and that no variation from such instructions (including the use of all specified equipment and materials) is permitted unless it has received the Agent’s prior written approval on behalf of the Lender and, if this clause is not complied with, the Lender and/or Agent reserve the right to request that the Work(s) is/are returned to the Return Delivery Address immediately at the Borrower’s cost; \r\n8.4 \tensure that only suitably qualified and experienced personnel are responsible for the handling and installation of the Work(s);\r\n8.5 \tinform the Agent of any loss of or damage to the Work(s) or any alteration in the condition of the Work(s) as soon as reasonably practicable and in any event within 48 hours of any such event occurring, and no restoration or (where applicable) re-framing should be undertaken without the consultation and authorisation of the Lender and/or Agent; \r\n8.6 \tensure that the Exhibition Venue, where the Work(s) is/are displayed, complies with the following environmental conditions or such alternative or additional conditions which have been advised in writing by the Lender and/or Agent or have received the Lender’s and/ or Agent’s prior written approval: Temperature 20°c ± 2°c; RH 50% ± 5% and Lux 200-300 general or 50-100 for Work(s) on paper;\r\n8.7 \tensure that the Work(s) is/are guarded during the opening hours of the Exhibition and that all relevant staff at the Exhibition Venue are briefed to ensure that visitors of the Exhibition are kept from touching or interfering with the Work(s); and \r\n8.8 \tnot move the Work(s) after they have been installed without the prior written permission of the Agent.\r\n9 \tInsurance \r\n9.1 \tThe Borrower undertakes to insure the Work(s) at its own cost for the entirety of the Loan Period with an insurer approved by the Agent and in accordance with the full agreed insurance value indicated on this Agreement appropriately and “nail to nail” under an 'All Risks' exhibition insurance policy which (without limitation) shall cover all risks in connection with the transportation, handling, storage and exhibition of the Work(s) during the Loan Period.  \r\n9.2 \tThe interests of the Lender and the Agent in the Work(s) shall be notified to the insurer and they shall be noted on the policy or on a certificate accompanying the policy as the Loss Payee.  Such policy and any accompanying certificate are referred to below as a \"Qualifying Insurance Policy\".\r\n9.3 \tIt is a condition of the loan that a copy of a Qualifying Insurance Policy must be provided to the Agent prior to commencement of the Loan Period and the Lender reserves the right to request that additional insurance is taken out if the Lender or Agent considers this to be necessary.\r\n9.4 \tIf the Work(s) suffer(s) any loss or damage during the Loan Period which is not covered by the Qualifying Insurance Policy then the Borrower must nonetheless cover the cost of such loss or damage.\r\n9.5 \tThe Borrower shall do nothing which would invalidate or restrict the ability of the Borrower, Lender or Agent to make any claim or recover monies under the Qualifying Insurance Policy.\r\n10 \tGeneral\r\n10.1 \tWithin a reasonable period of time of the Exhibition opening, and in any event no later than one month after the closing of the Exhibition, the Borrower agrees to provide the Lender with two (2) copies of each of the following items in which the Work(s) is/are included, such material is to be sent to the Agent for the attention of the Archivist:\r\n10.1.1 \thigh resolution professional digital photographs of each of the Work(s) in situ (no less than 100 mb tiff files at 300 dpi and preferably 220 mb 16 bit tifs) (the “Exhibition Shots”) and the appropriate caption and credit to be used in any reproduction of the Exhibition Shots. The Borrower shall ensure that White Cube and the Artist have the right to exploit such Exhibition Shots in perpetuity without further permission from or payment to the relevant photographers;\r\n10.1.2 \tall authorised printed matter (including, but not limited to, Exhibition catalogues, pamphlets, brochures, postcards, press releases, lists of Works, invitations for the Exhibition, recorded Artist’s talks, radio interviews or reviews, TV interview of reviews); and \r\n10.1.3 \tall press received in connection with the Exhibition. \r\n10.2 \tShould the Work(s) be a film or video work, the Borrower will ensure that all the data in relation to the Work(s) is deleted from any device on which the Work(s) has been saved or downloaded immediately after the end of the Exhibition by using either of the following methods: (a) reformatting the drive on each device on which the Work(s) was saved or downloaded; or (b) in instances where (a) is not possible, deleting the files from each device on which the Work(s) was saved or downloaded. Should the Work comprise of a time based media element, this clause shall apply to such media element.\r\n10.3 \tThe Borrower agrees to indemnify the Lender and the Agent against any loss damage or cost which the Lender and Agent suffers or incurs as a result of the Borrower being in breach of or failing to perform any of its obligations under this Agreement.\r\n10.4 \tThis Agreement may be executed in one or more counterparts, each of which shall be deemed an original but all of which together will constitute one and the same instrument.\r\n10.5 \tNo variation may be made to this Agreement unless agreed in writing by both the Borrower and the Lender.\r\n10.6 \tThis Agreement is governed by the law of England and Wales and the parties submit to the exclusive jurisdiction of the courts of England and Wales",
                  loanSignOff:
                    "White Cube Limited acting as agent for the Artist",
                  photoCredit: null,
                  name: "White Cube Limited",
                  notes: null,
                  shippingEmail: null,
                  vatno: "GB982 566 574",
                },
                condition: null,
                createdAt: "2024-11-05T15:09:39.000Z",
                description:
                  "Robert Adams\nTest Artwork - Three screen prints\n\n2021\nThree screen prints in bespoke cloth bound portfolio Somerset Radiant White Tub Sized 410gsm paper with hand torn edges.\n\n27 9/16 x 39 3/8 in. | (70 x 100 cm)\n\nJJ76555\n",
                edition: {
                  __typename: "Edition",
                  id: 51807,
                  ap: 2,
                  artwork: {
                    __typename: "Artwork",
                    id: 188469,
                    artFair: null,
                    artists: [
                      {
                        __typename: "Artist",
                        id: 2,
                        bornCountry: null,
                        bornCountryId: null,
                        bornDate: null,
                        bornTown: "",
                        confidential: 0,
                        contactId: 2,
                        copyright: null,
                        defaultFabRate: null,
                        defaultSplitRate: null,
                        droitdesuite: null,
                        mailingList: null,
                        name: "Robert Adams",
                        represented: 0,
                        sageCost: "AI",
                        sharedDiscount: null,
                        terms: "terms",
                      },
                    ],
                    artworkCategory: {
                      __typename: "ArtworkCategory",
                      id: 19,
                      name: "Prints and Multiples",
                      goodsCode: null,
                    },
                    authenticity: null,
                    categoryId: 19,
                    classId: 1,
                    confidential: 0,
                    countryOfOriginId: 5,
                    createdAt: "2024-07-08T15:52:49.000Z",
                    description:
                      "Unlocated. AG.ed 19/04/2017\n \n One signed edition gifted to Amanda McDermott - need to confirm number.\n Dims given are image and paper size (fullbleed)",
                    dimensions: "27 9/16 x 39 3/8 in. | (70 x 100 cm)\n",
                    goodsCode: null,
                    installation: null,
                    installationLink: null,
                    maintenance: null,
                    medium:
                      "Three screen prints in bespoke cloth bound portfolio Somerset Radiant White Tub Sized 410gsm paper with hand torn edges.\n",
                    packing: null,
                    photographed: 0,
                    photoLink: null,
                    photoNote: null,
                    precis: null,
                    reference: null,
                    series: "White Cube Edition",
                    standardId: null,
                    technicalDimensions: null,
                    timestamp: "2024-11-15T13:16:46.000Z",
                    title: "Test Artwork - Three screen prints\n",
                    travelPack: -1,
                    videoLink: null,
                    website: 0,
                  },
                  year: "2021",
                  number: 1,
                },
                editionNumber: 1,
                fabricated: null,
                fabricatedDate: null,
                forSale: 0,
                framed: 0,
                ipad: 0,
                bondType: null,
                isBond: false,
                isGuaranteed: false,
                isOnLoan: false,
                isSecondaryMarket: false,
                locationHistory: null,
                name: "JJ76555",
                notes:
                  "Unlocated. AG.ed 19/04/2017\n \n One signed edition gifted to Amanda McDermott - need to confirm number.\n Dims given are image and paper size (fullbleed)",
                parentOnline: 0,
                ref: 76555,
                reference: null,
                returns: 0,
                returnsDirector: 0,
                status: {
                  __typename: "Status",
                  id: 4,
                  name: "On Hold",
                  online: true,
                  createdAt: "2015-09-18T11:54:30.000Z",
                },
                statusId: 4,
                salesPrice: null,
                salesStrategy: "Sales Strategy",
                statusHistory: null,
                unpackedWeight: "12kg",
                updatedAt: "2024-11-15T13:20:44.000Z",
                value: {
                  __typename: "Value",
                  id: 85614,
                  authorisedId: 1261,
                  currency: {
                    __typename: "Currency",
                    id: 3,
                    code: "EUR",
                    description: "Euro",
                    name: null,
                  },
                  currencyId: 3,
                  date: "2024-11-05",
                  maxDiscount: 13,
                  notes: null,
                  typeId: 2,
                  userId: 1195,
                  value: 13,
                  grossProfit: 13,
                },
                volume: 0,
                weight: "12kg",
                location:
                  "White Cube Limited [Bermondsey] null null 144 - 152 Bermondsey Street",
              },
              itemDescription: "test",
              itemSite: {
                __typename: "WarehouseMove",
                bondref: null,
                date: "2024-07-04",
                goodsCode: null,
                id: 1221328,
                confirmed: null,
                item: {
                  __typename: "WarehouseItem",
                  id: 1129737,
                  artistId: null,
                  category: {
                    __typename: "WarehouseCategory",
                    id: 1,
                    description: "Fine Art",
                    weightPacked: 0,
                  },
                  categoryId: 1,
                  container: null,
                  description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                  destroyed: 0,
                  dimh: null,
                  dimw: null,
                  dimd: null,
                  externalRef: null,
                  image: null,
                  instanceId: 85096,
                  itemDescription: null,
                  link: null,
                  mgroup: null,
                  notes: null,
                  packing: null,
                  packingId: null,
                  responsibleGroupId: null,
                  weight: null,
                  weightTypeId: 1,
                },
                itemId: 1129737,
                location: {
                  id: 2,
                  description: "Basement Gallery",
                  siteId: 1,
                  __typename: "WarehouseLocation",
                },
                locationId: 2,
                locref: null,
              },
              mgroup: 1,
              packing: {
                __typename: "WarehousePacking",
                id: 58,
                description: "Barrel",
                updatedAt: "2011-01-04T12:09:35.000Z",
              },
              warehouseMoves: [
                {
                  __typename: "WarehouseMove",
                  bondref: null,
                  date: "2024-07-04",
                  goodsCode: null,
                  id: 1221328,
                  confirmed: null,
                  item: {
                    __typename: "WarehouseItem",
                    id: 1129737,
                    artistId: null,
                    category: {
                      __typename: "WarehouseCategory",
                      id: 1,
                      description: "Fine Art",
                      weightPacked: 0,
                    },
                    categoryId: 1,
                    container: null,
                    description:
                      "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                    destroyed: 0,
                    dimh: null,
                    dimw: null,
                    dimd: null,
                    externalRef: null,
                    image: null,
                    instanceId: 85096,
                    itemDescription: null,
                    link: null,
                    mgroup: null,
                    notes: null,
                    packing: null,
                    packingId: null,
                    responsibleGroupId: null,
                    weight: null,
                    weightTypeId: 1,
                  },
                  itemId: 1129737,
                  location: {
                    id: 2,
                    description: "Basement Gallery",
                    siteId: 1,
                    __typename: "WarehouseLocation",
                  },
                  locationId: 2,
                  locref: null,
                },
              ],
            },
            {
              __typename: "WarehouseItem",
              id: 1129746,
              container: 1113890,
              category: {
                __typename: "WarehouseCategory",
                id: 1,
                description: "Container",
                weightPacked: 0,
              },
              description:
                "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
              destroyed: 0,
              dimh: 3,
              dimw: 2,
              dimd: 11,
              itemDescription: "test",
              itemSite: {
                __typename: "WarehouseMove",
                bondref: null,
                date: "2024-07-04",
                goodsCode: null,
                id: 1221328,
                confirmed: null,
                item: {
                  __typename: "WarehouseItem",
                  id: 1129737,
                  artistId: null,
                  category: {
                    __typename: "WarehouseCategory",
                    id: 1,
                    description: "Container",
                    weightPacked: 0,
                  },
                  categoryId: 1,
                  container: null,
                  description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                  destroyed: 0,
                  dimh: null,
                  dimw: null,
                  dimd: null,
                  externalRef: null,
                  image: null,
                  instanceId: 85096,
                  itemDescription: null,
                  link: null,
                  mgroup: null,
                  notes: null,
                  packing: null,
                  packingId: null,
                  responsibleGroupId: null,
                  weight: null,
                  weightTypeId: 1,
                },
                itemId: 1129737,
                location: {
                  id: 2,
                  description: "Basement Gallery",
                  siteId: 1,
                  __typename: "WarehouseLocation",
                },
                locationId: 2,
                locref: null,
              },
              mgroup: 1,
              packing: {
                __typename: "WarehousePacking",
                id: 58,
                description: "Barrel",
                updatedAt: "2011-01-04T12:09:35.000Z",
              },
              warehouseMoves: [
                {
                  __typename: "WarehouseMove",
                  bondref: null,
                  date: "2024-07-04",
                  goodsCode: null,
                  id: 1221328,
                  confirmed: null,
                  item: {
                    __typename: "WarehouseItem",
                    id: 1129737,
                    artistId: null,
                    category: {
                      __typename: "WarehouseCategory",
                      id: 1,
                      description: "Fine Art",
                      weightPacked: 0,
                    },
                    categoryId: 1,
                    container: null,
                    description:
                      "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                    destroyed: 0,
                    dimh: null,
                    dimw: null,
                    dimd: null,
                    externalRef: null,
                    image: null,
                    instanceId: 85096,
                    itemDescription: null,
                    link: null,
                    mgroup: null,
                    notes: null,
                    packing: null,
                    packingId: null,
                    responsibleGroupId: null,
                    weight: null,
                    weightTypeId: 1,
                  },
                  itemId: 1129737,
                  location: {
                    id: 2,
                    description: "Basement Gallery",
                    siteId: 1,
                    __typename: "WarehouseLocation",
                  },
                  locationId: 2,
                  locref: null,
                },
              ],
            },
          ],

          __typename: "Instance",
        },
        instanceId: 85105,
        artistNames: "Anselm Kiefer\n",
        __typename: "JobItem",
      },
      {
        id: 299509,
        jobId: 1234677,
        instance: {
          id: 85105,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          condition: {
            id: 2786,
            status: {
              description: "Destroyed",
              id: 6,
              updatedAt: "2004-09-01T17:57:45.000Z",
              __typename: "ConditionStatus",
            },
          },
          createdAt: "2024-09-26T12:53:23.000Z",
          edition: {
            id: 51811,
            ap: 0,
            artwork: {
              id: 188478,
              artFair: "Artfair",
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity: "test",
              categoryId: 5,
              classId: 1,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2024-09-23T10:22:50.000Z",
              description:
                "13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              dimensions:
                "17.72 x 4.72 x 17.72 in. | (45 x 12 x 45 cm)\n13.39 x 26.38 x 13.39 in. | (34 x 67 x 34 cm)\n4.72 x 4.72 in. | (12 x 12 cm)",
              goodsCode: "9702",
              installation: null,
              installationLink: null,
              maintenance: null,
              medium: "Glass",
              packing: null,
              photographed: 0,
              photoLink: null,
              photoNote: null,
              precis:
                "For her new series of ceramic wall-based reliefs, Humeau took inspiration from Polish artist Adam Kossowski’s large mosaic panel for the Peckham Civic Center, called ‘The History of the Old Kent Road’ (1965). As the former civic centre and its Grade-II listed mural are scheduled for demolition, Humeau sought to explore the implications of a human community dismantled.\n",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2024-09-27T13:53:21.000Z",
              title: "Title changed",
              travelPack: -1,
              videoLink: null,
              website: 0,
              __typename: "Artwork",
            },
            year: "2021",
            number: 3,
            __typename: "Edition",
          },
          editionNumber: 3,
          fabricated: null,
          fabricatedDate: null,
          forSale: 0,
          framed: null,
          ipad: 0,
          bondType: null,
          locationHistory: null,
          name: "JJ76565",
          notes: null,
          parentOnline: 0,
          ref: 76565,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          statusId: 0,
          salesStrategy: null,
          statusHistory: null,
          status: {
            id: 13,
            name: "Allocated",
            online: true,
            createdAt: "2015-09-18T11:54:30.000Z",
            __typename: "Status",
          },
          updatedAt: "2024-09-26T12:53:23.000Z",
          warehouseItem: [
            {
              __typename: "WarehouseItem",
              id: 1129746,
              container: 1113890,
              category: {
                __typename: "WarehouseCategory",
                id: 1,
                description: "Container",
                weightPacked: 0,
              },
              description:
                "Robert Adams\nJJ76555\n2025\n1 of 1\n5 Colour process print\n4 Colour process print\n27 9/16 x 39 3/8 in. (70 x 100 cm)\n27 9/16 x 39 3/8 in. (70 x 100 cm)\nJJ76555",
              destroyed: 0,
              dimh: 3,
              dimw: 2,
              dimd: 11,
              itemDescription: "test",
              itemSite: {
                __typename: "WarehouseMove",
                bondref: null,
                date: "2024-07-04",
                goodsCode: null,
                id: 1221328,
                confirmed: null,
                item: {
                  __typename: "WarehouseItem",
                  id: 1129737,
                  artistId: null,
                  category: {
                    __typename: "WarehouseCategory",
                    id: 1,
                    description: "Annushka Shani (personal)",
                    weightPacked: 0,
                  },
                  categoryId: 1,
                  container: null,
                  description: "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                  destroyed: 0,
                  dimh: null,
                  dimw: null,
                  dimd: null,
                  externalRef: null,
                  image: null,
                  instanceId: 85096,
                  itemDescription: null,
                  link: null,
                  mgroup: null,
                  notes: null,
                  packing: null,
                  packingId: null,
                  responsibleGroupId: null,
                  weight: null,
                  weightTypeId: 1,
                },
                itemId: 1129737,
                location: {
                  id: 2,
                  description: "Upper Floor",
                  siteId: 1,
                  __typename: "WarehouseLocation",
                },
                locationId: 2,
                locref: null,
              },
              mgroup: 1,
              packing: {
                __typename: "WarehousePacking",
                id: 58,
                description: "Barrel",
                updatedAt: "2011-01-04T12:09:35.000Z",
              },
              warehouseMoves: [
                {
                  __typename: "WarehouseMove",
                  bondref: null,
                  date: "2024-07-04",
                  goodsCode: null,
                  id: 1221328,
                  confirmed: null,
                  item: {
                    __typename: "WarehouseItem",
                    id: 1129737,
                    artistId: null,
                    category: {
                      __typename: "WarehouseCategory",
                      id: 1,
                      description: "Container",
                      weightPacked: 0,
                    },
                    categoryId: 1,
                    container: null,
                    description:
                      "Darren Almond\nT0206037\n2022\n1 of 1\nJJ76550",
                    destroyed: 0,
                    dimh: null,
                    dimw: null,
                    dimd: null,
                    externalRef: null,
                    image: null,
                    instanceId: 85096,
                    itemDescription: null,
                    link: null,
                    mgroup: null,
                    notes: null,
                    packing: null,
                    packingId: null,
                    responsibleGroupId: null,
                    weight: null,
                    weightTypeId: 1,
                  },
                  itemId: 1129737,
                  location: {
                    id: 2,
                    description: "Basement Gallery",
                    siteId: 1,
                    __typename: "WarehouseLocation",
                  },
                  locationId: 2,
                  locref: null,
                },
              ],
            },
          ],
          __typename: "Instance",
        },
        instanceId: 85105,
        artistNames: "Anselm Kiefer\n",
        __typename: "JobItem",
      },
    ],
    jobStatus: {
      id: 3,
      description: "Complete",
      __typename: "JobStatus",
    },
    jobType: {
      id: 0,
      description: "Condition Check (New York)",
      __typename: "JobType",
    },
    link: null,
    overtimehours: null,
    permanentHours: null,
    pickupId: 69,
    pickupGroup: {
      id: 69,
      name: "artfair",
      __typename: "Entity",
    },
    rate: null,
    rateStaff: null,
    rateOvertime: null,
    requestGroupId: 69,
    requestUser: {
      id: 120,
      name: "charles",
      __typename: "Entity",
    },
    requestUserId: 120,
    ratevan: null,
    statusId: 3,
    technicians: null,
    technicianNotes: null,
    typeId: 0,
    user: {
      id: 434,
      name: "adam",
      __typename: "Entity",
    },
    userId: 434,
    updatedAt: "2024-09-26T16:09:04.000Z",
    viewing: null,
  },
];

export const offers = [
  {
    __typename: "Offer",
    id: 615308,
    amount: 500.55,
    artwork: {
      id: 88834,
      artFair: null,
      artists: [
        {
          __typename: "Artist",
          id: 83,
          bornCountry: {
            __typename: "Country",
            id: 122,
            continent: "Middle East and North Africa ",
            digraph: "LB",
            name: "Lebanon",
            sagecode: 4,
            updatedAt: "2024-03-20T15:25:03.000Z",
          },
          bornCountryId: 122,
          bornDate: null,
          bornTown: "",
          confidential: 0,
          contactId: 83,
          copyright: "© Mona Hatoum",
          defaultFabRate: 60,
          defaultSplitRate: 60,
          droitdesuite: -1,
          mailingList: null,
          name: "Mona Hatoum",
          represented: 0,
          sageCost: "HAT",
          sharedDiscount: 10,
          terms: "terms",
        },
      ],
      authenticity: null,
      categoryId: 4,
      classId: null,
      confidential: 0,
      countryOfOriginId: null,
      createdAt: "2023-10-30T15:49:17.000Z",
      description: null,
      dimensions:
        "15 3/4 x 23 5/8 in. | (40 x 60 cm)\r\n16 | 1/2 x 24 3/16 x 1 1/16 in. | (41.9 x 61.5 x 2.7 cm) | (framed) ",
      goodsCode: "970110",
      installation: null,
      installationLink:
        "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Leon%20Wuidar/2%20mai%202020%20JJ77060?csf=1&web=1&e=JhH0Ki",
      maintenance: null,
      medium: "Oil on canvas",
      packing: null,
      photographed: 0,
      photoLink: null,
      photoNote: null,
      precis: null,
      reference: null,
      series: "test",
      standardId: null,
      technicalDimensions: null,
      timestamp: "2023-12-05T17:40:43.000Z",
      title: "2 mai 2020",
      travelPack: -1,
      videoLink: null,
      website: 0,
      __typename: "Artwork",
    },
    contact: {
      id: 135841,
      address: "Luvre Fosselyngen 6",
      address2: " Leil. 424",
      address3: "address_3",
      affiliations: "None",
      biography:
        "ultrices posuere cubilia Curae Phasellus ornare. Fusce mollis. Duis sit",
      collection:
        "mauris, rhoncus id, mollis nec, cursus a, enim. Suspendisse aliquet,",
      collectionActive: -1,
      company: "",
      confidential: 0,
      contactSecondary: true,
      countryId: 225,
      county: " Vestsjeen",
      createdAt: "2023-10-30T23:17:02.000Z",
      details:
        "facilisis facilisis, magna tellus faucibus leo, in lobortis tellus justo",
      dob: "2020-01-01",
      email: "whitecube-237469@crvnprojects.com",
      eori: null,
      exhUserId: null,
      firstcontactdate: "2023-10-30",
      firstcontactlocation: "Intro via Mark Scala",
      firstcontacttype: 5,
      firstUserId: 487,
      forename: "Paula_SCRUBBED",
      greeting: null,
      img: "https://placehold.jp/700x200.png",
      invoicesLength: 0,
      level: 5,
      mailingname: "Vera Fernandez",
      middlename: null,
      name: "Paula_SCRUBBED Ortega",
      notes:
        "et, magna. Praesent interdum ligula eu enim. Etiam imperdiet dictum",
      postcode: " 6824",
      prefered: "Nunc ac sem ut dolor dapibus gravida. Aliquam tincidunt, nunc",
      rating: null,
      sagecode: null,
      salesUserId: 487,
      salesUser2Id: null,
      salutation: "Ori_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Ortega",
      title: "McKinnon Curator of Modern and Contemporary Art",
      town: " Vestsjeen",
      typeId: 27,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:31:46.000Z",
      vat: null,
      __typename: "Contact",
    },
    contactId: 135841,
    currency: {
      id: 3,
      code: "EUR",
      description: "Euro",
      name: "Euro",
      __typename: "Currency",
    },
    currencyId: 3,
    date: null,
    dateClosed: null,
    exchange: null,
    hold: null,
    holdId: 123,
    holdDate: "2024-05-16T10:42:37.000Z",
    notes: null,
    priority: 0,
    rank: 1,
    status: {
      id: 5,
      description: "To Be Invoiced",
      updatedAt: "2007-07-23T12:30:55.000Z",
      __typename: "OfferStatus",
    },
    statusId: 5,
    tbiAmount: 222.11,
    tbiDate: null,
    transparency: null,
    user: null,
    updatedAt: "2023-10-31T09:54:18.000Z",
  },
  {
    __typename: "Offer",
    id: 615309,
    amount: 2333,
    artwork: {
      id: 88986,
      artFair: null,
      authenticity: null,
      categoryId: 4,
      classId: null,
      confidential: 0,
      countryOfOriginId: 223,
      createdAt: "2023-11-20T14:59:56.000Z",
      description: null,
      dimensions: "29 15/16 x 40 3/16 in. | (76 x 102 cm) ",
      goodsCode: "970110",
      installation: null,
      installationLink:
        "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Alia%20Ahmad/%5BTitle%20to%20be%20confirmed%5D%20JJ77216?csf=1&web=1&e=mwi0lD",
      maintenance: null,
      medium: "Oil on canvas",
      packing: null,
      photographed: 0,
      photoLink: null,
      photoNote: null,
      precis: null,
      reference: null,
      series: "",
      standardId: null,
      technicalDimensions: null,
      timestamp: "2024-02-21T14:50:36.000Z",
      title: "Zuwaal shams / زوال شمس ١ | Vanishing Sun/Fading Sun 1",
      travelPack: -1,
      videoLink: null,
      website: 0,
      __typename: "Artwork",
    },
    contact: {
      id: 136170,
      address: "Gamle Elvevika 50",
      address2: "Oppgang B",
      address3: "address_3",
      affiliations: "None",
      biography: "sit amet nulla. Donec non justo. Proin non massa non",
      collection:
        "parturient montes, nascetur ridiculus mus. Aenean eget magna. Suspendisse tristique",
      collectionActive: -1,
      company: "COMPANY_136170_SCRUBBED",
      confidential: 0,
      contactSecondary: true,
      countryId: null,
      county: " Maly",
      createdAt: "2023-11-21T04:25:46.000Z",
      details:
        "scelerisque neque sed sem egestas blandit. Nam nulla magna, malesuada",
      dob: "2020-01-01",
      email: null,
      eori: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: null,
      firstcontacttype: null,
      firstUserId: null,
      forename: "Priscilla_SCRUBBED",
      greeting: null,
      img: "https://placehold.jp/700x200.png",
      invoicesLength: 0,
      lastOffer: {
        id: 616502,
        artwork: {
          id: 88834,
          artFair: null,
          artists: [
            {
              __typename: "Artist",
              id: 83,
              bornCountry: {
                __typename: "Country",
                id: 122,
                continent: "Middle East and North Africa ",
                digraph: "LB",
                name: "Lebanon",
                sagecode: 4,
                updatedAt: "2024-03-20T15:25:03.000Z",
              },
              bornCountryId: 122,
              bornDate: null,
              bornTown: "",
              confidential: 0,
              contactId: 83,
              copyright: "© Mona Hatoum",
              defaultFabRate: 60,
              defaultSplitRate: 60,
              droitdesuite: -1,
              mailingList: null,
              name: "Mona Hatoum",
              represented: 0,
              sageCost: "HAT",
              sharedDiscount: 10,
              terms: "terms",
            },
          ],
          authenticity: null,
          categoryId: 4,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2023-10-30T15:49:17.000Z",
          description: null,
          dimensions:
            "15 3/4 x 23 5/8 in. | (40 x 60 cm)\r\n16 | 1/2 x 24 3/16 x 1 1/16 in. | (41.9 x 61.5 x 2.7 cm) | (framed) ",
          goodsCode: "970110",
          installation: null,
          installationLink:
            "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Leon%20Wuidar/2%20mai%202020%20JJ77060?csf=1&web=1&e=JhH0Ki",
          maintenance: null,
          medium: "Oil on canvas",
          packing: null,
          photographed: 0,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "test",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2023-12-05T17:40:43.000Z",
          title: "2 mai 2020",
          travelPack: -1,
          videoLink: null,
          website: 0,
          __typename: "Artwork",
        },
        amount: 10000,
        contactId: 137352,
        currency: {
          id: 3,
          code: "EUR",
          description: "Euro",
          name: "Euro",
          __typename: "Currency",
        },
        currencyId: 1,
        date: "2024-05-16",
        dateClosed: null,
        exchange: null,
        holdId: 86485,
        holdDate: "2024-05-16T10:42:37.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        statusId: 1,
        tbiAmount: 10000,
        tbiDate: "2024-05-16",
        transparency: null,
        user: "root",
        updatedAt: "2024-05-16T10:43:18.000Z",
        __typename: "Offer",
      },
      level: null,
      mailingname: "Cleo Hinton",
      middlename: null,
      name: "Priscilla_SCRUBBED Downs",
      notes:
        "arcu. Nunc mauris. Morbi non sapien molestie orci tincidunt adipiscing.",
      postcode: " 9061",
      prefered: "amet, faucibus ut, nulla. Cras eu tellus eu augue porttitor",
      rating: null,
      sagecode: null,
      salesUserId: null,
      salesUser2Id: null,
      salutation: "Tanya_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Downs",
      title: null,
      town: " Maly",
      typeId: 0,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:32:17.000Z",
      vat: null,
      __typename: "Contact",
    },
    contactId: 136170,
    currency: {
      id: 2,
      code: "USD",
      description: "US Dollars",
      name: "Dollars",
      __typename: "Currency",
    },
    currencyId: 2,
    date: null,
    dateClosed: null,
    exchange: null,
    hold: null,
    holdId: null,
    holdDate: "2024-05-16T10:42:37.000Z",
    notes: null,
    priority: 0,
    rank: 1,
    status: {
      id: 2,
      description: "Refused",
      updatedAt: "2004-01-12T16:56:55.000Z",
      __typename: "OfferStatus",
    },
    statusId: 2,
    tbiAmount: null,
    tbiDate: null,
    transparency: null,
    user: null,
    updatedAt: "2023-11-21T10:05:55.000Z",
  },
  {
    __typename: "Offer",
    id: 615310,
    amount: 4200,
    artwork: {
      id: 88986,
      artFair: null,
      authenticity: null,
      categoryId: 4,
      classId: null,
      confidential: 0,
      countryOfOriginId: 223,
      createdAt: "2023-11-20T14:59:56.000Z",
      description: null,
      dimensions: "29 15/16 x 40 3/16 in. | (76 x 102 cm) ",
      goodsCode: "970110",
      installation: null,
      installationLink:
        "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Alia%20Ahmad/%5BTitle%20to%20be%20confirmed%5D%20JJ77216?csf=1&web=1&e=mwi0lD",
      maintenance: null,
      medium: "Oil on canvas",
      packing: null,
      photographed: 0,
      photoLink: null,
      photoNote: null,
      precis: null,
      reference: null,
      series: "",
      standardId: null,
      technicalDimensions: null,
      timestamp: "2024-02-21T14:50:36.000Z",
      title: "Zuwaal shams / زوال شمس ١ | Vanishing Sun/Fading Sun 1",
      travelPack: -1,
      videoLink: null,
      website: 0,
      __typename: "Artwork",
    },
    contact: {
      id: 136169,
      address: "49780 Kaitlyn Locks",
      address2: " Suite 367",
      address3: "address_3",
      affiliations: "None",
      biography:
        "lorem vitae odio sagittis semper. Nam tempor diam dictum sapien.",
      collection:
        "eu erat semper rutrum. Fusce dolor quam, elementum at, egestas",
      collectionActive: -1,
      company: "COMPANY_136169_SCRUBBED",
      confidential: 0,
      contactSecondary: true,
      countryId: 190,
      county: " Alvertaside",
      createdAt: "2023-11-21T03:31:53.000Z",
      details:
        "odio vel est tempor bibendum. Donec felis orci, adipiscing non,",
      dob: "2020-01-01",
      email: null,
      eori: null,
      exhUserId: null,
      firstcontactdate: "2023-11-21",
      firstcontactlocation: null,
      firstcontacttype: 12,
      firstUserId: 1054,
      forename: "Ian_SCRUBBED",
      greeting: null,
      img: "https://placehold.jp/700x200.png",
      invoicesLength: 1,
      lastOffer: {
        id: 616502,
        artwork: {
          id: 88834,
          artFair: null,
          artists: [
            {
              __typename: "Artist",
              id: 83,
              bornCountry: {
                __typename: "Country",
                id: 122,
                continent: "Middle East and North Africa ",
                digraph: "LB",
                name: "Lebanon",
                sagecode: 4,
                updatedAt: "2024-03-20T15:25:03.000Z",
              },
              bornCountryId: 122,
              bornDate: null,
              bornTown: "",
              confidential: 0,
              contactId: 83,
              copyright: "© Mona Hatoum",
              defaultFabRate: 60,
              defaultSplitRate: 60,
              droitdesuite: -1,
              mailingList: null,
              name: "Mona Hatoum",
              represented: 0,
              sageCost: "HAT",
              sharedDiscount: 10,
              terms: "terms",
            },
          ],
          authenticity: null,
          categoryId: 4,
          classId: null,
          confidential: 0,
          countryOfOriginId: null,
          createdAt: "2023-10-30T15:49:17.000Z",
          description: null,
          dimensions:
            "15 3/4 x 23 5/8 in. | (40 x 60 cm)\r\n16 | 1/2 x 24 3/16 x 1 1/16 in. | (41.9 x 61.5 x 2.7 cm) | (framed) ",
          goodsCode: "970110",
          installation: null,
          installationLink:
            "https://whitecube0.sharepoint.com/:f:/r/sites/Artworks/Leon%20Wuidar/2%20mai%202020%20JJ77060?csf=1&web=1&e=JhH0Ki",
          maintenance: null,
          medium: "Oil on canvas",
          packing: null,
          photographed: 0,
          photoLink: null,
          photoNote: null,
          precis: null,
          reference: null,
          series: "test",
          standardId: null,
          technicalDimensions: null,
          timestamp: "2023-12-05T17:40:43.000Z",
          title: "2 mai 2020",
          travelPack: -1,
          videoLink: null,
          website: 0,
          __typename: "Artwork",
        },
        amount: 10000,
        contactId: 137352,
        currency: {
          id: 3,
          code: "EUR",
          description: "Euro",
          name: "Euro",
          __typename: "Currency",
        },
        currencyId: 1,
        date: "2024-05-16",
        dateClosed: null,
        exchange: null,
        holdId: 86485,
        holdDate: "2024-05-16T10:42:37.000Z",
        notes: null,
        priority: 0,
        rank: 1,
        statusId: 1,
        tbiAmount: 10000,
        tbiDate: "2024-05-16",
        transparency: null,
        user: "root",
        updatedAt: "2024-05-16T10:43:18.000Z",
        __typename: "Offer",
      },
      level: 5,
      mailingname: "Maggy Aguilar",
      middlename: null,
      name: "Ian_SCRUBBED Yates",
      notes:
        "quam quis diam. Pellentesque habitant morbi tristique senectus et netus",
      postcode: " ED0 9GM",
      prefered:
        "mi eleifend egestas. Sed pharetra, felis eget varius ultrices, mauris",
      rating: null,
      sagecode: null,
      salesUserId: 1054,
      salesUser2Id: null,
      salutation: "Kevin_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Yates",
      title: "Director",
      town: " Alvertaside",
      typeId: 4,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:32:17.000Z",
      vat: null,
      __typename: "Contact",
    },
    contactId: 136169,
    currency: {
      id: 2,
      code: "USD",
      description: "US Dollars",
      name: "Dollars",
      __typename: "Currency",
    },
    currencyId: 2,
    date: null,
    dateClosed: null,
    exchange: null,
    hold: null,
    holdId: null,
    holdDate: "2024-05-16T10:42:37.000Z",
    notes: "hello abc",
    priority: 0,
    rank: 1,
    status: {
      id: 2,
      description: "Refused",
      updatedAt: "2004-01-12T16:56:55.000Z",
      __typename: "OfferStatus",
    },
    statusId: 2,
    tbiAmount: null,
    tbiDate: null,
    transparency: null,
    user: "luke",
    updatedAt: "2023-11-21T10:44:52.000Z",
  },
];

export const invoices = [
  {
    __typename: "Invoice",
    id: 42722,
    address: "364 Dillon Forest",
    address2: " Apt. 809",
    address3: "address-3",
    approved: 0,
    analysisId: null,
    analysisEventId: null,
    artAdvisorId: null,
    artAdvisorSale: 0,
    bank: {
      __typename: "BankAccount",
      id: 23,
      address: "5 Market Place",
      bank: "Nat West Bank",
      county: "Surrey",
      currency: {
        __typename: "Currency",
        id: 1,
        code: "GBP",
        description: "Pounds Sterling",
        name: null,
      },
      details:
        "Nat West Bank\n5 Market Place\nKingston upon Thames\nSurrey\nKT1 1JX\n60-60-02\nJay Jopling\n44892063\nPounds Sterling",
      holder: "Jay Jopling",
      invoiceTerms:
        "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.",
      number: "44892063",
      postcode: "KT1 1JX",
      sortCode: "60-60-02",
      town: "Kingston upon Thames",
      swift: "NWBKGB2L",
      iban: "12345",
      routingNumber: "GB48 NWBK 6072 9912 3456 78",
    },
    bankId: 23,
    channelId: 1,
    chargeStorage: -1,
    company: {
      __typename: "Company",
      id: 14,
      code: null,
      crossInvoiceId: null,
      images: {
        logo: "https://placehold.jp/700x200.png",
        header: "https://placehold.jp/700x200.png",
        footer: "https://placehold.jp/700x200.png",
      },
      name: "Jay Jopling (personal)",
      vatno: "GB480 124 375",
    },
    companyId: 14,
    companyName: null,
    conduit: 1,
    contact: {
      __typename: "Contact",
      id: 137342,
      address: "Eichenkamp 47c",
      address2: " Zimmer 283",
      address3: "address_3",
      affiliations: "None",
      biography: "sodales elit erat vitae risus. Duis a mi fringilla mi",
      collection:
        "Nam porttitor scelerisque neque. Nullam nisl. Maecenas malesuada fringilla est.",
      collectionActive: -1,
      company: "COMPANY_137342_SCRUBBED",
      confidential: 0,
      contactAddresses: [],
      contactArtists: [],
      contactCompany: null,
      contactFocuses: [],
      contactMailingLists: [],
      contactNumbers: [],
      contactSecondary: true,
      countryId: null,
      country: {
        __typename: "Country",
        id: 54,
        continent: "Europe",
        digraph: "DE",
        name: "Germany",
        sagecode: 1,
        updatedAt: "2024-03-20T15:25:03.000Z",
      },
      county: " Neu Dustinland",
      createdAt: "2024-02-23T09:15:02.000Z",
      details:
        "at lacus. Quisque purus sapien, gravida non, sollicitudin a, malesuada",
      dob: "2020-01-01",
      documents: {
        IsTruncated: false,
        Contents: [],
        Name: "wc-preprod-sync",
        Prefix: "data/inventory/contact/137342/",
        MaxKeys: 1000,
        CommonPrefixes: [],
        KeyCount: 0,
      },
      email: null,
      eori: null,
      exhUser: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: "Introduction",
      firstcontacttype: 12,
      firstUser: {
        __typename: "Entity",
        id: 994,
        name: "jini",
      },
      firstUserId: 994,
      forename: "Cathleen_SCRUBBED",
      greeting: null,
      img: null,
      invoicesLength: 1,
      lastOffer: null,
      level: 5,
      mailingname: "Hilel Day",
      middlename: null,
      name: "Cathleen_SCRUBBED Moore",
      notes:
        "scelerisque neque sed sem egestas blandit. Nam nulla magna, malesuada",
      postcode: " 85909",
      prefered:
        "arcu. Vivamus sit amet risus. Donec egestas. Aliquam nec enim.",
      purchases: [],
      rating: null,
      requests: [],
      sagecode: null,
      salesUser: {
        __typename: "Entity",
        id: 994,
        name: "jini",
      },
      salesUserId: 994,
      salesUser2: null,
      salesUser2Id: null,
      salutation: "Myles_SCRUBBED",
      siteId: null,
      storageCharge: 0,
      surname: "Moore",
      title: "Chief Curator",
      town: " Neu Dustinland",
      type: {
        __typename: "ContactType",
        id: 6,
        name: "Curator",
        description: "Curator",
      },
      typeId: 6,
      type2: null,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-05-22T07:34:02.000Z",
      vat: null,
    },
    contactId: 137342,
    county: " Fredericstad",
    country: {
      __typename: "Country",
      id: 54,
      continent: "Europe",
      digraph: "DE",
      name: "Germany",
      sagecode: 1,
      updatedAt: "2024-03-20T15:25:03.000Z",
    },
    countryId: null,
    currency: {
      __typename: "Currency",
      id: 1,
      code: "GBP",
      description: "Pounds Sterling",
      name: null,
    },
    currencyId: 1,
    date: "2024-08-02",
    debtChase: -1,
    deliveryAddress: "Gielenlaan 1",
    deliveryAddress2: " 3e verdieping",
    deliveryAddress3: "address-3",
    deliveryCompany: null,
    deliveryCountryId: null,
    deliveryCounty: " Lapscheuretem",
    deliveryEmail: null,
    deliveryExpectation: null,
    deliveryHold: null,
    deliveryName: null,
    deliveryPhone: null,
    deliveryPostcode: " 6275",
    deliveryTown: " Lapscheuretem",
    destinationId: 1,
    dueDate: "2024-09-02",
    items: [
      {
        __typename: "Item",
        amount: 5000,
        artistNames: "Nathaniel Mary Quinn\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: -2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: 7099,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        exchange: 2,
        id: 267679,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              ref: 13153,
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          editionNumberFormatted: "1/2",
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        quantity: 1,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: -875,
        type: {
          __typename: "PayType",
          name: "Credit Note",
          numberId: 6,
          tax: 1,
          updatedAt: "2004-03-04T15:10:11.000Z",
          cd: -1,
        },
        typeId: 6,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
      {
        __typename: "Item",
        amount: 5000,
        artistNames: "Nathaniel Mary Quinn\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: -2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: 7100,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        exchange: 3,
        id: 267680,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        quantity: 1,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: -875,
        type: {
          __typename: "PayType",
          name: "Credit Note",
          numberId: 6,
          tax: 1,
          updatedAt: "2004-03-04T15:10:11.000Z",
          cd: -1,
        },
        typeId: 6,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
      {
        __typename: "Item",
        amount: 5000,
        artistNames: "Franz Ackermann\n",
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: null,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        exchange: 2,
        id: 267678,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              artists: [
                {
                  id: 1,
                  contactId: 2221,
                  droitdesuite: -1,
                  name: "Franz Ackermann",
                  terms: "terms",
                  __typename: "Artist",
                },
                {
                  id: 3,
                  contactId: 3,
                  droitdesuite: null,
                  name: "Bryan Adams",
                  terms: "terms",
                  __typename: "Artist",
                },
              ],
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        quantity: 1,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 875,
        type: {
          __typename: "PayType",
          name: "Sale",
          numberId: 8,
          tax: 1,
          updatedAt: "2004-07-06T15:25:58.000Z",
          cd: 1,
        },
        typeId: 8,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
    ],
    exchange: 1,
    immutable: 0,
    invoiceTotals: {
      balance: 0,
      balance30Days: 0,
      balance60Days: 0,
      current: 0,
      grossProfit: 0,
      net: 0,
      tax: 0,
      total: 0,
      netExchange: "0.00",
    },
    marginRef: null,
    marginScheme: 0,
    name: "Cathleen_SCRUBBED Moore",
    number: 102,
    notes: null,
    paymentPlan: [
      {
        id: 123,
        dueDate: "2024-08-01",
        amount: 5000,
        cancel: 1,
        createdBy: {
          id: 1,
          name: "root",
        },
        createdById: 1,
        invoiceId: 123,
        description: "payment plan",
        updatedAt: "2024-10-21",
      },
    ],
    postcode: " CL6 4MQ",
    proofdate: null,
    proforma: null,
    purchaserId: null,
    purchaserCountryId: null,
    reference: "JOP",
    registrarId: null,
    shedule: null,
    salesUser: null,
    sagecode: null,
    salesPeople: "fredwest, haroldshipman",
    invoiceSalesPersons: [
      {
        __typename: "InvoiceSalesPerson",
        id: 1,
        salesUser: {
          id: 1,
          name: "fredwest",
          __typename: "Entity",
        },
        salesUserId: 1,
        typeId: 1,
        invoiceSalesPersonType: {
          id: 1,
          name: "Primary",
          __typename: "InvoiceSalesPersonType",
        },
        split: 0.5,
        timestamp: "2024-08-02T08:46:34.000Z",
      },
      {
        __typename: "InvoiceSalesPerson",
        id: 4,
        salesUser: {
          id: 5,
          name: "haroldshipman",
          __typename: "Entity",
        },
        salesUserId: 5,
        typeId: 2,
        invoiceSalesPersonType: {
          id: 2,
          name: "Secondary",
          __typename: "InvoiceSalesPersonType",
        },
        split: 0.5,
        timestamp: "2024-08-02T08:46:34.000Z",
      },
    ],
    taxareaId: 1,
    taxRate: 17.5,
    taxArea: {
      id: 1,
      name: "VAT",
      __typename: "TaxArea",
    },
    town: " Fredericstad",
    terms:
      "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.",
    termsback:
      "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
    type: {
      __typename: "InvoiceType",
      id: 1,
      description: "Invoice",
    },
    typeId: 1,
    updatedAt: "2024-08-02T08:46:34.000Z",
    user: "root",
    vatno: null,
  },
  {
    __typename: "Invoice",
    id: 42721,
    address: null,
    address2: null,
    address3: null,
    approved: 0,
    analysisId: null,
    analysisEventId: null,
    artAdvisorId: null,
    artAdvisorSale: 0,
    bank: {
      __typename: "BankAccount",
      id: 1,
      address: "5 Market Place",
      bank: "Nat West Bank Plc",
      county: "Surrey",
      currency: {
        __typename: "Currency",
        id: 1,
        code: "GBP",
        description: "Pounds Sterling",
        name: null,
      },
      details:
        "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
      holder: "White Cube",
      invoiceTerms:
        "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
      number: "71360867(£)",
      postcode: "KT1 1JX",
      sortCode: "60-60-02",
      town: "Kingston Upon Thames",
      swift: "NWBKGB2L",
      iban: "GB48 NWBK 6072 9912 3456 78",
      routingNumber: "GB48 NWBK 6072 9912 3456 78",
    },
    bankId: 1,
    channelId: 1,
    chargeStorage: -1,
    company: {
      __typename: "Company",
      id: 1,
      code: "JJ",
      crossInvoiceId: null,
      images: {
        logo: "https://placehold.jp/700x200.png",
        header: "https://placehold.jp/700x200.png",
        footer: "https://placehold.jp/700x200.png",
      },
      name: "Jay Jopling trading as White Cube",
      vatno: "GB480 124 375",
    },
    companyId: 1,
    companyName: null,
    conduit: 1,
    contact: {
      __typename: "Contact",
      id: 137370,
      address: null,
      address2: null,
      address3: null,
      affiliations: null,
      biography: null,
      collection: null,
      collectionActive: -1,
      company: null,
      confidential: 0,
      contactAddresses: [],
      contactArtists: [],
      contactCompany: null,
      contactFocuses: [],
      contactMailingLists: [],
      contactNumbers: [],
      contactSecondary: false,
      countryId: null,
      country: null,
      county: null,
      createdAt: "2024-07-04T07:57:13.000Z",
      details: null,
      dob: null,
      documents: {
        IsTruncated: false,
        Contents: [],
        Name: "wc-preprod-sync",
        Prefix: "data/inventory/contact/137370/",
        MaxKeys: 1000,
        CommonPrefixes: [],
        KeyCount: 0,
      },
      email: null,
      eori: null,
      exhUser: null,
      exhUserId: null,
      firstcontactdate: null,
      firstcontactlocation: null,
      firstcontacttype: null,
      firstUser: null,
      firstUserId: null,
      forename: "",
      greeting: null,
      img: null,
      invoicesLength: 6,
      lastOffer: null,
      level: null,
      mailingname: null,
      middlename: null,
      name: " Test",
      notes: null,
      postcode: null,
      prefered: null,
      purchases: [
        {
          __typename: "Item",
          amount: -1000,
          commission: 0,
          commissionRate: 25,
          consigneeSplit: 0,
          consigneeSplitRate: 0,
          creditId: null,
          customs: 0,
          date: "2024-07-25",
          description: null,
          discount: 0,
          discountRate: 0,
          id: 267650,
          instanceId: null,
          invoiceId: 42715,
          nominalId: null,
          price: -1000,
          ref: null,
          showDiscount: null,
          sourceId: null,
          tax: 0,
          taxAmount: 0,
          typeId: 2,
          exported: 0,
          artworkDimensions: null,
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -100,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 0,
          consigneeSplitRate: 0,
          creditId: null,
          customs: 0,
          date: "2024-07-26",
          description: null,
          discount: 0,
          discountRate: 0,
          id: 267652,
          instanceId: null,
          invoiceId: 42715,
          nominalId: null,
          price: -100,
          ref: null,
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 17.5,
          typeId: 2,
          exported: 0,
          artworkDimensions: null,
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -500,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 0,
          consigneeSplitRate: 0,
          creditId: 7077,
          customs: 0,
          date: "2024-08-01",
          description: null,
          discount: 0,
          discountRate: 0,
          id: 267653,
          instanceId: null,
          invoiceId: 42715,
          nominalId: null,
          price: -500,
          ref: null,
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: -87.5,
          typeId: 6,
          exported: 0,
          artworkDimensions: null,
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 1000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 0,
          consigneeSplitRate: 0,
          creditId: null,
          customs: 0,
          date: "2024-07-25",
          description: null,
          discount: 0,
          discountRate: 0,
          id: 267651,
          instanceId: null,
          invoiceId: 42715,
          nominalId: null,
          price: 1000,
          ref: null,
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 0,
          typeId: 8,
          exported: 0,
          artworkDimensions: null,
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -10887.5,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 0,
          consigneeSplitRate: 0,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description: null,
          discount: 0,
          discountRate: 0,
          id: 267663,
          instanceId: null,
          invoiceId: 42719,
          nominalId: null,
          price: -10887.5,
          ref: null,
          showDiscount: null,
          sourceId: null,
          tax: 0,
          taxAmount: 0,
          typeId: 14,
          exported: 0,
          artworkDimensions: null,
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -10000,
          consigneeSplitRate: 100,
          creditId: 7086,
          customs: 0,
          date: "2024-08-01",
          description:
            "avril 1996\n1996\nPen, pencil and watercolor on paper collage\nImage size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)\nJJ76887\n",
          discount: 0,
          discountRate: 0,
          id: 267664,
          instanceId: 85378,
          invoiceId: 42719,
          nominalId: 4008,
          price: -10000,
          ref: "JJ76887",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: -887.5,
          typeId: 6,
          exported: 0,
          artworkDimensions:
            "Image size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -10000,
          consigneeSplitRate: 100,
          creditId: 7087,
          customs: 0,
          date: "2024-08-01",
          description:
            "avril 1996\n1996\nPen, pencil and watercolor on paper collage\nImage size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)\nJJ76887\n",
          discount: 0,
          discountRate: 0,
          id: 267665,
          instanceId: 85378,
          invoiceId: 42719,
          nominalId: 4008,
          price: -10000,
          ref: "JJ76887",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 887.5,
          typeId: 6,
          exported: 0,
          artworkDimensions:
            "Image size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 10000,
          consigneeSplitRate: 100,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "avril 1996\n1996\nPen, pencil and watercolor on paper collage\nImage size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)\nJJ76887\n",
          discount: 0,
          discountRate: 0,
          id: 267662,
          instanceId: 85378,
          invoiceId: 42719,
          nominalId: 4008,
          price: 10000,
          ref: "JJ76887",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 887.5,
          typeId: 8,
          exported: 0,
          artworkDimensions:
            "Image size: 13 5/8 x 13 5/8 in. (34.6 x 34.6 cm)\r\nPaper size: 14 3/16 x 14 3/16 in. (36 x 36 cm)\r\n20 3/16 x 20 3/16 x 1 3/16 in. (51.3 x 51.3 x 3 cm) (framed)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -15000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -7500,
          consigneeSplitRate: 50,
          creditId: 7095,
          customs: 0,
          date: "2024-08-01",
          description:
            "Cerith Wyn Evans\nWith the advent of Radio Astronomy...\n2004\nVinyl text\nDimensions variable\nJJ19960\n",
          discount: 0,
          discountRate: 0,
          id: 267673,
          instanceId: 25284,
          invoiceId: 42720,
          nominalId: 4008,
          price: -15000,
          ref: "JJ19960",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 2625,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -15000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -7500,
          consigneeSplitRate: 50,
          creditId: 7096,
          customs: 0,
          date: "2024-08-01",
          description:
            "Cerith Wyn Evans\nWith the advent of Radio Astronomy...\n2004\nVinyl text\nDimensions variable\nJJ19960\n",
          discount: 0,
          discountRate: 0,
          id: 267674,
          instanceId: 25284,
          invoiceId: 42720,
          nominalId: 4008,
          price: -15000,
          ref: "JJ19960",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 2625,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 15000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 7500,
          consigneeSplitRate: 50,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "Cerith Wyn Evans\nWith the advent of Radio Astronomy...\n2004\nVinyl text\nDimensions variable\nJJ19960\n",
          discount: 0,
          discountRate: 0,
          id: 267672,
          instanceId: 25284,
          invoiceId: 42720,
          nominalId: 4008,
          price: 15000,
          ref: "JJ19960",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 2625,
          typeId: 8,
          exported: 0,
          artworkDimensions: "Dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -2500000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -1000000,
          consigneeSplitRate: 40,
          creditId: 7092,
          customs: 0,
          date: "2024-08-01",
          description:
            "Sam Taylor-Johnson\n21st Century Fox\n2008\nEdition 3 / 10\nC-Print\nImage size: 24 x 24 in. (61 x 61 cm)\nJJ32291\n",
          discount: 0,
          discountRate: 0,
          id: 267670,
          instanceId: 37881,
          invoiceId: 42720,
          nominalId: 4008,
          price: -2500000,
          ref: "JJ32291",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 437500,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Image size: 24 x 24 in. (61 x 61 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -2500000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -1000000,
          consigneeSplitRate: 40,
          creditId: 7093,
          customs: 0,
          date: "2024-08-01",
          description:
            "Sam Taylor-Johnson\n21st Century Fox\n2008\nEdition 3 / 10\nC-Print\nImage size: 24 x 24 in. (61 x 61 cm)\nJJ32291\n",
          discount: 0,
          discountRate: 0,
          id: 267671,
          instanceId: 37881,
          invoiceId: 42720,
          nominalId: 4008,
          price: -2500000,
          ref: "JJ32291",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 437500,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Image size: 24 x 24 in. (61 x 61 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 2500000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 1000000,
          consigneeSplitRate: 40,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "Sam Taylor-Johnson\n21st Century Fox\n2008\nEdition 3 / 10\nC-Print\nImage size: 24 x 24 in. (61 x 61 cm)\nJJ32291\n",
          discount: 0,
          discountRate: 0,
          id: 267669,
          instanceId: 37881,
          invoiceId: 42720,
          nominalId: 4008,
          price: 2500000,
          ref: "JJ32291",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 437500,
          typeId: 8,
          exported: 0,
          artworkDimensions: "Image size: 24 x 24 in. (61 x 61 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -2500,
          consigneeSplitRate: 50,
          creditId: 7097,
          customs: 0,
          date: "2024-08-01",
          description:
            "Andreas Golder\nRomantisches Auge\n2009\nOil on paper\n24 5/8 x 19 11/16 in. (62.5 x 50 cm)\nJJ34926\n",
          discount: 0,
          discountRate: 0,
          id: 267676,
          instanceId: 40546,
          invoiceId: 42720,
          nominalId: 4008,
          price: 5000,
          ref: "JJ34926",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 875,
          typeId: 6,
          exported: 0,
          artworkDimensions: "24 5/8 x 19 11/16 in. (62.5 x 50 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -2500,
          consigneeSplitRate: 50,
          creditId: 7098,
          customs: 0,
          date: "2024-08-01",
          description:
            "Andreas Golder\nRomantisches Auge\n2009\nOil on paper\n24 5/8 x 19 11/16 in. (62.5 x 50 cm)\nJJ34926\n",
          discount: 0,
          discountRate: 0,
          id: 267677,
          instanceId: 40546,
          invoiceId: 42720,
          nominalId: 4008,
          price: 5000,
          ref: "JJ34926",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: -875,
          typeId: 6,
          exported: 0,
          artworkDimensions: "24 5/8 x 19 11/16 in. (62.5 x 50 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 2500,
          consigneeSplitRate: 50,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "Andreas Golder\nRomantisches Auge\n2009\nOil on paper\n24 5/8 x 19 11/16 in. (62.5 x 50 cm)\nJJ34926\n",
          discount: 0,
          discountRate: 0,
          id: 267675,
          instanceId: 40546,
          invoiceId: 42720,
          nominalId: 4008,
          price: 5000,
          ref: "JJ34926",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 875,
          typeId: 8,
          exported: 0,
          artworkDimensions: "24 5/8 x 19 11/16 in. (62.5 x 50 cm)",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -10000,
          consigneeSplitRate: 100,
          creditId: 7088,
          customs: 0,
          date: "2024-08-01",
          description:
            "Resting Place\n2023\nTerracotta\n244 figures, dimensions variable\nJJ76830\n",
          discount: 0,
          discountRate: 0,
          id: 267667,
          instanceId: 85317,
          invoiceId: 42720,
          nominalId: 4008,
          price: -10000,
          ref: "JJ76830",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 1750,
          typeId: 6,
          exported: 0,
          artworkDimensions: "244 figures, dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: -10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -10000,
          consigneeSplitRate: 100,
          creditId: 7089,
          customs: 0,
          date: "2024-08-01",
          description:
            "Resting Place\n2023\nTerracotta\n244 figures, dimensions variable\nJJ76830\n",
          discount: 0,
          discountRate: 0,
          id: 267668,
          instanceId: 85317,
          invoiceId: 42720,
          nominalId: 4008,
          price: -10000,
          ref: "JJ76830",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 1750,
          typeId: 6,
          exported: 0,
          artworkDimensions: "244 figures, dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 10000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 10000,
          consigneeSplitRate: 100,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "Resting Place\n2023\nTerracotta\n244 figures, dimensions variable\nJJ76830\n",
          discount: 0,
          discountRate: 0,
          id: 267666,
          instanceId: 85317,
          invoiceId: 42720,
          nominalId: 4008,
          price: 10000,
          ref: "JJ76830",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 1750,
          typeId: 8,
          exported: 0,
          artworkDimensions: "244 figures, dimensions variable",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -2500,
          consigneeSplitRate: 50,
          creditId: 7099,
          customs: 0,
          date: "2024-08-01",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          discount: 0,
          discountRate: 0,
          id: 267679,
          instanceId: 19605,
          invoiceId: 42721,
          nominalId: 4008,
          price: 5000,
          ref: "JJ14461",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: -875,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Duration: 7 minutes",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: -2500,
          consigneeSplitRate: 50,
          creditId: 7100,
          customs: 0,
          date: "2024-08-01",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          discount: 0,
          discountRate: 0,
          id: 267680,
          instanceId: 19605,
          invoiceId: 42721,
          nominalId: 4008,
          price: 5000,
          ref: "JJ14461",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: -875,
          typeId: 6,
          exported: 0,
          artworkDimensions: "Duration: 7 minutes",
          currency: "GBP",
        },
        {
          __typename: "Item",
          amount: 5000,
          commission: 0,
          commissionRate: 0,
          consigneeSplit: 2500,
          consigneeSplitRate: 50,
          creditId: null,
          customs: 0,
          date: "2024-08-01",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          discount: 0,
          discountRate: 0,
          id: 267678,
          instanceId: 19605,
          invoiceId: 42721,
          nominalId: 4008,
          price: 5000,
          ref: "JJ14461",
          showDiscount: null,
          sourceId: null,
          tax: 1,
          taxAmount: 875,
          typeId: 8,
          exported: 0,
          artworkDimensions: "Duration: 7 minutes",
          currency: "GBP",
        },
      ],
      rating: null,
      requests: [],
      sagecode: null,
      salesUser: null,
      salesUserId: null,
      salesUser2: null,
      salesUser2Id: null,
      salutation: "Hello",
      siteId: null,
      storageCharge: 0,
      surname: "Test",
      title: null,
      town: null,
      type: {
        __typename: "ContactType",
        id: 3,
        name: "Artist",
        description: "Artist",
      },
      typeId: 3,
      type2: null,
      type2Id: null,
      unsubscribed: null,
      updatedAt: "2024-07-04T07:57:13.000Z",
      vat: null,
    },
    contactId: 137370,
    county: null,
    country: null,
    countryId: null,
    currency: {
      __typename: "Currency",
      id: 1,
      code: "GBP",
      description: "Pounds Sterling",
      name: null,
    },
    currencyId: 1,
    date: "2024-08-01",
    debtChase: -1,
    deliveryAddress: "test",
    deliveryAddress2: "test",
    deliveryAddress3: "test",
    deliveryCompany: null,
    deliveryCountryId: null,
    deliveryCounty: null,
    deliveryEmail: null,
    deliveryExpectation: null,
    deliveryHold: null,
    deliveryName: null,
    deliveryPhone: null,
    deliveryPostcode: null,
    deliveryTown: null,
    destinationId: 1,
    dueDate: "2024-09-01",
    items: [
      {
        __typename: "Item",
        amount: 5000,
        commission: 0,
        commissionRate: 0,
        consigneeSplit: -2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: 7099,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        id: 267679,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: -875,
        type: {
          __typename: "PayType",
          name: "Credit Note",
          numberId: 6,
          tax: 1,
          updatedAt: "2004-03-04T15:10:11.000Z",
          cd: -1,
        },
        typeId: 6,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
      {
        __typename: "Item",
        amount: 5000,
        commission: 0,
        commissionRate: 0,
        consigneeSplit: -2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: 7100,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        id: 267680,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: -875,
        type: {
          __typename: "PayType",
          name: "Credit Note",
          numberId: 6,
          tax: 1,
          updatedAt: "2004-03-04T15:10:11.000Z",
          cd: -1,
        },
        typeId: 6,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
      {
        __typename: "Item",
        amount: 5000,
        commission: 0,
        commissionRate: 0,
        consigneeSplit: 2500,
        consigneeSplitRate: 50,
        consignmentChannel: null,
        creditId: null,
        customs: 0,
        date: "2024-08-01",
        description:
          "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
        discount: 0,
        discountRate: 0,
        id: 267678,
        instance: {
          __typename: "Instance",
          id: 19605,
          arrApplicable: false,
          artistRef: null,
          artsy: 0,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificate: null,
          certificateSent: null,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          condition: null,
          createdAt: "2015-09-15T11:46:08.000Z",
          description:
            "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
          edition: {
            __typename: "Edition",
            id: 10842,
            ap: -1,
            artwork: {
              __typename: "Artwork",
              id: 10233,
              artFair: null,
              authenticity:
                "Certificates signed by artist and dated 04 APR 2006",
              categoryId: 2,
              classId: null,
              confidential: 0,
              countryOfOriginId: null,
              createdAt: "2015-09-15T11:43:17.000Z",
              description: "This film has sound\r\nSee Precis",
              dimensions: "Duration: 7 minutes ",
              goodsCode: "9703",
              installation: "DAT: 25 frps\r\nprint is 300 ft",
              installationLink: null,
              images: [
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13153,
                  channelDisplayOnline: 1,
                  description:
                    "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/a/a13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=7cf1d2a3a51d15fe88011d4ccb0d3bd8b23824f8e19f25b519c8eb42584066bf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/b/b13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=a5328ef1c88f9b9fdfdb60841447d2a179a891fffbb659c0df357ae88cf09b08&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/x/x13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b5bc5b5321889cfc568480d6b1adf673d459eaf3da5e021f65297e1ade6187b8&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 13363,
                  channelDisplayOnline: 1,
                  description:
                    "2 Image 1 (Approced) Production stills There is no A3 image",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/t/t13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b32f847abb6cc6058223a90c0c1943dd98499aef7044dfa4fc7218618da02fdf&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/a/a13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=73ce49a0bdf208e670e8ff32944128761baa434d3965bf18daa83d2bba29f9c5&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/b/b13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e16cf5f3c151de6a3bf700c7247d007a7500fd64d87765103857228d9a8f598a&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 6756,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-06-14",
                    description: "Scans made by Runa here of stills",
                    formatId: 9,
                    id: 6756,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:19.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/6/x/x13363.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6a69e92e6eda9288258aea96723a9717769f4578cb68ac0fbacd34c7dbbc005d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14075,
                  channelDisplayOnline: 1,
                  description:
                    "3 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/t/t14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=0ab673669bfa0d1615a3e3f78d60e26472ca5f7c8afa71253dab03fc39e12a07&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/a/a14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=685e1bebd51ea6c4894597b98d3b83630bed82457cfeff23675a771debc7dcdf&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/b/b14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5a5bb014e45218dbd1a471c5e6b7026eb646eadd2f34c5cc8e00b0005e035eee&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/5/7/x/x14075.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e1bd63a6ff29eaa29d4a22989f4bb560ee54505ad5aabc34e76ef395b5cfbf5f&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14076,
                  channelDisplayOnline: 1,
                  description:
                    "4 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/t/t14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1573053602738624fe1a097902b504d82233b837e0a6a4bb9795bf276f2d5df0&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/a/a14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=bcabb1078581a26f2da62330523b75fc2d6a3eb7f4e0332af14a3ef0eb42a8e7&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/b/b14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=247564d03604ef62f74a5016e1bdb08c6efc72422633f6e0ce55d89721c3edcf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/7/x/x14076.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=645b951f0cf9ff9198288bf6839e2a2fe5f6f6d1f9deb02ed464b118948699c6&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 14077,
                  channelDisplayOnline: 1,
                  description:
                    "5 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/t/t14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=05aa39be4b6c576655699eed2eb198b5867788697e1549c824aa2561ef8b033c&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/a/a14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=d44f3f1027d398b166104643b6c4ff48f4d00b41a7c81ec16db36d4d813be3c6&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/b/b14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=e853119b59c5e110c3fa268ee679026a63fd2106b723cf89075eeb5835f56adf&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/7/x/x14077.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=497f599f2a3b8d680862f1bf2a2b97ac23c925517b92410905cb15fe7ce6da3d&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16824,
                  channelDisplayOnline: 1,
                  description:
                    "6 Installation Camden Arts Centre, London 2005 Photo: Andy Keate",
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/t/t16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=66719679fea313db17444ca7da79f2b5a7f827d2ea4861b329c60fb3a7333ad1&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/a/a16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=35d7d45f5b42ffe28e4643f2148053a5813459851af1263fc001fedb89294cad&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/b/b16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=83638e793a653058f36401e9f6061f1579f7d80077bf0c97d581e79311db8337&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 7568,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2005-10-25",
                    description:
                      "2 copies of three shots (2 of the shots are dupes as only one trannie was received of two of the shots)",
                    formatId: 7,
                    id: 7568,
                    number: 6,
                    original: -1,
                    photographer: "Andy Keate",
                    updatedAt: "2009-04-09T16:04:20.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/2/x/x16824.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=70b6bca996b27b1f50b7d7de4b48add5d96603542093438cb143134833f7c50e&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16833,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/t/t16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=15f96705df277da964441127e396b9305d71d5b0a2bbcdb22ac35dc0d9b84719&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/a/a16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=896c6eec439507fa0c79932280f71b63fcc19ee6f1dc737fd46d3c87b5e55cfd&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/b/b16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=55392a0663ea74014735d3984935c6f471ae97a5feaf3e6ea3c8abb314fb3cac&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 18083,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2008-05-09",
                    description:
                      "Cropped from the second image of three stills, top one",
                    formatId: 9,
                    id: 18083,
                    number: 1,
                    original: -1,
                    photographer: null,
                    updatedAt: "2009-04-09T16:04:24.000Z",
                  },
                  updatedAt: "2017-04-21T15:40:02.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/3/x/x16833.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=5aac8efc4b34e4f435438e09a29c311fa937eed35658c6971a320643d00f0d6a&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 16834,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/t/t16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6add2817df7c6d15416df5f634f8fda5f7e92fe6a9060ece22732f22059d68d3&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/a/a16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=db4f0520ae8afc9b4036f8bab89fe5a08a7dc69b1b98b35522e8f91778990128&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/b/b16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=493531578c0eb7a8d54f79f3f24924d2f4809f42b3e0bfcff8dd0b5045f0a967&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/4/3/x/x16834.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=232c8b4318e69e9a6e86ab145cb3516449aa67b7be2e68147466fa4c1200a730&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 28593,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/t/t28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=b546c1322b7624a97a83be4d8ee42f0e76ceca8d7a05dfa1901bfc993833648e&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/a/a28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c1d1520dc775bfc6cf03650a5ffbfa92ca779aafa2bacb79bc769b10daa69f77&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/b/b28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=c0dcfa0917ea51892f0797e0a96125d0acc4dca42cb77196992b3d94ad394952&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 22431,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: null,
                    date: "2009-02-27",
                    description:
                      "223 MB 16 bit TIFFs shot at Turner Prize, Tate Britain 2008",
                    formatId: 9,
                    id: 22431,
                    number: 2,
                    original: -1,
                    photographer: "White Cube (Todd-White Art Photography)",
                    updatedAt: "2015-07-16T11:44:36.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2013-02-06T17:29:34.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/9/x/x28593.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=6b1cac9d07fde79c637e1af6b37ca6bd4cdbdd2d3f1f9209c16fb1674d7af4a0&X-Amz-SignedHeaders=host",
                },
                {
                  __typename: "Image",
                  artworkId: 10233,
                  archiveId: 37367,
                  channelDisplayOnline: 1,
                  description: null,
                  downloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/t/t37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3adbe94df64f41ae12cb7aadf055b33179ad7ecba82c363dd533bcc414b4f47b&X-Amz-SignedHeaders=host",
                  imgX: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                  imgA: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/a/a37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=3a72fcf95e14d3c682a8d7c2ea06155d30bc959a7ec623db9c7485ce86632b47&X-Amz-SignedHeaders=host",
                  imgB: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/b/b37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=1caecbb0e4369d5a237efcb534a2c2f80e54fbaee4441bb8c144bf97ef6b5a4d&X-Amz-SignedHeaders=host",
                  jpegUrls: null,
                  order: null,
                  photoMaterialId: 26130,
                  photoMaterial: {
                    __typename: "PhotoMaterial",
                    artworkId: 10233,
                    credit: "White Cube",
                    date: "2010-12-15",
                    description: "129mb tif form print JJ18371",
                    formatId: 9,
                    id: 26130,
                    number: 1,
                    original: 0,
                    photographer: null,
                    updatedAt: "2010-12-15T11:25:56.000Z",
                  },
                  updatedAt: "2013-05-09T13:35:45.000Z",
                  uploadedAt: "2010-12-15T11:26:04.000Z",
                  urls: {
                    t: null,
                    x: null,
                    a: null,
                    b: null,
                  },
                  xDownloadPath:
                    "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/7/6/x/x37367.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=ba9044346d1c362875fa57c4a89446a8111cb6b22363dd36ac773c6c8dc3b0f2&X-Amz-SignedHeaders=host",
                },
              ],
              imagesSummary: {
                __typename: "Image",
                artworkId: 10233,
                archiveId: 13153,
                channelDisplayOnline: 1,
                description:
                  "1 Image 1 (Approved) Production stills. There is no A3 image (see link for more film stills)",
                downloadPath: "https://placehold.jp/600x600.png",
                imgT: "https://placehold.jp/600x600.png",
                imgX: "https://placehold.jp/600x600.png",
                imgA: "https://placehold.jp/600x600.png",
                imgB: "https://placehold.jp/600x600.png",
                jpegUrls: null,
                order: null,
                photoMaterialId: 6756,
                photoMaterial: {
                  __typename: "PhotoMaterial",
                  artworkId: 10233,
                  credit: "White Cube",
                  date: "2005-06-14",
                  description: "Scans made by Runa here of stills",
                  formatId: 9,
                  id: 6756,
                  number: 1,
                  original: 0,
                  photographer: null,
                  updatedAt: "2009-04-09T16:04:19.000Z",
                },
                updatedAt: "2013-05-09T13:35:45.000Z",
                uploadedAt: "2013-02-06T17:29:34.000Z",
                urls: {
                  t: null,
                  x: null,
                  a: null,
                  b: null,
                },
                xDownloadPath: "https://placehold.jp/600x600.png",
              },
              maintenance: null,
              medium: "16mm film",
              packing: null,
              photographed: 0,
              photoLink:
                "\\\\Goliath\\images\\artists\\Runa Islam\\Film Stills\\First Day of Spring",
              photoNote: null,
              precis:
                "First Day of Spring (2005), a 16mm film, is characterised by a sense of stillness. Shot in Dhaka, Bangladesh on the official first day of spring the 7-minute film loop shows a group of rickshaw drivers at rest against the backdrop of the noise and bustle of the cityscape. Islam paid each driver a day’s wages to do nothing, in a comment on the city’s working conditions and labour structures.\r\n\r\n“For First Day of Spring (2005), which is in MoMA’s and Tate's collections, Islam paid a group of Bangladeshi rickshaw operators to have a day of leisure in the middle of the public park, where she filmed them relaxing on their rickshaws under the shade of trees, calling into question the distinction between documentary and staged filmmaking. .”\r\n-\tExcerpt from Art Office on Runa Islam  MA \thttp://artoffice.org/t/runa-islam/\r\n\r\n\r\n \"(…) the piece challenges traditional cinematic technique. Islam’s takes are long, almost static, and her camera approaches the group of rickshaw drivers from a range of perspectives, pausing every now and again to record the gentle spring breeze blowing through the foliage, then zooming in to capture individual faces before the drivers take off into the evening sunlight. With its subtle intensity and visual power, ‘First Day of Spring’ is an enthralling work of art, both a critique of cinematic legerdemain and an exposé of socio-political phenomena.”\r\n-\tExcerpt from the Press release by Kunsthaus Zürich http://www.kunsthaus.ch/fileadmin/templates/kunsthaus/pdf/medienmitteilungen/2008/pm_islam_e.pdf",
              reference: null,
              series: "test",
              standardId: 0,
              technicalDimensions: null,
              timestamp: "2016-10-24T15:56:32.000Z",
              title: "First Day of Spring",
              travelPack: null,
              videoLink: null,
              website: 0,
              base64Image:
                "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/3/5/t/t13153.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20240816%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20240816T113314Z&X-Amz-Expires=3600&X-Amz-Signature=622b645718890aa4658ba82fb950465ecc18743e347bb1df255d9afbef3e84f0&X-Amz-SignedHeaders=host",
            },
            year: "2005",
            number: 2,
          },
          editionNumber: 1,
          fabricated: -1,
          fabricatedDate: null,
          forSale: -1,
          framed: null,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          locationHistory: null,
          name: "JJ14461",
          notes: null,
          parentOnline: 0,
          ref: 14461,
          reference: null,
          returns: 0,
          returnsDirector: 0,
          status: {
            __typename: "Status",
            id: 3,
            name: "Sold",
            online: true,
            createdAt: "2015-09-18T10:54:30.000Z",
          },
          statusId: 3,
          salesStrategy: null,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2024-08-01T13:41:40.000Z",
          value: null,
          weight: "132kg",
          volume: 0,
          location: "Tate Store Ms.Sarah Miller 7-14 Mandela Way",
        },
        instanceId: 19605,
        invoice: {
          __typename: "Invoice",
          id: 42721,
          address: null,
          address2: null,
          address3: null,
          approved: 0,
          analysisId: null,
          analysisEventId: null,
          artAdvisorId: null,
          artAdvisorSale: 0,
          bank: {
            __typename: "BankAccount",
            id: 1,
            address: "5 Market Place",
            bank: "Nat West Bank Plc",
            county: "Surrey",
            details:
              "Nat West Bank Plc\n5 Market Place\nKingston Upon Thames\nSurrey\nKT1 1JX\n60-60-02\nWhite Cube\n71360867(£)\nPounds Sterling",
            holder: "White Cube",
            invoiceTerms:
              "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
            number: "71360867(£)",
            postcode: "KT1 1JX",
            sortCode: "60-60-02",
            town: "Kingston Upon Thames",
            swift: "NWBKGB2L",
            iban: "GB48 NWBK 6072 9912 3456 78",
            routingNumber: "GB48 NWBK 6072 9912 3456 78",
          },
          bankId: 1,
          channelId: 1,
          chargeStorage: -1,
          company: {
            __typename: "Company",
            id: 1,
            code: "JJ",
            crossInvoiceId: null,
            name: "Jay Jopling trading as White Cube",
            vatno: "GB480 124 375",
          },
          companyId: 1,
          companyName: null,
          conduit: 1,
          contact: {
            __typename: "Contact",
            id: 137370,
            address: null,
            address2: null,
            address3: null,
            affiliations: null,
            biography: null,
            collection: null,
            collectionActive: -1,
            company: null,
            confidential: 0,
            contactSecondary: false,
            countryId: null,
            county: null,
            createdAt: "2024-07-04T07:57:13.000Z",
            details: null,
            dob: null,
            email: null,
            eori: null,
            exhUserId: null,
            firstcontactdate: null,
            firstcontactlocation: null,
            firstcontacttype: null,
            firstUserId: null,
            forename: "",
            greeting: null,
            img: null,
            invoicesLength: 6,
            level: null,
            mailingname: null,
            middlename: null,
            name: " Test",
            notes: null,
            postcode: null,
            prefered: null,
            rating: null,
            sagecode: null,
            salesUserId: null,
            salesUser2Id: null,
            salutation: "Hello",
            siteId: null,
            storageCharge: 0,
            surname: "Test",
            title: null,
            town: null,
            typeId: 3,
            type2Id: null,
            unsubscribed: null,
            updatedAt: "2024-07-04T07:57:13.000Z",
            vat: null,
          },
          contactId: 137370,
          county: null,
          country: null,
          countryId: null,
          currency: {
            __typename: "Currency",
            id: 1,
            code: "GBP",
            description: "Pounds Sterling",
            name: null,
          },
          currencyId: 1,
          date: "2024-08-01",
          debtChase: -1,
          deliveryAddress: "test",
          deliveryAddress2: "test",
          deliveryAddress3: "test",
          deliveryCompany: null,
          deliveryCountryId: null,
          deliveryCounty: null,
          deliveryEmail: null,
          deliveryExpectation: null,
          deliveryHold: null,
          deliveryName: null,
          deliveryPhone: null,
          deliveryPostcode: null,
          deliveryTown: null,
          destinationId: 1,
          dueDate: "2024-09-01",
          items: [
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7099,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267679,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: -2500,
              consigneeSplitRate: 50,
              creditId: 7100,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267680,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: -875,
              typeId: 6,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
            {
              __typename: "Item",
              amount: 5000,
              commission: 0,
              commissionRate: 0,
              consigneeSplit: 2500,
              consigneeSplitRate: 50,
              creditId: null,
              customs: 0,
              date: "2024-08-01",
              description:
                "Runa Islam\nFirst Day of Spring\n2005\nAP 1 / 2\n16mm film\nDuration: 7 minutes\nJJ14461\n",
              discount: 0,
              discountRate: 0,
              id: 267678,
              instanceId: 19605,
              invoiceId: 42721,
              nominalId: 4008,
              price: 5000,
              ref: "JJ14461",
              showDiscount: null,
              sourceId: null,
              tax: 1,
              taxAmount: 875,
              typeId: 8,
              exported: 0,
              artworkDimensions: "Duration: 7 minutes",
              currency: "GBP",
            },
          ],
          exchange: 1,
          immutable: 0,
          invoiceTotals: {
            balance: -5875,
            balance30Days: 0,
            balance60Days: 5875,
            current: 0,
            grossProfit: -2500,
            net: 5000,
            tax: -875,
            total: -5875,
            netExchange: "-5000.00",
          },
          marginRef: null,
          marginScheme: 0,
          name: " Test",
          number: 112751,
          notes: null,
          postcode: null,
          proofdate: null,
          proforma: null,
          purchaserId: null,
          purchaserCountryId: null,
          reference: "JJ",
          registrarId: null,
          shedule: null,
          salesUser: null,
          sagecode: null,
          invoiceSalesPersons: [
            {
              id: 1,
              salesUser: {
                id: 1,
                name: "root",
              },
              salesUserId: 1,
              split: 1.0,
            },
          ],
          taxareaId: 1,
          taxRate: 17.5,
          taxArea: {
            id: 1,
            name: "VAT",
            __typename: "TaxArea",
          },
          town: null,
          terms:
            "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
          termsback:
            "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
          type: {
            __typename: "InvoiceType",
            id: 1,
            description: "Invoice",
          },
          typeId: 1,
          updatedAt: "2024-08-13T10:46:27.000Z",
          user: "fern",
          vatno: null,
        },
        invoiceId: 42721,
        nominal: null,
        nominalId: 4008,
        price: 5000,
        ref: "JJ14461",
        showDiscount: null,
        sourceId: null,
        tax: 1,
        taxAmount: 875,
        type: {
          __typename: "PayType",
          name: "Sale",
          numberId: 8,
          tax: 1,
          updatedAt: "2004-07-06T15:25:58.000Z",
          cd: 1,
        },
        typeId: 8,
        exported: 0,
        artworkDimensions: "Duration: 7 minutes",
        currency: "GBP",
      },
    ],
    exchange: 1,
    immutable: 0,
    invoiceTotals: {
      balance: -5875,
      balance30Days: 0,
      balance60Days: 5875,
      current: 0,
      grossProfit: -2500,
      net: 5000,
      tax: -875,
      total: -5875,
      netExchange: "-5000.00",
    },
    marginRef: null,
    marginScheme: 0,
    name: " Test",
    number: 112751,
    notes: null,
    postcode: null,
    proofdate: null,
    proforma: null,
    purchaserId: null,
    purchaserCountryId: null,
    reference: "JJ",
    registrarId: null,
    shedule: null,
    salesUser: null,
    sagecode: null,
    salesPeople: "tedbundy, jeffreydahmer, johnwaynegacy",
    invoiceSalesPersons: [
      {
        __typename: "InvoiceSalesPerson",
        id: 2,
        salesUser: {
          id: 346,
          name: "tedbundy",
          __typename: "Entity",
        },
        salesUserId: 346,
        typeId: 1,
        invoiceSalesPersonType: {
          id: 1,
          name: "Primary",
          __typename: "InvoiceSalesPersonType",
        },
        split: 0.4,
        timestamp: "2024-08-13T10:46:27.000Z",
      },
      {
        __typename: "InvoiceSalesPerson",
        id: 3,
        salesUser: {
          id: 1,
          name: "jeffreydahmer",
          __typename: "Entity",
        },
        salesUserId: 1,
        typeId: 2,
        invoiceSalesPersonType: {
          id: 2,
          name: "Secondary",
          __typename: "InvoiceSalesPersonType",
        },
        split: 0.3,
        timestamp: "2024-08-13T10:46:27.000Z",
      },
      {
        __typename: "InvoiceSalesPerson",
        id: 5,
        salesUser: {
          id: 7,
          name: "johnwaynegacy",
          __typename: "Entity",
        },
        salesUserId: 7,
        typeId: 2,
        invoiceSalesPersonType: {
          id: 2,
          name: "Secondary",
          __typename: "InvoiceSalesPersonType",
        },
        split: 0.3,
        timestamp: "2024-08-13T10:46:27.000Z",
      },
    ],
    taxareaId: 1,
    taxRate: 17.5,
    taxArea: {
      id: 1,
      name: "VAT",
      __typename: "TaxArea",
    },
    town: null,
    terms:
      "PLEASE QUOTE THE INVOICE NUMBER ON PAYMENT INSTRUCTIONS.\r\nPayment must be made in the currency indicated on the invoice.\r\nPayment must be made by bank transfer within 30 days of the date of this invoice unless otherwise agreed.\r\nPlease note that the Terms and Conditions of Sale are continued on the reverse.",
    termsback:
      "1.The sale is made on the terms in this invoice and those set out in the email confirming sale, all of which form part of the contract.\r\n2.Title to the artwork (the “Work”) does not pass until payment of the Purchase Price has been received in full by White Cube in cleared funds.  \r\n3.White Cube reserves the right to charge interest at 3% over RBS base rate if payments are not received by the due date.\r\n4.The Work must be collected from White Cube’s premises after payment of the Purchase Price has been made in full and at the time and date agreed between White Cube and the purchaser (the “Purchaser”).  \r\n5.If the Purchaser does not collect the Work within 45 days after the Work is made available for delivery, the Purchaser will be liable for the costs of storage from that date until the date of collection.\r\n6.The Purchaser is responsible for shipping and casing costs.  White Cube will obtain a quotation for these on request.  Arranging and paying for condition reporting of the Work at the time of release by White Cube is the responsibility of the Purchaser.\r\n7.From the time and date title passes to the Purchaser, the Purchaser will be responsible for the Work and any maintenance and the risk of damage to it or loss of it will pass to the Purchaser.  The Purchaser must therefore make appropriate arrangements to insure the Work from this time.\r\n8.Whilst White Cube will upon request provide information on the condition of the Work at the time of the sale, White Cube will not be responsible for any subsequent deterioration of the Work, however occasioned, after the sale, though will endeavour to provide advice in response to any enquiries.  The Purchaser shall comply with all instructions in relation to the installation, handling and maintenance of the work which have been given by or on behalf of White Cube.\r\n9.Where goods are being exported, proof of export is required within three months of the date of this invoice.\r\n10.White Cube confirms that it is authorised to sell the Work on behalf of the artist (the “Artist”).\r\n11.No public display of the Work in a commercial manner is to be undertaken by or authorised by the Purchaser without the consent of White Cube and/or the Artist.\r\n12.No copyright or other intellectual property rights in the Work are granted to the Purchaser and the Artist’s moral rights (including the Artist’s right to be identified as author of the Work) are hereby asserted.\r\n13.If the Work is made available for resale on the open market, whether by the Purchaser or via any agent or other third party on behalf of the Purchaser, it must be offered back to White Cube at fair market value; White Cube shall have the right of first refusal to buy back the Work, or to take the Work on exclusive consignment, at fair market value.  Fair market value shall be determined by the White Cube’s retail price for Works of similar scale and significance at the time of resale and/or auction house estimates, if applicable.  This right is to be understood as the right for White Cube to either purchase the Work on its own behalf or, at White Cube’s election, to offer the Work as agent on the Purchaser’s behalf for an agreed period of time to prospective purchasers in return for paying a price to be agreed between the Purchaser and White Cube.\r\n14.White Cube may use the information supplied by the Purchaser (including the Purchaser’s name, address and the Purchase Price) for administrative purposes and may supply that information to the Artist.  White Cube and/or the Artist may use the Purchaser’s details to send the Purchaser information in relation to other Works and events unless the Purchaser notifies White Cube otherwise. \r\n15.If the Work is donated or sold to an institution in the future, the Purchaser agrees to notify White Cube of the donation or sale for provenance purposes.\r\n16.These terms and conditions may only be varied by written agreement between the Purchaser and White Cube.\r\n17.English law shall apply to the whole of these terms and conditions (including any non-contractual obligation related to these terms and conditions).  The Purchaser and White Cube agree as follows in relation to jurisdiction:\r\na.save as specified at paragraph 17(b) below, the English courts shall have exclusive jurisdiction in relation to any dispute arising out of or in connection with these terms and conditions and any legal proceedings in relation thereto and the Purchaser waives any objection to any such proceedings being brought in those courts on the grounds of venue or on the grounds that the proceedings have been brought in an inconvenient forum;\r\nb.for the benefit of White Cube only, White Cube shall have the right to bring proceedings against the Purchaser in any other court which has jurisdiction.",
    type: {
      __typename: "InvoiceType",
      id: 1,
      description: "Invoice",
    },
    typeId: 1,
    updatedAt: "2024-08-13T10:46:27.000Z",
    user: "fern",
    vatno: null,
  },
];

export const exhibitions = [
  {
    __typename: "Exhibition",
    id: 4723,
    artFair: 0,
    contact: {
      id: 111601,
      address: "Unit 2-1, Block 20, Section 3,",
      address2: "Long Hu Shuang Long Yuan Zhu (Land No.5),",
      address3: "Qing Yun Road, Hua Yuan City, Xin Jin District,",
      affiliations: null,
      biography: null,
      collection: null,
      collectionActive: null,
      company: null,
      confidential: 0,
      contactCompany: null,
      contactNumbers: [
        {
          id: 202508,
          donotcall: 0,
          identifier: null,
          number: "puiyin@whitecube.com",
          prefere: -1,
          typeId: 1,
          __typename: "ContactNumber",
        },
        {
          id: 230497,
          donotcall: 0,
          identifier: null,
          number: "13910901773",
          prefere: 0,
          typeId: 7,
          __typename: "ContactNumber",
        },
      ],
      contactSecondary: true,
      countryId: 45,
      country: {
        id: 45,
        continent: "East Asia",
        digraph: "CN",
        name: "China",
        sagecode: 5,
        updatedAt: "2024-03-20T15:34:41.000Z",
        __typename: "Country",
      },
      county: "Sichuan",
      createdAt: "2018-09-18T10:49:46.000Z",
      dateEntered: "2018-09-18T10:49:46.000Z",
      details:
        "CDD - Individual Pui Yin Tong pending\r\nCK\r\n\r\nCDD - Individual Pingyang Liu completed 30/11/2022 DT\r\nPartner of Pui Yin Tong\r\n\r\nName: Pui Yin TONG (唐佩賢)\r\nAddress: Unit 2-1, Block 20, Section 3, Long Hu Shuang Long Yuan Zhu (Land No.5), Qing Yun Road, Hua Yuan City, Xin Lv District, Chengdu, Sichuan\r\n\r\n(四川省成都市 新津区花源镇青云路龙湖双珑原著三期（5号地）20栋2单元-1 )",
      dob: null,
      email: "puiyin@whitecube.com",
      eori: null,
      exhUserId: null,
      firstcontactdate: "2018-09-18",
      firstcontactlocation: null,
      firstcontacttype: 10,
      firstUserId: 922,
      forename: "Pui Yin",
      greeting: null,
      img: null,
      invoicesLength: 2,
      level: 5,
      mailingname: "Pui Yin Tong",
      middlename: null,
      name: "Pui Yin Tong",
      notes: "notes",
      postcode: null,
      prefered: null,
      rating: null,
      sagecode: "TONG",
      salesUserId: 922,
      salesUser2Id: null,
      salutation: "Pui Yin",
      siteId: null,
      storageCharge: 0,
      surname: "Tong",
      title: null,
      town: "Chengdu,",
      typeId: 22,
      type2Id: null,
      unsubscribed: false,
      updatedAt: "2024-11-15T13:27:04.000Z",
      userEntered: "puiyin",
      user: null,
      vat: null,
      __typename: "Contact",
    },
    contactId: 111601,
    curator: "Puiyin and Ting Ting",
    endDate: "2023-11-12T00:00:00.000Z",
    endDay: 12,
    endMonth: 11,
    endYear: 2023,
    exhibitionWorks: [
      {
        artistNames: "Marguerite Humeau\n",
        artworkCat: "Sculpture",
        exhibited: null,
        exhibitionId: 4723,
        id: 56822,
        instance: {
          id: 83320,
          arrApplicable: false,
          artworkId: 199726,
          articheckUrl: null,
          artistNames: "Marguerite Humeau\n",
          artistRef: null,
          artsy: 0,
          bondType: null,
          certificate: null,
          channelEcommerce: 0,
          channelPresentation: 0,
          certificateSent: 0,
          condition: null,
          consignmentPurchase: null,
          createdAt: "2023-05-12T17:30:38.000Z",
          edition: {
            artwork: {
              id: 199726,
              artworkCategory: {
                name: "Sculpture",
                __typename: "ArtworkCategory",
              },
              dimensions: "Dimensions variable ",
              imagesSummary: {
                imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/6/2/t/t199726.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250326%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250326T152635Z&X-Amz-Expires=3600&X-Amz-Signature=7ca66d0ba7a8e7813d51ab537b789440710201e1c0db70dbee6268a6e7c5ac78&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                __typename: "Image",
              },
              medium:
                "Adam Kossowski’s resurrected intelligence, hand-sculpted stoneware tiles, stoneware glazes including wood-ash-based glazes and aluminium",
              series: null,
              title:
                "The History of Old Kent Road (Post-Kossowski) Fragments I–V",
              __typename: "Artwork",
            },
            number: 1,
            year: "2023",
            __typename: "Edition",
          },
          editionNumber: 1,
          editionNumberFormatted: "1/1",
          name: "JJ75013",
          fabricated: 1,
          fabricatedDate: "2023-05-12T17:30:38.000Z",
          forSale: 0,
          framed: 0,
          ipad: 0,
          isBond: false,
          isGuaranteed: false,
          isOnLoan: false,
          isSecondaryMarket: false,
          currentWarehouseMove: {
            id: 4181526,
            bondref: null,
            date: "2023-10-18T09:15:00.000Z",
            goodsCode: null,
            itemId: 1129746,
            locationId: 25,
            locref: "A1-25",
            shipmentId: null,
            siteId: 2,
            taDays: null,
            ti: 0,
            user: "gigi",
            value: 35000,
            confirmed: true,
            location: {
              id: 25,
              description: "West Bund Stand",
              capacity: null,
              siteId: 2,
              __typename: "WarehouseLocation",
            },
            site: {
              id: 2,
              name: "West Bund",
              description: "West Bund",
              updatedAt: "2023-10-18T09:15:00.000Z",
              __typename: "WarehouseSite",
            },
            __typename: "WarehouseMove",
          },
          locationHistory: null,
          ref: 75013,
          company: {
            id: 11,
            name: "White Cube Limited",
            code: "JJ",
            contact: {
              forename: null,
              name: "",
              surname: null,
              __typename: "Contact",
            },
            __typename: "Company",
          },
          market: 0,
          notes: "Preview notes",
          parentOnline: 0,
          reference: "JJ75013",
          returns: 0,
          returnsDirector: 0,
          primaryWarehouseItem: {
            id: 1129746,
            artist: null,
            artistId: null,
            authGroup: null,
            categoryId: 1,
            category: {
              id: 1,
              description: "Fine Art",
              __typename: "WarehouseCategory",
            },
            container: null,
            description: "Packed sculpture",
            destroyed: 0,
            dimh: 175,
            dimw: 52,
            dimd: 34,
            externalRef: null,
            image: null,
            instanceId: 83320,
            itemDescription: "Packed sculpture",
            itemSite: {
              id: 4181526,
              itemId: 1129746,
              locationId: 25,
              siteId: 2,
              location: {
                id: 25,
                description: "West Bund Stand",
                capacity: null,
                siteId: 2,
                __typename: "WarehouseLocation",
              },
              site: {
                id: 2,
                name: "West Bund",
                description: "West Bund",
                updatedAt: "2023-10-18T09:15:00.000Z",
                __typename: "WarehouseSite",
              },
              __typename: "WarehouseMove",
            },
            link: null,
            mgroup: 1,
            notes: "Packed for fair",
            packing: {
              id: 4,
              description: "Museum crate",
              updatedAt: "2023-10-01T12:00:00.000Z",
              __typename: "WarehousePacking",
            },
            packingId: 4,
            responsibleGroupId: null,
            warehouseMoves: [
              {
                id: 4181526,
                bondref: null,
                date: "2023-10-18T09:15:00.000Z",
                goodsCode: null,
                itemId: 1129746,
                locationId: 25,
                locref: "A1-25",
                shipmentId: null,
                siteId: 2,
                taDays: null,
                ti: 0,
                user: "gigi",
                value: 35000,
                confirmed: true,
                location: {
                  id: 25,
                  description: "West Bund Stand",
                  capacity: null,
                  siteId: 2,
                  __typename: "WarehouseLocation",
                },
                site: {
                  id: 2,
                  name: "West Bund",
                  description: "West Bund",
                  updatedAt: "2023-10-18T09:15:00.000Z",
                  __typename: "WarehouseSite",
                },
                __typename: "WarehouseMove",
              },
            ],
            weight: 350,
            weightType: null,
            weightTypeId: null,
            __typename: "WarehouseItem",
          },
          salePrice: null,
          salesStrategy: null,
          description:
            "Marguerite Humeau\nThe History of Old Kent Road (Post-Kossowski) Fragments I–V\n2023\nAdam Kossowski’s resurrected intelligence, hand-sculpted stoneware tiles, stoneware glazes including wood-ash-based glazes and aluminium\nDimensions variable\nJJ75013",
          location: "West Bund Stand",
          status: {
            name: "Allocated",
            __typename: "Status",
          },
          statusId: null,
          statusUndo: 0,
          statusHistory: null,
          unpackedWeight: null,
          updatedAt: "2023-10-18T09:15:00.000Z",
          value: {
            currency: {
              code: "GBP",
              __typename: "Currency",
            },
            value: 35000,
            __typename: "Value",
          },
          volume: 309400,
          weight: "350kg",
          warehouseItemId: 1129746,
          warehouseItem: [
            {
              id: 1129746,
              artist: null,
              artistId: null,
              authGroup: null,
              categoryId: 1,
              category: {
                id: 1,
                description: "Fine Art",
                __typename: "WarehouseCategory",
              },
              container: null,
              description: "Packed sculpture",
              destroyed: 0,
              dimh: 175,
              dimw: 52,
              dimd: 34,
              externalRef: null,
              image: null,
              instanceId: 83320,
              itemDescription: "Packed sculpture",
              itemSite: {
                id: 4181526,
                itemId: 1129746,
                locationId: 25,
                siteId: 2,
                location: {
                  id: 25,
                  description: "West Bund Stand",
                  capacity: null,
                  siteId: 2,
                  __typename: "WarehouseLocation",
                },
                site: {
                  id: 2,
                  name: "West Bund",
                  description: "West Bund",
                  updatedAt: "2023-10-18T09:15:00.000Z",
                  __typename: "WarehouseSite",
                },
                __typename: "WarehouseMove",
              },
              link: null,
              mgroup: 1,
              notes: "Packed for fair",
              packing: {
                id: 4,
                description: "Museum crate",
                updatedAt: "2023-10-01T12:00:00.000Z",
                __typename: "WarehousePacking",
              },
              packingId: 4,
              responsibleGroupId: null,
              warehouseMoves: [
                {
                  id: 4181526,
                  bondref: null,
                  date: "2023-10-18T09:15:00.000Z",
                  goodsCode: null,
                  itemId: 1129746,
                  locationId: 25,
                  locref: "A1-25",
                  shipmentId: null,
                  siteId: 2,
                  taDays: null,
                  ti: 0,
                  user: "gigi",
                  value: 35000,
                  confirmed: true,
                  location: {
                    id: 25,
                    description: "West Bund Stand",
                    capacity: null,
                    siteId: 2,
                    __typename: "WarehouseLocation",
                  },
                  site: {
                    id: 2,
                    name: "West Bund",
                    description: "West Bund",
                    updatedAt: "2023-10-18T09:15:00.000Z",
                    __typename: "WarehouseSite",
                  },
                  __typename: "WarehouseMove",
                },
              ],
              weight: 350,
              weightType: null,
              weightTypeId: null,
              __typename: "WarehouseItem",
            },
          ],
          __typename: "Instance",
        },
        instanceId: 83320,
        notes: "notes",
        offer: [
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
        ],
        removed: 0,
        technicalNotes: "Technical notes",
        technicalnotes: "Technical notes",
        updatedAt: "2023-06-02T15:55:01.000Z",
        user: "gigi",
        __typename: "ExhibitionWork",
      },
      {
        artistNames: null,
        artworkCat: null,
        exhibited: null,
        exhibitionId: 4723,
        id: 56823,
        instance: {
          id: 83599,
          artistNames: "Marguerite Humeau\n",
          bondType: null,
          edition: {
            artwork: {
              artworkCategory: {
                name: "Sculpture",
                __typename: "ArtworkCategory",
              },
              dimensions: "Dimensions variable ",
              imagesSummary: {
                imgT: "https://wc-dev-app.s3.eu-west-2.amazonaws.com/array/0/4/t/t199740.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAX7WBRWTWKY6ZL3VE%2F20250326%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250326T152635Z&X-Amz-Expires=3600&X-Amz-Signature=b96cc35752c006a5adbe5652c2bfe9da2ae56c073d3088afc19f6549b5477d0c&X-Amz-SignedHeaders=host&response-cache-control=public%2C%20no-cache%2C%20immutable&x-id=GetObject",
                __typename: "Image",
              },
              medium:
                "Adam Kossowski’s resurrected intelligence, hand-sculpted stoneware tiles, stoneware glazes including wood-ash-based glazes and aluminium",
              series: null,
              title:
                "The History of Old Kent Road (Post-Kossowski) Fragments VIII–3 and VIII–4",
              __typename: "Artwork",
            },
            number: 1,
            year: "2023",
            __typename: "Edition",
          },
          editionNumber: 1,
          name: "JJ75256",
          ref: 75256,
          company: {
            id: 11,
            name: "White Cube Limited",
            code: "JJ",
            contact: {
              forename: null,
              name: "",
              surname: null,
              __typename: "Contact",
            },
            __typename: "Company",
          },
          description:
            "Marguerite Humeau\nThe History of Old Kent Road (Post-Kossowski) Fragments VIII–3 and VIII–4\n2023\nAdam Kossowski’s resurrected intelligence, hand-sculpted stoneware tiles, stoneware glazes including wood-ash-based glazes and aluminium\nDimensions variable\nJJ75256",
          status: {
            name: "Allocated",
            __typename: "Status",
          },
          value: {
            currency: {
              code: "GBP",
              __typename: "Currency",
            },
            value: 50000,
            __typename: "Value",
          },
          __typename: "Instance",
        },
        instanceId: 83599,
        notes: "notes",
        offer: [
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
        ],
        removed: 0,
        technicalnotes: "Technical notes",
        updatedAt: "2023-06-02T15:55:20.000Z",
        user: "gigi",
        __typename: "ExhibitionWork",
      },
      {
        artistNames: null,
        artworkCat: null,
        exhibited: null,
        exhibitionId: 4723,
        id: 56827,
        instance: {
          id: 83304,
          artistNames: "Bram Bogart\n",
          bondType: null,
          edition: {
            artwork: {
              artworkCategory: {
                name: "Painting",
                __typename: "ArtworkCategory",
              },
              dimensions: "22 1/16 x 22 7/16 in. | (56 x 57 cm) ",
              imagesSummary: {
                imgT: null,
                __typename: "Image",
              },
              medium: "Wooden glass",
              series: null,
              title: "Blok in geel",
              __typename: "Artwork",
            },
            number: 1,
            year: "1971",
            __typename: "Edition",
          },
          editionNumber: 1,
          name: "JJ74998",
          ref: 74998,
          company: {
            id: 11,
            name: "White Cube Limited",
            code: "JJ",
            contact: {
              forename: null,
              name: "",
              surname: null,
              __typename: "Contact",
            },
            __typename: "Company",
          },
          description:
            "Bram Bogart\nBlok in geel\n1971\nWooden glass\n22 1/16 x 22 7/16 in. (56 x 57 cm)\nJJ74998",
          status: {
            name: "Null",
            __typename: "Status",
          },
          value: null,
          __typename: "Instance",
        },
        instanceId: 83304,
        notes: "null",
        offer: [
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
          {
            id: 608687,
            contact: {
              forename: "Thomas and Lynn",
              surname: "Ou",
              name: "Thomas and Lynn Ou",
              __typename: "Contact",
            },
            contactId: 51181,
            hold: {
              name: "JJ74435",
              ref: 74435,
              description:
                "Antony Gormley\nOPEN ADJUST\n2022\n8 mm Corten steel\n68 7/8 x 20 1/2 x 13 3/8 in. (175 x 52 x 34 cm)\nJJ74435",
              notes:
                "\r\n\r\nindoor only AJ 06.01.2022\r\n\r\n**correct eta of shipment (89101) should be 27/03/2023 - KK(14.02.2023)\r\n\r\nLate shipment for ABHK 2023.\r\n\r\nAG's approval is required for the release. 16/02/2023 GS",
              __typename: "Instance",
            },
            holdId: 82664,
            holdDate: "2023-03-23T10:47:50.000Z",
            status: {
              description: "Pending",
              __typename: "OfferStatus",
            },
            statusId: 1,
            user: "jay",
            __typename: "Offer",
          },
        ],
        removed: 0,
        technicalnotes: "Technical notes",
        updatedAt: "2023-06-05T11:28:32.000Z",
        user: "cosima",
        __typename: "ExhibitionWork",
      },
    ],
    fullDate: "9/11/2023 - 12/11/2023",
    notes: "Reservation list: 4760",
    sageCode: "ARTFAIR-WEST-\r\nARTFAIR-WEST-23",
    startDate: "2023-11-09T00:00:00.000Z",
    startDay: 9,
    startMonth: 11,
    startYear: 2023,
    title: "West Bund 2023",
    type: "Artfair",
    updatedAt: "2023-06-02T16:02:53.000Z",
  },
];
